interface Translation {
  [key: string]: string;
}

export const translateStatistics: Translation = {
  Afrikaans: 'Statistiek',
  Amharic: 'ስታቲስቲክስ',
  Arabic: 'إحصائيات',
  Armenian: 'Վիճակագրություն',
  Azerbaijani: 'Statistika',
  Belarusian: 'Статыстыка',
  Bengali: 'পরিসংখ্যান',
  Bosnian: 'Statistika',
  Bulgarian: 'Статистика',
  Cantonese: '統計',
  Catalan: 'Estadístiques',
  Chinese: '统计',
  'Chinese (Traditional)': '統計',
  Croatian: 'Statistika',
  Czech: 'Statistiky',
  Danish: 'Statistik',
  Dutch: 'Statistieken',
  English: 'Statistics',
  Estonian: 'Statistika',
  Finnish: 'Tilastot',
  French: 'Statistiques',
  Galician: 'Estatísticas',
  Georgian: 'სტატისტიკა',
  German: 'Statistiken',
  Greek: 'Στατιστικά',
  Hebrew: 'סטטיסטיקות',
  Hindi: 'सांख्यिकी',
  Hungarian: 'Statisztika',
  Icelandic: 'Tölfræði',
  Indonesian: 'Statistik',
  Italian: 'Statistiche',
  Japanese: '統計',
  Kannada: 'ಸಂಖ್ಯಾಶಾಸ್ತ್ರ',
  Kazakh: 'Статистика',
  Korean: '통계',
  Latvian: 'Statistika',
  Lithuanian: 'Statistika',
  Macedonian: 'Статистика',
  Malay: 'Statistik',
  Maori: 'Tauanga',
  Marathi: 'सांख्यिकी',
  Nepali: 'तथ्याङ्क',
  Norwegian: 'Statistikk',
  Panjabi: 'ਅੰਕੜੇ',
  Punjabi: 'ਅੰਕੜੇ',
  Persian: 'آمار',
  Polish: 'Statystyki',
  Portuguese: 'Estatísticas',
  Romanian: 'Statistică',
  Russian: 'Статистика',
  Serbian: 'Статистика',
  Slovak: 'Štatistika',
  Slovenian: 'Statistika',
  Spanish: 'Estadísticas',
  Swahili: 'Takwimu',
  Swedish: 'Statistik',
  Tagalog: 'Estadistika',
  Tamil: 'புள்ளிவிவரம்',
  Telugu: 'గణాంకాలు',
  Thai: 'สถิติ',
  Turkish: 'İstatistikler',
  Ukrainian: 'Статистика',
  Urdu: 'اعداد و شمار',
  Uzbek: 'Statistika',
  Vietnamese: 'Thống kê',
  Welsh: 'Ystadegau',
};

export const translateTotal: Translation = {
  Afrikaans: 'Totaal',
  Amharic: 'ጠቅላላ',
  Arabic: 'المجموع',
  Armenian: 'Ընդհանուր',
  Azerbaijani: 'Ümumi',
  Belarusian: 'Усяго',
  Bengali: 'মোট',
  Bosnian: 'Ukupno',
  Bulgarian: 'Общо',
  Cantonese: '總計',
  Catalan: 'Total',
  Chinese: '总',
  'Chinese (Traditional)': '總計',
  Croatian: 'Ukupno',
  Czech: 'Celkem',
  Danish: 'Total',
  Dutch: 'Totaal',
  English: 'Total',
  Estonian: 'Kokku',
  Finnish: 'Yhteensä',
  French: 'Total',
  Galician: 'Total',
  Georgian: 'სულ',
  German: 'Gesamt',
  Greek: 'Σύνολο',
  Hebrew: 'סה"כ',
  Hindi: 'कुल',
  Hungarian: 'Teljes',
  Icelandic: 'Heildar',
  Indonesian: 'Total',
  Italian: 'Totale',
  Japanese: '合計',
  Kannada: 'ಒಟ್ಟು',
  Kazakh: 'Жалпы',
  Korean: '합계',
  Latvian: 'Kopā',
  Lithuanian: 'Iš viso',
  Macedonian: 'Вкупно',
  Malay: 'Jumlah',
  Maori: 'Te Katoa',
  Marathi: 'एकूण',
  Nepali: 'जम्मा',
  Norwegian: 'Totalt',
  Panjabi: 'ਕੁੱਲ',
  Punjabi: 'ਕੁੱਲ',
  Persian: 'کل',
  Polish: 'Suma',
  Portuguese: 'Total',
  Romanian: 'Total',
  Russian: 'Всего',
  Serbian: 'Укупно',
  Slovak: 'Celkom',
  Slovenian: 'Skupaj',
  Spanish: 'Total',
  Swahili: 'Jumla',
  Swedish: 'Totalt',
  Tagalog: 'Kabuuan',
  Tamil: 'மொத்தம்',
  Telugu: 'మొత్తం',
  Thai: 'รวม',
  Turkish: 'Toplam',
  Ukrainian: 'Всього',
  Urdu: 'کل',
  Uzbek: 'Jami',
  Vietnamese: 'Tổng cộng',
  Welsh: 'Cyfanswm',
};

export const translateCompletedInterviews: Translation = {
  Afrikaans: 'Voltooide onderhoude',
  Amharic: 'የተጠናቀቁ ቃለ-መጠይቆች',
  Arabic: 'المقابلات المكتملة',
  Armenian: 'Ավարտված հարցումներ',
  Azerbaijani: 'Tamamlanmış mülakatlar',
  Belarusian: "Завершаныя інтэрв'ю",
  Bengali: 'সম্পন্ন সাক্ষাৎকার',
  Bosnian: 'Završeni intervjui',
  Bulgarian: 'Завършени интервюта',
  Cantonese: '已完成的訪談',
  Catalan: 'Entrevistes completades',
  Chinese: '已完成的面试',
  'Chinese (Traditional)': '已完成的訪談',
  Croatian: 'Završeni razgovori',
  Czech: 'Dokončené rozhovory',
  Danish: 'Afsluttede interviews',
  Dutch: 'Voltooide interviews',
  English: 'Completed interviews',
  Estonian: 'Lõpetatud intervjuud',
  Finnish: 'Valmiit haastattelut',
  French: 'Entretiens terminés',
  Galician: 'Entrevistas completadas',
  Georgian: 'დასრულებული ინტერვიუები',
  German: 'Abgeschlossene Interviews',
  Greek: 'Ολοκληρωμένες συνεντεύξεις',
  Hebrew: 'ראיונות הושלמו',
  Hindi: 'पूर्ण किए गए साक्षात्कार',
  Hungarian: 'Befejezett interjúk',
  Icelandic: 'Lokið viðtöl',
  Indonesian: 'Wawancara Selesai',
  Italian: 'Interviste completate',
  Japanese: '完了した面接',
  Kannada: 'ಪೂರ್ಣಗೊಂಡ ಸಂವಾದಗಳು',
  Kazakh: 'Жүргізілген интервьюлар',
  Korean: '완료된 인터뷰',
  Latvian: 'Pabeigtās intervijas',
  Lithuanian: 'Baigti interviu',
  Macedonian: 'Завршени интервјуа',
  Malay: 'Wawancara Selesai',
  Maori: 'Ngā mahi haere kē',
  Marathi: 'पूर्ण केलेले मुलाखत',
  Nepali: 'सम्पन्न अन्तर्वार्ताहरू',
  Norwegian: 'Fullførte intervjuer',
  Panjabi: 'ਮੁਕੰਮਲ ਇੰਟਰਵਿਊ',
  Punjabi: 'ਮੁਕੰਮਲ ਇੰਟਰਵਿਊ',
  Persian: 'مصاحبه های تکمیل شده',
  Polish: 'Zakończone wywiady',
  Portuguese: 'Entrevistas concluídas',
  Romanian: 'Interviuri completate',
  Russian: 'Завершенные интервью',
  Serbian: 'Завршени интервјуи',
  Slovak: 'Dokončené pohovory',
  Slovenian: 'Končani pogovori',
  Spanish: 'Entrevistas completadas',
  Swahili: 'Mahojiano yaliyokamilika',
  Swedish: 'Avslutade intervjuer',
  Tagalog: 'Natapos na mga panayam',
  Tamil: 'முடிந்த பேட்டிகள்',
  Telugu: 'పూర్తయిన ఇంటర్వ్యూలు',
  Thai: 'สัมภาษณ์เสร็จสมบูรณ์',
  Turkish: 'Tamamlanan mülakatlar',
  Ukrainian: "Завершені інтерв'ю",
  Urdu: 'مکمل انٹرویوز',
  Uzbek: 'Yakunlangan suhbatlar',
  Vietnamese: 'Các cuộc phỏng vấn đã hoàn thành',
  Welsh: 'Cyfweliadau wedi eu cwblhau',
};

export const translateInterviewsInProgress: Translation = {
  Afrikaans: 'Onderhoude aan die gang',
  Amharic: 'በሂደት ላይ ያሉ ቃለ-መጠይቆች',
  Arabic: 'المقابلات الجارية',
  Armenian: 'Հարցազրույցներ ընթացքի մեջ',
  Azerbaijani: 'Müsahibələr davam edir',
  Belarusian: "Інтэрв'ю ў працэсе",
  Bengali: 'চলমান সাক্ষাৎকার',
  Bosnian: 'Intervjui u toku',
  Bulgarian: 'Интервюта в ход',
  Cantonese: '進行中的訪談',
  Catalan: 'Entrevistes en curs',
  Chinese: '进行中的面试',
  'Chinese (Traditional)': '進行中的訪談',
  Croatian: 'Intervjui u tijeku',
  Czech: 'Rozhovory v průběhu',
  Danish: 'Interviews i gang',
  Dutch: 'Interviews in uitvoering',
  English: 'Interviews in Progress',
  Estonian: 'Käimasolevad intervjuud',
  Finnish: 'Haastattelut käynnissä',
  French: 'Entretiens en cours',
  Galician: 'Entrevistas en progreso',
  Georgian: 'მიმდინარე ინტერვიუები',
  German: 'Interviews im Gange',
  Greek: 'Συνεντεύξεις σε εξέλιξη',
  Hebrew: 'ראיונות בתהליך',
  Hindi: 'चल रहे साक्षात्कार',
  Hungarian: 'Folyamatban lévő interjúk',
  Icelandic: 'Viðtöl í vinnslu',
  Indonesian: 'Wawancara Sedang Berlangsung',
  Italian: 'Interviste in corso',
  Japanese: '進行中の面接',
  Kannada: 'ಪ್ರಗತಿಯಲ್ಲಿರುವ ಸಂದರ್ಶನಗಳು',
  Kazakh: 'Өтіп жатқан сұхбаттар',
  Korean: '진행 중인 인터뷰',
  Latvian: 'Notiekošās intervijas',
  Lithuanian: 'Vykstantys interviu',
  Macedonian: 'Интервјуа во тек',
  Malay: 'Wawancara Sedang Berlangsung',
  Maori: 'Ngā whakawhiti kōrero kei te haere',
  Marathi: 'प्रगतीपथावरील मुलाखती',
  Nepali: 'प्रगतिमा रहेका अन्तर्वार्ताहरू',
  Norwegian: 'Intervjuer pågår',
  Panjabi: 'ਚੱਲ ਰਹੀਆਂ ਇੰਟਰਵਿਊ',
  Punjabi: 'ਚੱਲ ਰਹੀਆਂ ਇੰਟਰਵਿਊ',
  Persian: 'مصاحبه‌های در حال انجام',
  Polish: 'Wywiady w toku',
  Portuguese: 'Entrevistas em andamento',
  Romanian: 'Interviuri în desfășurare',
  Russian: 'Интервью в процессе',
  Serbian: 'Интервјуи у току',
  Slovak: 'Rozhovory v priebehu',
  Slovenian: 'Intervjuji v teku',
  Spanish: 'Entrevistas en progreso',
  Swahili: 'Mahojiano Yanaendelea',
  Swedish: 'Intervjuer pågår',
  Tagalog: 'Mga panayam na nasa proseso',
  Tamil: 'நடந்து கொண்டிருக்கும் பேட்டிகள்',
  Telugu: 'జరుగుతున్న ఇంటర్వ్యూలు',
  Thai: 'การสัมภาษณ์กำลังดำเนินอยู่',
  Turkish: 'Devam eden mülakatlar',
  Ukrainian: "Інтерв'ю у процесі",
  Urdu: 'انٹرویوز جاری ہیں',
  Uzbek: 'Jarayondagi suhbatlar',
  Vietnamese: 'Các cuộc phỏng vấn đang diễn ra',
  Welsh: 'Cyfweliadau yn y broses',
};

export const translateCompletionRate: Translation = {
  Afrikaans: 'Voltooiingsyfer',
  Amharic: 'የማጠናቀቂያ መጠን',
  Arabic: 'معدل الإنجاز',
  Armenian: 'Ավարտման տոկոսադրույքը',
  Azerbaijani: 'Tamamlama dərəcəsi',
  Belarusian: 'Хуткасць выканання',
  Bengali: 'সম্পন্নের হার',
  Bosnian: 'Stopa završetka',
  Bulgarian: 'Степен на завършване',
  Cantonese: '完成率',
  Catalan: 'Taxa de finalització',
  Chinese: '完成率',
  'Chinese (Traditional)': '完成率',
  Croatian: 'Stopa završetka',
  Czech: 'Míra dokončení',
  Danish: 'Gennemførelsesgrad',
  Dutch: 'Voltooiingspercentage',
  English: 'Completion rate',
  Estonian: 'Täitmise määr',
  Finnish: 'Valmistumisaste',
  French: 'Taux de complétion',
  Galician: 'Taxa de realización',
  Georgian: 'დასრულების მაჩვენებელი',
  German: 'Abschlussquote',
  Greek: 'Ποσοστό ολοκλήρωσης',
  Hebrew: 'שיעור השלמה',
  Hindi: 'समापन दर',
  Hungarian: 'Teljesítési arány',
  Icelandic: 'Fullnaðarhlutfall',
  Indonesian: 'Tingkat penyelesaian',
  Italian: 'Tasso di completamento',
  Japanese: '完了率',
  Kannada: 'ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಯ ಪ್ರಮಾಣ',
  Kazakh: 'Аяқтау жылдамдығы',
  Korean: '진척률',
  Latvian: 'Pabeigšanas rādītājs',
  Lithuanian: 'Užbaigimo rodiklis',
  Macedonian: 'Стапка на завршување',
  Malay: 'Kadar penyiapan',
  Maori: 'Reeti whakaotinga',
  Marathi: 'पूर्ण होण्याचा दर',
  Nepali: 'पूर्णता दर',
  Norwegian: 'Fullføringsprosent',
  Panjabi: 'ਮੁਕੰਮਲ ਹੋਣ ਦੀ ਦਰ',
  Punjabi: 'ਮੁਕੰਮਲ ਹੋਣ ਦੀ ਦਰ',
  Persian: 'نرخ تکمیل',
  Polish: 'Stopień ukończenia',
  Portuguese: 'Taxa de realização',
  Romanian: 'Rata de finalizare',
  Russian: 'Скорость завершения',
  Serbian: 'Стопа завршавања',
  Slovak: 'Miera dokončenia',
  Slovenian: 'Stopnja dokončanja',
  Spanish: 'Tasa de finalización',
  Swahili: 'Kiwango cha kukamilika',
  Swedish: 'Färdigställandegrad',
  Tagalog: 'Rate ng pagkumpleto',
  Tamil: 'நிறைவு விகிதம்',
  Telugu: 'పూర్తి రేటు',
  Thai: 'อัตราความสำเร็จ',
  Turkish: 'Tamamlama oranı',
  Ukrainian: 'Швидкість виконання',
  Urdu: 'تکمیل کی شرح',
  Uzbek: 'Yakunlash darajasi',
  Vietnamese: 'Tỷ lệ hoàn thành',
  Welsh: 'Cyfradd cwblhau',
};

export const translateAvgTimeToCompletion: Translation = {
  Afrikaans: 'Gem. tyd tot voltooiing',
  Amharic: 'እስከ መጠናቀቂያ ድረስ ያለ አማካይ ጊዜ',
  Arabic: 'متوسط الوقت حتى الانتهاء',
  Armenian: 'Ավարտի միջին ժամանակ',
  Azerbaijani: 'Başa çatmağa orta vaxt',
  Belarusian: 'Сярэдні час да завяршэння',
  Bengali: 'সম্পন্ন হতে গড় সময়',
  Bosnian: 'Prosječno vrijeme do završetka',
  Bulgarian: 'Средно време за завършване',
  Cantonese: '平均完成時間',
  Catalan: 'Temps mitjà de finalització',
  Chinese: '平均完成时间',
  'Chinese (Traditional)': '平均完成時間',
  Croatian: 'Prosječno vrijeme do završetka',
  Czech: 'Průměrný čas do dokončení',
  Danish: 'Gns. tid til afslutning',
  Dutch: 'Gem. tijd tot voltooiing',
  English: 'Avg. time to completion',
  Estonian: 'Keskmine aeg lõpetamiseni',
  Finnish: 'Keskimääräinen aika valmistumiseen',
  French: 'Temps moyen de complétion',
  Galician: 'Tempo medio de finalización',
  Georgian: 'დასრულებამდე საშუალო დრო',
  German: 'Durchschnittliche Zeit bis zur Fertigstellung',
  Greek: 'Μέσος χρόνος ολοκλήρωσης',
  Hebrew: 'זמן ממוצע עד השלמה',
  Hindi: 'पूरा होने तक का औसत समय',
  Hungarian: 'Átlagos idő a befejezésig',
  Icelandic: 'Meðaltími til lokunar',
  Indonesian: 'Rata-rata waktu hingga selesai',
  Italian: 'Tempo medio per il completamento',
  Japanese: '完了までの平均時間',
  Kannada: 'ಪೂರ್ತಿಗೆ ಸಮಯದ ಸರಾಸರಿ',
  Kazakh: 'Жақтығына дейінгі ортақ уақыт',
  Korean: '평균 완료 시간',
  Latvian: 'Vidējais laiks līdz pabeigšanai',
  Lithuanian: 'Vidutinis laikas iki užbaigimo',
  Macedonian: 'Просечно време до завршување',
  Malay: 'Purata masa hingga penyelesaian',
  Maori: 'Wā o te wā o te whakakapia',
  Marathi: 'पूर्णता पर्यंतचा सरासरी वेळ',
  Nepali: 'पूर्ण हुन लाग्ने औसत समय',
  Norwegian: 'Gjennomsnittlig tid til fullføring',
  Panjabi: 'ਮੁਕੰਮਲਤਾ ਤੱਕ ਔਸਤ ਸਮਾਂ',
  Punjabi: 'ਮੁਕੰਮਲਤਾ ਤੱਕ ਔਸਤ ਸਮਾਂ',
  Persian: 'متوسط زمان تا پایان',
  Polish: 'Średni czas do zakończenia',
  Portuguese: 'Tempo médio para conclusão',
  Romanian: 'Timp mediu până la finalizare',
  Russian: 'Среднее время до завершения',
  Serbian: 'Процењено време до завршетка',
  Slovak: 'Priemerný čas do dokončenia',
  Slovenian: 'Povprečni čas do konca',
  Spanish: 'Tiempo promedio de finalización',
  Swahili: 'Wakati wa wastani wa kumaliza',
  Swedish: 'Genomsnittlig tid till avslut',
  Tagalog: 'Avg. oras hanggang matapos',
  Tamil: 'முடிப்புக்கு சராசரி நேரம்',
  Telugu: 'పూర్తి చేయడానికి సగటు సమయం',
  Thai: 'เวลาเฉลี่ยถึงเสร็จสิ้น',
  Turkish: 'Tamamlanma süresinin ortalama zamanı',
  Ukrainian: 'Середній час до завершення',
  Urdu: 'مکمل ہونے کا اوسط وقت',
  Uzbek: "Yakunlashgacha o'rtacha vaqt",
  Vietnamese: 'Thời gian trung bình đến hoàn thành',
  Welsh: 'Amser cyfartalog i gwblhau',
};

export const translateMedianTime: Translation = {
  Afrikaans: 'Mediaan',
  Amharic: 'መካከለኛ',
  Arabic: 'وسيط',
  Armenian: 'Մեդիան',
  Azerbaijani: 'Median',
  Belarusian: 'Медыяна',
  Bengali: 'মধ্যমান',
  Bosnian: 'Median',
  Bulgarian: 'Медиана',
  Cantonese: '中位數',
  Catalan: 'Mediana',
  Chinese: '中位数',
  'Chinese (Traditional)': '中位數',
  Croatian: 'Medijan',
  Czech: 'Medián',
  Danish: 'Median',
  Dutch: 'Mediaan',
  English: 'Median',
  Estonian: 'Mediaan',
  Finnish: 'Mediaani',
  French: 'Médiane',
  Galician: 'Mediana',
  Georgian: 'მედიანა',
  German: 'Median',
  Greek: 'Διάμεσος',
  Hebrew: 'חציון',
  Hindi: 'मध्यिका',
  Hungarian: 'Medián',
  Icelandic: 'Miðgildi',
  Indonesian: 'Median',
  Italian: 'Mediana',
  Japanese: '中央値',
  Kannada: 'ಮಧ್ಯಗತ',
  Kazakh: 'Медиана',
  Korean: '중앙값',
  Latvian: 'Mediāna',
  Lithuanian: 'Mediana',
  Macedonian: 'Медијана',
  Malay: 'Median',
  Maori: 'Takawaenga',
  Marathi: 'मध्यगा',
  Nepali: 'मध्यमान',
  Norwegian: 'Median',
  Panjabi: 'ਮੱਧਮਾਨ',
  Punjabi: 'ਮੱਧਮਾਨ',
  Persian: 'میانه',
  Polish: 'Mediana',
  Portuguese: 'Mediana',
  Romanian: 'Mediană',
  Russian: 'Медиана',
  Serbian: 'Медијана',
  Slovak: 'Medián',
  Slovenian: 'Mediana',
  Spanish: 'Mediana',
  Swahili: 'Wastani',
  Swedish: 'Median',
  Tagalog: 'Median',
  Tamil: 'இடைநிலை',
  Telugu: 'మధ్యగతం',
  Thai: 'มัธยฐาน',
  Turkish: 'Medyan',
  Ukrainian: 'Медіана',
  Urdu: 'وسط',
  Uzbek: 'Mediana',
  Vietnamese: 'Trung vị',
  Welsh: 'Canolrif',
};

export const translateAverageTime: Translation = {
  Afrikaans: 'Gemiddelde',
  Amharic: 'አማካይ',
  Arabic: 'متوسط',
  Armenian: 'Միջին',
  Azerbaijani: 'Orta',
  Belarusian: 'Сярэдняе',
  Bengali: 'গড়',
  Bosnian: 'Prosjek',
  Bulgarian: 'Средно',
  Cantonese: '平均',
  Catalan: 'Mitjana',
  Chinese: '平均',
  'Chinese (Traditional)': '平均',
  Croatian: 'Prosjek',
  Czech: 'Průměr',
  Danish: 'Gennemsnit',
  Dutch: 'Gemiddelde',
  English: 'Average',
  Estonian: 'Keskmine',
  Finnish: 'Keskiarvo',
  French: 'Moyenne',
  Galician: 'Media',
  Georgian: 'საშუალო',
  German: 'Durchschnitt',
  Greek: 'Μέσος όρος',
  Hebrew: 'ממוצע',
  Hindi: 'औसत',
  Hungarian: 'Átlag',
  Icelandic: 'Meðaltal',
  Indonesian: 'Rata-rata',
  Italian: 'Media',
  Japanese: '平均',
  Kannada: 'ಸರಾಸರಿ',
  Kazakh: 'Орташа',
  Korean: '평균',
  Latvian: 'Vidējais',
  Lithuanian: 'Vidurkis',
  Macedonian: 'Просек',
  Malay: 'Purata',
  Maori: 'Tautuhi',
  Marathi: 'सरासरी',
  Nepali: 'औसत',
  Norwegian: 'Gjennomsnitt',
  Panjabi: 'ਔਸਤ',
  Punjabi: 'ਔਸਤ',
  Persian: 'میانگین',
  Polish: 'Średnia',
  Portuguese: 'Média',
  Romanian: 'Medie',
  Russian: 'Среднее',
  Serbian: 'Просек',
  Slovak: 'Priemer',
  Slovenian: 'Povprečje',
  Spanish: 'Promedio',
  Swahili: 'Wastani',
  Swedish: 'Genomsnitt',
  Tagalog: 'Average',
  Tamil: 'சராசரி',
  Telugu: 'సగటు',
  Thai: 'เฉลี่ย',
  Turkish: 'Ortalama',
  Ukrainian: 'Середнє',
  Urdu: 'اوسط',
  Uzbek: "O'rtacha",
  Vietnamese: 'Trung bình',
  Welsh: 'Cyfartaledd',
};

export const translateTimeToCompletion: Translation = {
  Afrikaans: 'Tyd tot voltooiing',
  Amharic: 'እስከ መጠናቀቂያ ድረስ ጊዜ',
  Arabic: 'الوقت حتى الانتهاء',
  Armenian: 'Ավարտի ժամանակ',
  Azerbaijani: 'Başa çatma vaxtı',
  Belarusian: 'Час да завяршэння',
  Bengali: 'সম্পন্ন হতে সময়',
  Bosnian: 'Vrijeme do završetka',
  Bulgarian: 'Време за завършване',
  Cantonese: '完成時間',
  Catalan: 'Temps de finalització',
  Chinese: '完成时间',
  'Chinese (Traditional)': '完成時間',
  Croatian: 'Vrijeme do završetka',
  Czech: 'Čas do dokončení',
  Danish: 'Tid til afslutning',
  Dutch: 'Tijd tot voltooiing',
  English: 'Time to completion',
  Estonian: 'Aeg lõpetamiseni',
  Finnish: 'Aika valmistumiseen',
  French: 'Temps de complétion',
  Galician: 'Tempo de finalización',
  Georgian: 'დასრულებამდე დრო',
  German: 'Zeit bis zur Fertigstellung',
  Greek: 'Χρόνος ολοκλήρωσης',
  Hebrew: 'זמן עד השלמה',
  Hindi: 'पूरा होने तक का समय',
  Hungarian: 'Idő a befejezésig',
  Icelandic: 'Tími til lokunar',
  Indonesian: 'Waktu hingga selesai',
  Italian: 'Tempo per il completamento',
  Japanese: '完了までの時間',
  Kannada: 'ಪೂರ್ತಿಗೆ ಸಮಯ',
  Kazakh: 'Жақтығына дейінгі уақыт',
  Korean: '완료 시간',
  Latvian: 'Laiks līdz pabeigšanai',
  Lithuanian: 'Laikas iki užbaigimo',
  Macedonian: 'Време до завршување',
  Malay: 'Masa hingga penyelesaian',
  Maori: 'Wā o te whakakapia',
  Marathi: 'पूर्णता पर्यंतचा वेळ',
  Nepali: 'पूर्ण हुन लाग्ने समय',
  Norwegian: 'Tid til fullføring',
  Panjabi: 'ਮੁਕੰਮਲਤਾ ਤੱਕ ਸਮਾਂ',
  Punjabi: 'ਮੁਕੰਮਲਤਾ ਤੱਕ ਸਮਾਂ',
  Persian: 'زمان تا پایان',
  Polish: 'Czas do zakończenia',
  Portuguese: 'Tempo para conclusão',
  Romanian: 'Timp până la finalizare',
  Russian: 'Время до завершения',
  Serbian: 'Време до завршетка',
  Slovak: 'Čas do dokončenia',
  Slovenian: 'Čas do konca',
  Spanish: 'Tiempo de finalización',
  Swahili: 'Wakati wa kumaliza',
  Swedish: 'Tid till avslut',
  Tagalog: 'Oras hanggang matapos',
  Tamil: 'முடிப்புக்கு நேரம்',
  Telugu: 'పూర్తి చేయడానికి సమయం',
  Thai: 'เวลาถึงเสร็จสิ้น',
  Turkish: 'Tamamlanma süresi',
  Ukrainian: 'Час до завершення',
  Urdu: 'مکمل ہونے کا وقت',
  Uzbek: 'Yakunlashgacha vaqt',
  Vietnamese: 'Thời gian đến hoàn thành',
  Welsh: 'Amser i gwblhau',
};

export const translateSummary: Translation = {
  Afrikaans: 'Opsomming',
  Amharic: 'ማጠቃለያ',
  Arabic: 'ملخص',
  Armenian: 'Ամփոփում',
  Azerbaijani: 'Nəticə',
  Belarusian: 'Суадносіны',
  Bengali: 'সারাংশ',
  Bosnian: 'Sažetak',
  Bulgarian: 'Резюме',
  Cantonese: '摘要',
  Catalan: 'Resum',
  Chinese: '摘要',
  'Chinese (Traditional)': '摘要',
  Croatian: 'Sažetak',
  Czech: 'Souhrn',
  Danish: 'Resumé',
  Dutch: 'Samenvatting',
  English: 'Summary',
  Estonian: 'Kokkuvõte',
  Finnish: 'Yhteenveto',
  French: 'Résumé',
  Galician: 'Resumo',
  Georgian: 'შეჯამება',
  German: 'Zusammenfassung',
  Greek: 'Περίληψη',
  Hebrew: 'סיכום',
  Hindi: 'सारांश',
  Hungarian: 'Összefoglaló',
  Icelandic: 'Yfirlit',
  Indonesian: 'Ringkasan',
  Italian: 'Sommario',
  Japanese: '概要',
  Kannada: 'ಸಂಕ್ಷಿಪ್ತವನ್ನು',
  Kazakh: 'Жалпы есеп',
  Korean: '개요',
  Latvian: 'Kopsavilkums',
  Lithuanian: 'Santrauka',
  Macedonian: 'Сажеток',
  Malay: 'Ringkasan',
  Maori: 'Whakarāpopototanga',
  Marathi: 'सारांश',
  Nepali: 'सारांश',
  Norwegian: 'Sammendrag',
  Panjabi: 'ਸਾਰ',
  Punjabi: 'ਸਾਰ',
  Persian: 'خلاصه',
  Polish: 'Podsumowanie',
  Portuguese: 'Resumo',
  Romanian: 'Rezumat',
  Russian: 'Резюме',
  Serbian: 'Резиме',
  Slovak: 'Zhrnutie',
  Slovenian: 'Povzetek',
  Spanish: 'Resumen',
  Swahili: 'Muhtasari',
  Swedish: 'Sammanfattning',
  Tagalog: 'Buod',
  Tamil: 'சுருக்கம்',
  Telugu: 'సారాంశం',
  Thai: 'สรุป',
  Turkish: 'Özet',
  Ukrainian: 'Резюме',
  Urdu: 'خلاصہ',
  Uzbek: 'Xulosa',
  Vietnamese: 'Tóm tắt',
  Welsh: 'Crynodeb',
};

export const translateKeyThemes: Translation = {
  Afrikaans: 'Kern temas',
  Amharic: 'ዋና ጭብጦች',
  Arabic: 'مواضيع رئيسية',
  Armenian: 'Հիմնական թեմաներ',
  Azerbaijani: 'Əsas mövzular',
  Belarusian: 'Ключавыя тэмы',
  Bengali: 'মূল বিষয়বস্তু',
  Bosnian: 'Ključne teme',
  Bulgarian: 'Ключови теми',
  Cantonese: '主要主題',
  Catalan: 'Temes clau',
  Chinese: '关键主题',
  'Chinese (Traditional)': '主要主題',
  Croatian: 'Ključne teme',
  Czech: 'Klíčová témata',
  Danish: 'Centrale temaer',
  Dutch: "Belangrijke thema's",
  English: 'Key themes',
  Estonian: 'Peamised teemad',
  Finnish: 'Avainaiheet',
  French: 'Thèmes clés',
  Galician: 'Temas clave',
  Georgian: 'მთავარი თემები',
  German: 'Hauptthemen',
  Greek: 'Κύρια θέματα',
  Hebrew: 'נושאים מרכזיים',
  Hindi: 'मुख्य विषय',
  Hungarian: 'Kulcs témák',
  Icelandic: 'Lykilþættir',
  Indonesian: 'Tema utama',
  Italian: 'Temi chiave',
  Japanese: 'キーテーマ',
  Kannada: 'ಪ್ರಧಾನ ಥೀಮ್‌ಗಳು',
  Kazakh: 'Негізгі тақырыптар',
  Korean: '주요 주제',
  Latvian: 'Galvenās tēmas',
  Lithuanian: 'Pagrindinės temos',
  Macedonian: 'Клучни теми',
  Malay: 'Tema utama',
  Maori: 'Kaupapa matua',
  Marathi: 'मुख्य थीम्स',
  Nepali: 'मुख्य विषयहरू',
  Norwegian: 'Nøkkeltemaer',
  Panjabi: 'ਮੁੱਖ ਵਿਸ਼ੇ',
  Punjabi: 'ਮੁੱਖ ਵਿਸ਼ੇ',
  Persian: 'موضوعات کلیدی',
  Polish: 'Kluczowe tematy',
  Portuguese: 'Temas chave',
  Romanian: 'Tematici cheie',
  Russian: 'Ключевые темы',
  Serbian: 'Кључне теме',
  Slovak: 'Kľúčové témy',
  Slovenian: 'Ključne teme',
  Spanish: 'Temas clave',
  Swahili: 'Mada muhimu',
  Swedish: 'Nyckelteman',
  Tamil: 'முக்கிய தொகுப்புகள்',
  Telugu: 'ముఖ్య థీమ్‌లు',
  Thai: 'หัวข้อหลัก',
  Tagalog: 'Mga pangunahing tema',
  Turkish: 'Ana temalar',
  Ukrainian: 'Ключові теми',
  Urdu: 'کلیدی موضوعات',
  Uzbek: 'Asosiy mavzular',
  Vietnamese: 'Chủ đề chính',
  Welsh: 'Themâu allweddol',
};

export const translatePatternsAndTrends: Translation = {
  Afrikaans: 'Patrone en Tendense',
  Amharic: 'ዘይቤዎች እና አዝማሚያዎች',
  Arabic: 'أنماط واتجاهات',
  Armenian: 'Կաղապարներ և Թրենդներ',
  Azerbaijani: 'Nümunələr və Trendlər',
  Belarusian: 'Патэрны і Трэнды',
  Bengali: 'নিদর্শন এবং প্রবণতা',
  Bosnian: 'Šabloni i Trendovi',
  Bulgarian: 'Модели и Тенденции',
  Cantonese: '模式和趨勢',
  Catalan: 'Patrons i Tendències',
  Chinese: '模式和趋势',
  'Chinese (Traditional)': '模式和趨勢',
  Croatian: 'Uzorci i Trendovi',
  Czech: 'Vzory a Trendy',
  Danish: 'Mønstre og Tendenser',
  Dutch: 'Patronen en Trends',
  English: 'Patterns and Trends',
  Estonian: 'Mustrid ja Trendid',
  Finnish: 'Mallit ja Trendit',
  French: 'Modèles et Tendances',
  Galician: 'Patróns e Tendencias',
  Georgian: 'ნიმუშები და ტენდენციები',
  German: 'Muster und Trends',
  Greek: 'Πρότυπα και Τάσεις',
  Hebrew: 'תבניות ומגמות',
  Hindi: 'पैटर्न्स और ट्रेंड्स',
  Hungarian: 'Minták és Trendek',
  Icelandic: 'Mynstur og Stefnur',
  Indonesian: 'Pola dan Tren',
  Italian: 'Modelli e Tendenze',
  Japanese: 'パターンとトレンド',
  Kannada: 'ನಮೂನೆಗಳು ಮತ್ತು ಪ್ರವೃತ್ತಿಗಳು',
  Kazakh: 'Үлгілер мен Трендтер',
  Korean: '패턴 및 트렌드',
  Latvian: 'Modeļi un tendences',
  Lithuanian: 'Modeliai ir tendencijos',
  Macedonian: 'Шаблони и Трендови',
  Malay: 'Corak dan Trend',
  Maori: 'Ngā Tauira me ngā Ia',
  Marathi: 'नमुने आणि ट्रेंड्स',
  Nepali: 'ढाँचाहरू र प्रवृत्तिहरू',
  Norwegian: 'Mønstre og trender',
  Panjabi: 'ਨਮੂਨੇ ਅਤੇ ਰੁਝਾਨ',
  Punjabi: 'ਨਮੂਨੇ ਅਤੇ ਰੁਝਾਨ',
  Persian: 'الگوها و روندها',
  Polish: 'Wzory i Trendy',
  Portuguese: 'Padrões e Tendências',
  Romanian: 'Tipare și Tendințe',
  Russian: 'Шаблоны и Тренды',
  Serbian: 'Шаблони и Трендови',
  Slovak: 'Vzory a Trendy',
  Slovenian: 'Vzorci in Trendi',
  Spanish: 'Patrones y Tendencias',
  Swahili: 'Mifumo na Mitindo',
  Swedish: 'Mönster och Trender',
  Tagalog: 'Mga pattern at trend',
  Tamil: 'மாதிரிகள் மற்றும் போக்குகள்',
  Telugu: 'నమూనాలు మరియు ధోరణులు',
  Thai: 'รูปแบบและแนวโน้ม',
  Turkish: 'Kalıplar ve Trendler',
  Ukrainian: 'Шаблони і Тренди',
  Urdu: 'پیٹرنز اور رجحانات',
  Uzbek: 'Naqshlar va tendentsiyalar',
  Vietnamese: 'Mô hình và Xu hướng',
  Welsh: 'Patrymau a Thueddiadau',
};

export const translateDivergentViewsAndOutliers: Translation = {
  Afrikaans: 'Afwykende Menings en Uitskieters',
  Amharic: 'የተለያዩ አመለካከቶች እና ልዩ ሁኔታዎች',
  Arabic: 'آراء متباينة وحالات شاذة',
  Armenian: 'Տարբերվող Դիտումներ և Արտառոցներ',
  Azerbaijani: 'Fərqli Baxışlar və Fərqlənənlər',
  Belarusian: 'Разнастайныя Погляды і Выбітныя',
  Bengali: 'ভিন্ন দৃষ্টিভঙ্গি ও ব্যতিক্রম',
  Bosnian: 'Divergentna Mišljenja i Izdvojeni Podaci',
  Bulgarian: 'Различаващи се Мнения и Аномалии',
  Cantonese: '分歧觀點及異常值',
  Catalan: 'Opinions Divergents i Valors Extrems',
  Chinese: '分歧意见和离群值',
  'Chinese (Traditional)': '分歧觀點及異常值',
  Croatian: 'Različita Mišljenja i Odstupanja',
  Czech: 'Odlišné Názory a Výstřední Hodnoty',
  Danish: 'Divergerende Synspunkter og Afvigere',
  Dutch: 'Divergerende Meningen en Uitschieters',
  English: 'Divergent Views and Outliers',
  Estonian: 'Erinevad Arvamused ja Äärmused',
  Finnish: 'Eriävät Mielipiteet ja Poikkeamat',
  French: 'Points de Vue Divergents et Valeurs Atypiques',
  Galician: 'Puntos de Vista Diverxentes e Outliers',
  Georgian: 'განსხვავებული შეხედულებები და გამონაკლისები',
  German: 'Abweichende Ansichten und Ausreißer',
  Greek: 'Αντιφατικές Απόψεις και Ακραίες Τιμές',
  Hebrew: 'דעות שונות וחריגים',
  Hindi: 'विभिन्न दृष्टिकोण और अपवाद',
  Hungarian: 'Eltérő Vélemények és Kiemelkedések',
  Icelandic: 'Ólík Viðhorf og Útsetningar',
  Indonesian: 'Pandangan Berbeda dan Outlier',
  Italian: 'Punti di Vista Divergenti e Valori Anomali',
  Japanese: '異なる見解と外れ値',
  Kannada: 'ವಿಭಿನ್ನ ದೃಷ್ಟಿಕೋನಗಳು ಮತ್ತು ವೈಚಾರಿಕ ಅತಿರೇಕಗಳು',
  Kazakh: 'Қарама-Қайшы Көзқарастар және Ерекшеліктер',
  Korean: '상이한 견해와 이상치',
  Latvian: 'Atšķirīgi viedokļi un izņēmumi',
  Lithuanian: 'Skirtingos nuomonės ir išimtys',
  Macedonian: 'Различни Мислења и Изолирани Податоци',
  Malay: 'Pandangan Berbeza dan Keluar Bias',
  Maori: 'Ngā Tirohanga Rerekē me ngā Ahurei',
  Marathi: 'विभिन्न मते आणि अपवाद',
  Nepali: 'फरक दृष्टिकोण र असामान्य मूल्यहरू',
  Norwegian: 'Avvikende synspunkter og uteliggere',
  Panjabi: 'ਵੱਖ-ਵੱਖ ਵਿਚਾਰ ਅਤੇ ਅਸਾਧਾਰਨ ਕੇਸ',
  Punjabi: 'ਵੱਖ-ਵੱਖ ਵਿਚਾਰ ਅਤੇ ਅਸਾਧਾਰਨ ਕੇਸ',
  Persian: 'دیدگاه‌های متفاوت و موارد استثنایی',
  Polish: 'Rozbieżne Poglądy i Wartości Odstające',
  Portuguese: 'Visões Divergentes e Outliers',
  Romanian: 'Puncte de Vedere Divergente și Valori Anormale',
  Russian: 'Расходящиеся Мнения и Аномалии',
  Serbian: 'Различита Мишљења и Изузетни Подаци',
  Slovak: 'Rozdielne Názory a Odľahlé Hodnoty',
  Slovenian: 'Različna Mnenja in Odstopanja',
  Spanish: 'Puntos de Vista Divergentes y Valores Atípicos',
  Swahili: 'Mitazamo Tofauti na Vipimo vya Nje',
  Swedish: 'Avvikande Åsikter och Udda Värden',
  Tamil: 'மாறுபட்ட கருத்துக்கள் மற்றும் அசாதாரணமான மதிப்புகள்',
  Telugu: 'భిన్నాభిప్రాయాలు మరియు అసాధారణతలు',
  Thai: 'มุมมองที่แตกต่างและค่าผิดปกติ',
  Turkish: 'Farklı Görüşler ve Aykırılıklar',
  Tagalog: 'Magkaibang pananaw at outlier',
  Ukrainian: 'Відмінні Думки та Відхилення',
  Urdu: 'مختلف خیالات اور غیر معمولی معاملات',
  Uzbek: 'Farqli qarashlar va istisno holatlar',
  Vietnamese: 'Quan Điểm Khác Biệt và Giá Trị Ngoại Lệ',
  Welsh: 'Golygfeydd Amrywiol a Gwerthoedd Eithriadol',
};

export const translateInterestingQuotes: Translation = {
  Afrikaans: 'Interessante aanhalings',
  Amharic: 'አስደሳች ጥቅሶች',
  Arabic: 'اقتباسات مثيرة للاهتمام',
  Armenian: 'Ինտերեսանտ խոսաքանդություններ',
  Azerbaijani: 'Marğub sitatlar',
  Belarusian: 'Цікавыя цытаты',
  Bengali: 'আকর্ষণীয় উদ্ধৃতি',
  Bosnian: 'Zanimljivi citati',
  Bulgarian: 'Интересни цитати',
  Cantonese: '有趣的引語',
  Catalan: 'Cites interessants',
  Chinese: '有趣的引语',
  'Chinese (Traditional)': '有趣的引語',
  Croatian: 'Zanimljive izreke',
  Czech: 'Zajímavé citáty',
  Danish: 'Interessante citater',
  Dutch: 'Interessante citaten',
  English: 'Interesting quotes',
  Estonian: 'Huvitavad tsitaadid',
  Finnish: 'Mielenkiintoisia lainauksia',
  French: 'Citations intéressantes',
  Galician: 'Citas interesantes',
  Georgian: 'საინტერესო ციტატები',
  German: 'Interessante Zitate',
  Greek: 'Ενδιαφέροντα αποφθέγματα',
  Hebrew: 'ציטוטים מעניינים',
  Hindi: 'रोचक उद्धरण',
  Hungarian: 'Érdekes idézetek',
  Icelandic: 'Áhugaverðar tilvitnanir',
  Indonesian: 'Kutipan menarik',
  Italian: 'Citazioni interessanti',
  Japanese: '興味深い引用',
  Kannada: 'ಆಸಕ್ತಿಯ ಉಲ್ಲೇಖಗಳು',
  Kazakh: 'Қызықты сөздер',
  Korean: '흥미로운 인용구',
  Latvian: 'Interesanti citāti',
  Lithuanian: 'Įdomios citatos',
  Macedonian: 'Интересни цитати',
  Malay: 'Ucapan menarik',
  Maori: 'Whakamāramatanga whakataukī',
  Marathi: 'आकर्षक उद्धरणे',
  Nepali: 'रोचक उद्धरणहरू',
  Norwegian: 'Interessante sitater',
  Panjabi: 'ਦਿਲਚਸਪ ਹਵਾਲੇ',
  Punjabi: 'ਦਿਲਚਸਪ ਹਵਾਲੇ',
  Persian: 'نقل قول های جالب',
  Polish: 'Interesujące cytaty',
  Portuguese: 'Citações interessantes',
  Romanian: 'Citate interesante',
  Russian: 'Интересные цитаты',
  Serbian: 'Интересантне цитате',
  Slovak: 'Zaujímavé citáty',
  Slovenian: 'Zanimivi citati',
  Spanish: 'Frases interesantes',
  Swahili: 'Nukuu za kuvutia',
  Swedish: 'Intressanta citat',
  Tamil: 'ஆர்வம் மெய்யிய மொழிபெயர்ப்புகள்',
  Telugu: 'ఆసక్తికరమైన ఉల్లేఖనలు',
  Thai: 'คำพูดที่น่าสนใจ',
  Turkish: 'İlginç alıntılar',
  Tagalog: 'Mga kawili-wiling quote',
  Ukrainian: 'Цікаві цитати',
  Urdu: 'دلچسپ حوار',
  Uzbek: 'Qiziqarli iqtiboslar',
  Vietnamese: 'Trích dẫn thú vị',
  Welsh: 'Dyfyniadau diddorol',
};

export const translateQuote: Translation = {
  Afrikaans: 'Aanhalings',
  Amharic: 'ጥቅስ',
  Arabic: 'اقتباس',
  Armenian: 'Մեկնաբանություն',
  Azerbaijani: 'Sitat',
  Belarusian: 'Цытата',
  Bengali: 'উদ্ধৃতি',
  Bosnian: 'Citat',
  Bulgarian: 'Цитат',
  Cantonese: '引語',
  Catalan: 'Cita',
  Chinese: '引语',
  'Chinese (Traditional)': '引語',
  Croatian: 'Citirati',
  Czech: 'Citace',
  Danish: 'Citat',
  Dutch: 'Citaat',
  English: 'Quote',
  Estonian: 'Tsitaat',
  Finnish: 'Lainaus',
  French: 'Citation',
  Galician: 'Cita',
  Georgian: 'ციტატა',
  German: 'Zitat',
  Greek: 'Παράθεση',
  Hebrew: 'ציטוט',
  Hindi: 'उद्धरण',
  Hungarian: 'Idézet',
  Icelandic: 'Tilvitnun',
  Indonesian: 'Kutipan',
  Italian: 'Citazione',
  Japanese: '引用',
  Kannada: 'ಉಲ್ಲೇಖ',
  Kazakh: 'Сөз',
  Korean: '인용구',
  Latvian: 'Citāts',
  Lithuanian: 'Citata',
  Macedonian: 'Цитат',
  Malay: 'Kutipan',
  Maori: 'Whakataukī',
  Marathi: 'उद्धर',
  Nepali: 'उद्धरण',
  Norwegian: 'Sitat',
  Panjabi: 'ਹਵਾਲਾ',
  Punjabi: 'ਹਵਾਲਾ',
  Persian: 'نقل قول',
  Polish: 'Cytat',
  Portuguese: 'Citação',
  Romanian: 'Citat',
  Russian: 'Цитата',
  Serbian: 'Цитат',
  Slovak: 'Citát',
  Slovenian: 'Citat',
  Spanish: 'Cita',
  Swahili: 'Nukuu',
  Swedish: 'Citat',
  Tamil: 'கோப்பு',
  Telugu: 'ఉల్లేఖనం',
  Thai: 'คำคม',
  Turkish: 'Alıntı',
  Tagalog: 'Quote',
  Ukrainian: 'Цитата',
  Urdu: 'حوالہ',
  Uzbek: 'Iqtibos',
  Vietnamese: 'Trích dẫn',
  Welsh: 'Dyfyniad',
};

export const translateOpportunities: Translation = {
  Afrikaans: 'Geleenthede',
  Amharic: 'ዕድሎች',
  Arabic: 'فرص',
  Armenian: 'Օրինակներ',
  Azerbaijani: 'Fırsatlar',
  Belarusian: 'Магчымасці',
  Bengali: 'সুযোগসমূহ',
  Bosnian: 'Prilike',
  Bulgarian: 'Възможности',
  Cantonese: '機遇',
  Catalan: 'Oportunitats',
  Chinese: '机会',
  'Chinese (Traditional)': '機遇',
  Croatian: 'Prilike',
  Czech: 'Příležitosti',
  Danish: 'Muligheder',
  Dutch: 'Kansen',
  English: 'Opportunities',
  Estonian: 'Võimalused',
  Finnish: 'Mahdollisuudet',
  French: 'Opportunités',
  Galician: 'Oportunidades',
  Georgian: 'შესაძლებლობები',
  German: 'Chancen',
  Greek: 'Ευκαιρίες',
  Hebrew: 'הזדמנויות',
  Hindi: 'अवसर',
  Hungarian: 'Lehetőségek',
  Icelandic: 'Tækifæri',
  Indonesian: 'Peluang',
  Italian: 'Opportunità',
  Japanese: '機会',
  Kannada: 'ಅವಕಾಶಗಳು',
  Kazakh: 'Мүмкіндіктер',
  Korean: '기회',
  Latvian: 'Iespējas',
  Lithuanian: 'Galimybės',
  Macedonian: 'Можности',
  Malay: 'Peluang',
  Maori: 'Tauhokohoko',
  Marathi: 'संधी',
  Nepali: 'अवसरहरू',
  Norwegian: 'Muligheter',
  Panjabi: 'ਮੌਕੇ',
  Punjabi: 'ਮੌਕੇ',
  Persian: 'فرصت ها',
  Polish: 'Okazje',
  Portuguese: 'Oportunidades',
  Romanian: 'Oportunități',
  Russian: 'Возможности',
  Serbian: 'Прилике',
  Slovak: 'Príležitosti',
  Slovenian: 'Priložnosti',
  Spanish: 'Oportunidades',
  Swahili: 'Fursa',
  Swedish: 'Möjligheter',
  Tamil: 'வாயில்கள்',
  Telugu: 'అవకాశాలు',
  Thai: 'โอกาส',
  Turkish: 'Fırsatlar',
  Tagalog: 'Mga pagkakataon',
  Ukrainian: 'Можливості',
  Urdu: 'مواقع',
  Uzbek: 'Imkoniyatlar',
  Vietnamese: 'Cơ hội',
  Welsh: 'Cyfleoedd',
};

export const translateAddToReport: Translation = {
  Afrikaans: 'Voeg by verslag',
  Amharic: 'ወደ ሪፖርት ጨምር',
  Arabic: 'أضف إلى التقرير',
  Armenian: 'Ավելացնել դեպի հաշվետվություն',
  Azerbaijani: 'Hesabatə əlavə edin',
  Belarusian: 'Дадаць у справаздачу',
  Bengali: 'রিপোর্টে যোগ করুন',
  Bosnian: 'Dodaj u izvještaj',
  Bulgarian: 'Добави към доклада',
  Cantonese: '加入報告',
  Catalan: 'Afegir al informe',
  Chinese: '添加到报告',
  'Chinese (Traditional)': '加入報告',
  Croatian: 'Dodaj u izvješće',
  Czech: 'Přidat do zprávy',
  Danish: 'Tilføj til rapport',
  Dutch: 'Toevoegen aan rapport',
  English: 'Add to report',
  Estonian: 'Lisa aruandesse',
  Finnish: 'Lisää raporttiin',
  French: 'Ajouter au rapport',
  Galician: 'Engadir ao informe',
  Georgian: 'ანგარიშში დამატება',
  German: 'Zum Bericht hinzufügen',
  Greek: 'Προσθήκη στην αναφορά',
  Hebrew: 'הוסף לדוח',
  Hindi: 'रिपोर्ट में जोड़ें',
  Hungarian: 'Hozzáadás a jelentéshez',
  Icelandic: 'Bæta við skýrslu',
  Indonesian: 'Tambahkan ke laporan',
  Italian: 'Aggiungi al rapporto',
  Japanese: 'レポートに追加',
  Kannada: 'ವರದಿಗೆ ಸೇರಿಸಿ',
  Kazakh: 'Есепке қосу',
  Korean: '보고서에 추가',
  Latvian: 'Pievienot ziņojumam',
  Lithuanian: 'Pridėti prie ataskaitos',
  Macedonian: 'Додади во извештајот',
  Malay: 'Tambah ke laporan',
  Maori: 'Tāpiri ki te pūrongo',
  Marathi: 'अहवालात जोडा',
  Nepali: 'रिपोर्टमा थप्नुहोस्',
  Norwegian: 'Legg til i rapport',
  Panjabi: 'ਰਿਪੋਰਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ',
  Punjabi: 'ਰਿਪੋਰਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ',
  Persian: 'افزودن به گزارش',
  Polish: 'Dodaj do raportu',
  Portuguese: 'Adicionar ao relatório',
  Romanian: 'Adăugare la raport',
  Russian: 'Добавить в отчет',
  Serbian: 'Додај у извештај',
  Slovak: 'Pridať do správy',
  Slovenian: 'Dodaj v poročilo',
  Spanish: 'Agregar al informe',
  Swahili: 'Ongeza kwa ripoti',
  Swedish: 'Lägg till i rapporten',
  Tamil: 'அறிக்கைக்கு சேர்க்க',
  Telugu: 'నివేదికకు జోడించండి',
  Thai: 'เพิ่มเข้ารายงาน',
  Turkish: 'Rapora ekle',
  Tagalog: 'Idagdag sa ulat',
  Ukrainian: 'Додати до звіту',
  Urdu: 'رپورٹ میں شامل کریں',
  Uzbek: "Hisobotga qo'shish",
  Vietnamese: 'Thêm vào báo cáo',
  Welsh: 'Ychwanegu at yr adroddiad',
};

export const translateCategories: Translation = {
  Afrikaans: 'Kategorieë',
  Amharic: 'ምድቦች',
  Arabic: 'التصنيفات',
  Armenian: 'Կատեգորիաներ',
  Azerbaijani: 'Kateqoriyalar',
  Belarusian: 'Катэгорыі',
  Bengali: 'বিভাগসমূহ',
  Bosnian: 'Kategorije',
  Bulgarian: 'Категории',
  Cantonese: '類別',
  Catalan: 'Categories',
  Chinese: '类别',
  'Chinese (Traditional)': '類別',
  Croatian: 'Kategorije',
  Czech: 'Kategorie',
  Danish: 'Kategorier',
  Dutch: 'Categorieën',
  English: 'Categories',
  Estonian: 'Kategooriad',
  Finnish: 'Luokat',
  French: 'Catégories',
  Galician: 'Categorías',
  Georgian: 'კატეგორიები',
  German: 'Kategorien',
  Greek: 'Κατηγορίες',
  Hebrew: 'קטגוריות',
  Hindi: 'श्रेणियाँ',
  Hungarian: 'Kategóriák',
  Icelandic: 'Flokkar',
  Indonesian: 'Kategori',
  Italian: 'Categorie',
  Japanese: 'カテゴリー',
  Kannada: 'ವರ್ಗಗಳು',
  Kazakh: 'Санаттар',
  Korean: '카테고리',
  Latvian: 'Kategorijas',
  Lithuanian: 'Kategorijos',
  Macedonian: 'Категории',
  Malay: 'Kategori',
  Maori: 'Kāwai',

  Marathi: 'वर्ग',

  Nepali: 'श्रेणीहरू',
  Norwegian: 'Kategorier',
  Panjabi: 'ਸ਼੍ਰੇਣੀਆਂ',
  Punjabi: 'ਸ਼੍ਰੇਣੀਆਂ',
  Persian: 'دسته بندی ها',
  Polish: 'Kategorie',
  Portuguese: 'Categorias',
  Romanian: 'Categorii',
  Russian: 'Категории',
  Serbian: 'Категорије',
  Slovak: 'Kategórie',
  Slovenian: 'Kategorije',
  Spanish: 'Categorías',
  Swahili: 'Jamii',
  Swedish: 'Kategorier',
  Tamil: 'வகைகள்',
  Telugu: 'వర్గాలు',
  Thai: 'หมวดหมู่',
  Turkish: 'Kategoriler',
  Tagalog: 'Mga kategorya',
  Ukrainian: 'Категорії',
  Urdu: 'زمرے',
  Uzbek: 'Kategoriyalar',
  Vietnamese: 'Danh mục',
  Welsh: 'Categorïau',
};

export const translateNoDataAll: Translation = {
  Afrikaans: 'Ongelukkig is daar nie genoeg data om hierdie afdeling te genereer nie.',
  Amharic: 'አሳዛኝ ሆኖ ይህን ክፍል ለመፍጠር በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لإنشاء هذا القسم.',
  Armenian: 'Ներողության համար բավարար տվյալներ չկան այս բաժինը գեներացնելու համար:',
  Azerbaijani: 'Təəssüf ki, bu bölməni yaratmaq üçün kifayət qədər məlumat yoxdur.',
  Belarusian: 'На жаль, недастаткова дадзеных для генерацыі гэтага раздзелу.',
  Bengali: 'দুর্ভাগ্যক্রমে এই বিভাগটি তৈরি করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za generisanje ove sekcije.',
  Bulgarian: 'За съжаление, няма достатъчно данни, за да се генерира този раздел.',
  Cantonese: '非常抱歉，沒有足夠的數據來生成這個部分。',
  Catalan: 'Desafortunadament, no hi ha prou dades per generar aquesta secció.',
  Chinese: '很抱歉，没有足够的数据来生成此部分。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來生成這個部分。',
  Croatian: 'Nažalost, nema dovoljno podataka za generiranje ovog odjeljka.',
  Czech: 'Omlouváme se, ale k vytvoření této sekce není dostatek dat.',
  Danish: 'Desværre er der ikke tilstrækkelige data til at generere denne sektion.',
  Dutch: 'Helaas zijn er niet genoeg gegevens om deze sectie te genereren.',
  English: 'Unfortunately there is not enough data to generate this section.',
  Estonian: 'Kahjuks pole selle jaotise genereerimiseks piisavalt andmeid.',
  Finnish: 'Valitettavasti tähän osioon ei ole riittävästi tietoja.',
  French: "Malheureusement, il n'y a pas assez de données pour générer cette section.",
  Galician: 'Desafortunadamente, non hai suficientes datos para xerar esta sección.',
  Georgian: 'სამწუხაროდ, ამ განყოფილების შესაქმნელად საკმარისი მონაცემები არ არის.',
  German: 'Leider liegen nicht genügend Daten vor, um diesen Abschnitt zu generieren.',
  Greek: 'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να δημιουργηθεί αυτή η ενότητα.',
  Hebrew: 'לצערנו אין מספיק נתונים כדי ליצור את המקטע הזה.',
  Hindi: 'दुर्भाग्यवश इस खंड को उत्पन्न करने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat ehhez a szakaszhoz.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að búa til þessa hluta.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menghasilkan bagian ini.',
  Italian: 'Purtroppo non ci sono abbastanza dati per generare questa sezione.',
  Japanese: '残念ながら、このセクションを生成するのに十分なデータがありません。',
  Kannada: 'ಅದುಕ್ಕೆ ಪ್ರಮಾಣ ಮಾಹಿತಿ ಸಾಕಷ್ಟು ಇಲ್ಲ ದುರದೃಷ್ಟವಶದಿಂದ ಈ ವಿಭಾಗವನ್ನು ರಚಿಸಲು.',
  Kazakh: 'Кешірім, мұнда бұрын болмаса да, мәліметтерді жеткізу үшін дәл мәліметтер жоқ.',
  Korean: '이 부분을 생성할만한 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai ģenerētu šo sadaļu.',
  Lithuanian: 'Deja, nepakanka duomenų šiam skyriui generuoti.',
  Macedonian: 'За жал, нема доволно податоци за генерирање на оваа секција.',
  Malay: 'Malangnya, tidak ada data yang mencukupi untuk menghasilkan bahagian ini.',
  Maori: 'Aroha mai, kāore he ōrite mō te tohutoro i tenei wāhanga.',
  Marathi: 'दुर्दैवाने ह्या विभागाचे रचना करण्यासाठी पुरेसे डेटा नाही.',
  Nepali: 'दुर्भाग्यवश यो खण्ड उत्पन्न गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å generere denne seksjonen.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇਸ ਭਾਗ ਨੂੰ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇਸ ਭਾਗ ਨੂੰ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای ایجاد این بخش موجود نیست.',
  Polish: 'Niestety nie ma wystarczająco danych, aby wygenerować tę sekcję.',
  Portuguese: 'Infelizmente, não há dados suficientes para gerar esta seção.',
  Romanian: 'Din păcate, nu există suficiente date pentru a genera această secțiune.',
  Russian: 'К сожалению, недостаточно данных для генерации этого раздела.',
  Serbian: 'Нажалост, нема довољно података за генерисање ове секције.',
  Slovak: 'Bohužiaľ, nie sú k dispozícii dostatočné údaje na generovanie tejto časti.',
  Slovenian: 'Na žalost ni dovolj podatkov za generiranje tega odseka.',
  Spanish: 'Desafortunadamente, no hay suficientes datos para generar esta sección.',
  Swahili: 'Kwa bahati mbaya hakuna data ya kutosha ya kuzalisha sehemu hii.',
  Swedish: 'Tyvärr finns det inte tillräckligt med data för att generera den här sektionen.',
  Tagalog: 'Sa kasamaang-palad, hindi sapat ang data upang makabuo ng seksyong ito.',
  Tamil: 'இந்த பிரிப்பானை உருவாக்க போது போதுமான தரவு இல்லையாம்.',
  Telugu: 'దురదృష్టవశాత్తు ఈ విభాగాన్ని రూపొందించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะสร้างส่วนนี้',
  Turkish: 'Maalesef, bu bölümü oluşturmak için yeterli veri yok.',
  Ukrainian: 'На жаль, недостатньо даних для генерації цього розділу.',
  Urdu: 'افسوس کہ اس حصے کو تشکیل دینے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, bu bo'limni yaratish uchun yetarli ma'lumot yo'q.",
  Vietnamese: 'Rất tiếc, không có đủ dữ liệu để tạo ra phần này.',
  Welsh: "Yn anffodus, nid oes digon o ddata i greu'r adran hon.",
};

export const translateNoSummaryData: Translation = {
  Afrikaans: "Ongelukkig is daar nie genoeg data om 'n opsomming te genereer nie.",
  Amharic: 'በሚያሳዝን ሁኔታ፣ ማጠቃለያ ለማመንጨት በቂ መረጃ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لإنشاء ملخص.',
  Armenian: 'Ներողության համար բավարար տվյալներ չկան այս ամփոփ գրառումը ստեղծելու համար:',
  Azerbaijani: 'Təəssüf ki, bir özət yaratmaq üçün kifayət qədər məlumat yoxdur.',
  Belarusian: 'На жаль, недастаткова дадзеных для стварэння агляду.',
  Bengali: 'দুর্ভাগ্যক্রমে একটি সারাংশ তৈরি করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za generisanje sažetka.',
  Bulgarian: 'За съжаление, няма достатъчно данни, за да се създаде обобщение.',
  Cantonese: '非常抱歉，沒有足夠的數據來生成摘要。',
  Catalan: 'Desafortunadament, no hi ha prou dades per generar un resum.',
  Chinese: '很抱歉，没有足够的数据来生成摘要。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來生成摘要。',
  Croatian: 'Nažalost, nema dovoljno podataka za generiranje sažetka.',
  Czech: 'Omlouváme se, ale k vytvoření souhrnu není dostatek dat.',
  Danish: 'Desværre er der ikke tilstrækkelige data til at generere en opsummering.',
  Dutch: 'Helaas zijn er niet genoeg gegevens om een samenvatting te genereren.',
  English: 'Unfortunately there is not enough data to generate a summary.',
  Estonian: 'Kahjuks pole kokkuvõtte koostamiseks piisavalt andmeid.',
  Finnish: 'Valitettavasti tähän yhteenvetoon ei ole riittävästi tietoja.',
  French: "Malheureusement, il n'y a pas assez de données pour générer un résumé.",
  Galician: 'Desafortunadamente, non hai suficientes datos para xerar un resumo.',
  Georgian: 'სამწუხაროდ, შეჯამების შესაქმნელად საკმარისი მონაცემები არ არის.',
  German: 'Leider liegen nicht genügend Daten vor, um eine Zusammenfassung zu generieren.',
  Greek: 'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να δημιουργηθεί μια περίληψη.',
  Hebrew: 'לצערנו אין מספיק נתונים כדי ליצור תקציר.',
  Hindi: 'दुर्भाग्यवश एक सारांश तैयार करने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat ehhez az összefoglalóhoz.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að búa til yfirlit.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menghasilkan ringkasan.',
  Italian: 'Purtroppo non ci sono abbastanza dati per generare un riassunto.',
  Japanese: '残念ながら、この要約を生成するのに十分なデータがありません。',
  Kannada: 'ಅದುಕ್ಕೆ ಪ್ರಮಾಣ ಸಾರಾಂಶಕ್ಕಾಗಿ ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ.',
  Kazakh: 'Кешірім, көрсеткі үшін дәл мәліметтер жоқ.',
  Korean: '이 요약을 생성할만한 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai ģenerētu kopsavilkumu.',
  Lithuanian: 'Deja, nepakanka duomenų santraukai generuoti.',
  Macedonian: 'За жал, нема доволно податоци за генерирање на сажетокот.',
  Malay: 'Malangnya, tidak ada data yang mencukupi untuk menghasilkan ringkasan.',
  Maori: 'Aroha mai, kāore he ōrite mō te tohutoro.',
  Marathi: 'दुर्दैवाने सारांश तयार करण्यासाठी पुरेसे डेटा नाही.',
  Nepali: 'दुर्भाग्यवश सारांश उत्पन्न गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å generere et sammendrag.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਸਾਰਾਂਸ਼ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਸਾਰਾਂਸ਼ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای ایجاد خلاصه موجود نیست.',
  Polish: 'Niestety nie ma wystarczająco danych, aby wygenerować podsumowanie.',
  Portuguese: 'Infelizmente, não há dados suficientes para gerar um resumo.',
  Romanian: 'Din păcate, nu există suficiente date pentru a genera un rezumat.',
  Russian: 'К сожалению, недостаточно данных для создания обзора.',
  Serbian: 'Нажалост, нема довољно података за генерисање резимеа.',
  Slovak: 'Bohužiaľ, nie sú k dispozícii dostatočné údaje na generovanie súhrnu.',
  Slovenian: 'Na žalost ni dovolj podatkov za generiranje povzetka.',
  Spanish: 'Desafortunadamente, no hay suficientes datos para generar un resumen.',
  Swahili: 'Kwa bahati mbaya hakuna data ya kutosha ya kuzalisha muhtasari.',
  Swedish: 'Tyvärr finns det inte tillräckligt med data för att generera en sammanfattning.',
  Tamil: 'இந்த சுருக்கம் உருவாக்க போது போதுமான தரவு இல்லை.',
  Telugu: 'దురదృష్టవశాత్తు సారాంశాన్ని రూపొందించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะสร้างสรุป',
  Turkish: 'Maalesef, bu özet için yeterli veri yok.',
  Tagalog: 'Sa kasamaang-palad, hindi sapat ang data upang makabuo ng buod.',
  Ukrainian: 'На жаль, недостатньо даних для створення огляду.',
  Urdu: 'افسوس کہ ایک خلاصہ تیار کرنے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, xulosa yaratish uchun yetarli ma'lumot yo'q.",
  Vietnamese: 'Rất tiếc, không có đủ dữ liệu để tạo ra bản tóm tắt.',
  Welsh: 'Yn anffodus, nid oes digon o ddata i greu crynodeb.',
};

export const translateNoKeyThemesData: Translation = {
  Afrikaans: "Ongelukkig is daar nie genoeg data om 'n lys van sleuteltemas te genereer nie.",
  Amharic: 'አሳዛኝ ሆኖ የቁልፍ ጭብጦች ዝርዝር ለመፍጠር በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لإنشاء قائمة بالموضوعات الرئيسية.',
  Armenian:
    'Ներողության համար բավարար տվյալներ չկան հիմնական թեմաների ցանկ գրառումը ստեղծելու համար:',
  Azerbaijani: 'Təəssüf ki, əsas mövzuların siyahısını yaratmaq üçün kifayət qədər məlumat yoxdur.',
  Belarusian: 'На жаль, недастаткова дадзеных для стварэння спісу ключавых тэм.',
  Bengali: 'দুর্ভাগ্যক্রমে মূল বিষয়ের তালিকা তৈরি করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za generiranje liste ključnih tema.',
  Bulgarian: 'За съжаление, няма достатъчно данни, за да се създаде списък на ключови теми.',
  Cantonese: '非常抱歉，沒有足夠的數據來生成主要主題列表。',
  Catalan: 'Desafortunadament, no hi ha prou dades per generar una llista de temes clau.',
  Chinese: '很抱歉，没有足够的数据来生成关键主题列表。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來生成主要主題列表。',
  Croatian: 'Nažalost, nema dovoljno podataka za generiranje liste ključnih tema.',
  Czech: 'Omlouváme se, ale k vytvoření seznamu klíčových témat není dostatek dat.',
  Danish: 'Desværre er der ikke tilstrækkelige data til at generere en liste over nøgleemner.',
  Dutch: "Helaas zijn er niet genoeg gegevens om een lijst van sleutelthema's te genereren.",
  English: 'Unfortunately there is not enough data to generate a list of key themes.',
  Estonian: 'Kahjuks pole piisavalt andmeid põhiteemade loendi koostamiseks.',
  Finnish: 'Valitettavasti avainteemojen luettelon laatimiseen ei ole riittävästi tietoja.',
  French: "Malheureusement, il n'y a pas assez de données pour générer une liste des thèmes clés.",
  Galician: 'Desafortunadamente, non hai suficientes datos para xerar unha lista de temas clave.',
  Georgian: 'სამწუხაროდ, ძირითადი თემების სიის შესაქმნელად საკმარისი მონაცემები არ არის.',
  German:
    'Leider liegen nicht genügend Daten vor, um eine Liste der Schlüsselthemen zu generieren.',
  Greek: 'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να δημιουργηθεί μια λίστα με τα κύρια θέματα.',
  Hebrew: 'לצערנו אין מספיק נתונים כדי ליצור רשימה של נושאים מרכזיים.',
  Hindi: 'दुर्भाग्यवश एक प्रमुख विषयों की सूची तैयार करने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat ehhez az összefoglalóhoz.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að búa til yfirlit.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menghasilkan daftar tema utama.',
  Italian: 'Purtroppo non ci sono abbastanza dati per generare un riassunto.',
  Japanese: '残念ながら、この要約を生成するのに十分なデータがありません。',
  Kannada: 'ಅದುಕ್ಕೆ ಪ್ರಮುಖ ವಿಷಯಗಳ ಪಟ್ಟಿಯನ್ನು ರಚಿಸಲು ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ.',
  Kazakh: 'Кешірім, кімімді ұғымдардың тізімін жасау үшін дәл мәліметтер жоқ.',
  Korean: '이 요약을 생성할만한 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai ģenerētu galveno tēmu sarakstu.',
  Lithuanian: 'Deja, nepakanka duomenų pagrindinių temų sąrašui generuoti.',
  Macedonian: 'За жал, нема доволно податоци за генерирање на списокот на клучни теми.',
  Malay: 'Malangnya, tidak ada data yang mencukupi untuk menghasilkan senarai tema utama.',
  Maori: 'Aroha mai, kāore he ōrite mō te tohutoro.',
  Marathi: 'दुर्दैवाने प्रमुख विषयांची यादी तयार करण्यासाठी पुरेसे डेटा नाही.',
  Nepali: 'दुर्भाग्यवश मुख्य विषयहरूको सूची उत्पन्न गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å generere en liste over nøkkeltemaer.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਮੁੱਖ ਵਿਸ਼ਿਆਂ ਦੀ ਸੂਚੀ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਮੁੱਖ ਵਿਸ਼ਿਆਂ ਦੀ ਸੂਚੀ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای ایجاد فهرست موضوعات کلیدی موجود نیست.',
  Polish: 'Niestety nie ma wystarczająco danych, aby wygenerować listę kluczowych tematów.',
  Portuguese: 'Infelizmente, não há dados suficientes para gerar uma lista de temas principais.',
  Romanian: 'Din păcate, nu există suficiente date pentru a genera o listă de teme cheie.',
  Russian: 'К сожалению, недостаточно данных для создания списка ключевых тем.',
  Serbian: 'Нажалост, нема довољно података за генерисање списака кључних тема.',
  Slovak: 'Bohužiaľ, nie sú k dispozícii dostatočné údaje na generovanie zoznamu kľúčových tém.',
  Slovenian: 'Na žalost ni dovolj podatkov za generiranje seznama ključnih tem.',
  Spanish: 'Desafortunadamente, no hay suficientes datos para generar una lista de temas clave.',
  Swahili: 'Kwa bahati mbaya hakuna data ya kutosha ya kuzalisha orodha ya mada muhimu.',
  Swedish:
    'Tyvärr finns det inte tillräckligt med data för att generera en lista över nyckelämnen.',
  Tagalog:
    'Sa kasamaang-palad, hindi sapat ang data upang makabuo ng listahan ng mga pangunahing tema.',
  Tamil: 'இந்த சுருக்கம் உருவாக்க போது போதுமான தரவு இல்லை.',
  Telugu: 'దురదృష్టవశాత్తు ముఖ్య థీమ్‌ల జాబితాను రూపొందించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะสร้างรายการของหัวข้อสำคัญ',
  Turkish: 'Maalesef, anahtar konuların bir listesini oluşturmak için yeterli veri yok.',
  Ukrainian: 'На жаль, недостатньо даних для створення списку ключових тем.',
  Urdu: 'افسوس کہ اہم موضوعات کی فہرست تیار کرنے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, asosiy mavzular ro'yxatini yaratish uchun yetarli ma'lumot yo'q.",
  Vietnamese: 'Rất tiếc, không có đủ dữ liệu để tạo ra danh sách các chủ đề chính.',
  Welsh: 'Yn anffodus, nid oes digon o ddata i greu rhestr o themâu allweddol.',
};

export const translateNoQuotesData: Translation = {
  Afrikaans:
    'Ongelukkig is daar nie genoeg data om interessante aanhalings uit die onderhoude te wys nie.',
  Amharic: 'አሳዛኝ ሆኖ ከቃለ-ምልልሶቹ አስደሳች ጥቅሶችን ለማሳየት በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لعرض الاقتباسات المثيرة من المقابلات.',
  Armenian:
    'Ներողության համար բավարար տվյալներ չկան հետաքրքրող մեկնաբանությունները ցուցադրելու համար:',
  Azerbaijani:
    'Təəssüf ki, maraqlı sitatları müsahibələrdən göstərmək üçün kifayət qədər məlumat yoxdur.',
  Belarusian: "На жаль, недастаткова дадзеных, каб паказаць вам цікавыя цытаты з інтэрв'ю.",
  Bengali: 'দুর্ভাগ্যক্রমে, সাক্ষাৎকার থেকে আকর্ষণীয় উদ্ধৃতি দেখানোর জন্য পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka da vam se prikažu zanimljive izjave iz intervjua.',
  Bulgarian:
    'За съжаление, няма достатъчно данни, за да ви покажем интересни цитати от интервютата.',
  Cantonese: '非常抱歉，沒有足夠的數據來顯示您在訪談中的有趣引用。',
  Catalan:
    'Desafortunadament, no hi ha prou dades per mostrar-vos cites interessants de les entrevistes.',
  Chinese: '很抱歉，没有足够的数据来显示您在面试中的有趣引用。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來顯示您在訪談中的有趣引用。',
  Croatian: 'Nažalost, nema dovoljno podataka da vam se prikažu zanimljive izjave iz intervjua.',
  Czech:
    'Omlouváme se, ale nemáme dostatek dat, abychom vám mohli ukázat zajímavé citáty z rozhovorů.',
  Danish:
    'Desværre er der ikke tilstrækkelige data til at vise dig interessante citater fra interviews.',
  Dutch:
    'Helaas zijn er niet genoeg gegevens om u interessante citaten uit de interviews te tonen.',
  English: 'Unfortunately there is not enough data to show you quotes from the interviews.',
  Estonian: 'Kahjuks pole piisavalt andmeid, et näidata teile huvitavaid tsitaate intervjuudest.',
  Finnish:
    'Valitettavasti haastatteluista ei ole tarpeeksi tietoa näyttääkseni sinulle mielenkiintoisia lainauksia.',
  French:
    "Malheureusement, il n'y a pas assez de données pour vous montrer des citations intéressantes des entretiens.",
  Galician:
    'Desafortunadamente, non hai suficientes datos para amosarche citas interesantes das entrevistas.',
  Georgian:
    'სამწუხაროდ, ინტერვიუებიდან საინტერესო ციტატების საჩვენებლად საკმარისი მონაცემები არ არის.',
  German:
    'Leider liegen nicht genügend Daten vor, um Ihnen interessante Zitate aus den Interviews zu zeigen.',
  Greek:
    'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να σας εμφανίσουμε ενδιαφέρουσες φράσεις από τις συνεντεύξεις.',
  Hebrew: 'לצערנו אין מספיק נתונים כדי להציג לכם ציטוטים מעניינים מהראיונות.',
  Hindi: 'दुर्भाग्यवश, साक्षात्कारों से आपको रोचक उद्धरण दिखाने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian:
    'Sajnálatos módon nincs elég adat ahhoz, hogy érdekes idézeteket mutassunk Önnek az interjúkból.',
  Icelandic:
    'Því miður eru ekki nægjanleg gögn til að sýna þér áhugaverðar tilvitnanir úr viðtölum.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menampilkan kutipan menarik dari wawancara.',
  Italian:
    'Purtroppo non ci sono abbastanza dati per mostrarti citazioni interessanti dagli interviste.',
  Japanese: '残念ながら、面接から興味深い引用を表示するための十分なデータがありません。',
  Kannada: 'ದುರ್ಭಾಗ್ಯಕ್ಕಾಗಿ, ಸಂಭಾಷಣೆಗಳಿಂದ ನಿಮಗೆ ಆಸಕ್ತಿಯ ಉಲ್ಲೇಖಗಳನ್ನು ತೋರಿಸಲು ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ.',
  Kazakh: 'Кешірім, интервьюлардан сізге қызықты цитаталарды көрсетуге үшін дәл мәліметтер жоқ.',
  Korean: '죄송하지만 인터뷰에서 흥미로운 인용구를 보여줄 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai rādītu interesantas citātes no intervijām.',
  Lithuanian: 'Deja, nepakanka duomenų, kad būtų galima rodyti įdomias citatas iš interviu.',
  Macedonian: 'За жал, нема доволно податоци за прикажување на интересни цитати од интервјуата.',
  Malay:
    'Malangnya, tidak ada data yang mencukupi untuk menunjukkan petikan menarik dari temu ramah.',
  Maori: 'Aroha mai, kāore he ōrite mō te tohutoro.',
  Marathi: 'दुर्दैवाने, माहितीस रोखण्यासाठी पर्याप्त डेटा नाहीत.',
  Nepali: 'दुर्भाग्यवश, अन्तर्वार्ताबाट रोचक उद्धरणहरू देखाउन पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å vise interessante sitater fra intervjuene.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਦਿਲਚਸਪ ਹਵਾਲੇ ਦਿਖਾਉਣ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਦਿਲਚਸਪ ਹਵਾਲੇ ਦਿਖਾਉਣ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای نمایش نقل قول های جالب از مصاحبه ها وجود ندارد.',
  Polish: 'Niestety nie ma wystarczająco danych, aby pokazać Ci interesujące cytaty z wywiadów.',
  Portuguese:
    'Infelizmente, não há dados suficientes para mostrar citações interessantes das entrevistas.',
  Romanian:
    'Din păcate, nu există suficiente date pentru a vă arăta citate interesante din interviuri.',
  Russian: 'К сожалению, недостаточно данных для отображения вам интересных цитат из интервью.',
  Serbian: 'Нажалост, нема довољно података да вам се прикажу занимљиве изјаве из интервјуа.',
  Slovak:
    'Bohužiaľ, nie sú k dispozícii dostatočné údaje na zobrazenie zaujímavých citátov z rozhovorov.',
  Slovenian: 'Na žalost ni dovolj podatkov, da vam pokažemo zanimive citate iz intervjujev.',
  Spanish:
    'Desafortunadamente, no hay suficientes datos para mostrarle citas interesantes de las entrevistas.',
  Swahili:
    'Kwa bahati mbaya hakuna data ya kutosha kuonyesha quotes za kuvutia kutoka kwa mahojiano.',
  Swedish:
    'Tyvärr finns det inte tillräckligt med data för att visa dig intressanta citat från intervjuerna.',
  Tagalog:
    'Sa kasamaang-palad, hindi sapat ang data upang ipakita ang mga kawili-wiling quote mula sa mga panayam.',
  Tamil: 'இந்த சுருக்கம் உருவாக்க போது போதுமான தரவு இல்லை.',
  Telugu: 'దురదృష్టవశాత్తు ఇంటర్వ్యూల నుండి ఉల్లేఖనలను చూపించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะแสดงคำพูดที่น่าสนใจจากการสัมภาษณ์',
  Turkish: 'Maalesef, röportajlardan ilginç alıntıları size gösterecek yeterli veri yok.',
  Ukrainian: "На жаль, недостатньо даних, щоб показати вам цікаві цитати з інтерв'ю.",
  Urdu: 'افسوس، مقابلوں سے دلچسپ حوالے دکھانے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, intervyulardan qiziqarli iqtiboslarni ko'rsatish uchun yetarli ma'lumot yo'q.",
  Vietnamese:
    'Rất tiếc, không có đủ dữ liệu để hiển thị các câu trích dẫn thú vị từ các cuộc phỏng vấn.',
  Welsh: "Yn anffodus, nid oes digon o ddata i ddangos dyfyniadau diddorol o'r cyfweliadau.",
};

export const translateNoOpportunitiesData: Translation = {
  Afrikaans:
    'Ongelukkig is daar nie genoeg data om geleenthede uit jou onderhoude te genereer nie.',
  Amharic: 'አሳዛኝ ሆኖ ከቃለ-ምልልሶቻችሁ ዕድሎችን ለመፍጠር በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لتوليد الفرص من مقابلاتك.',
  Armenian: 'Ներողության համար բավարար տվյալներ չկան խնդրերը ձեր հարցաթերթերից գեներացնելու համար:',
  Azerbaijani:
    'Təəssüf ki, müsahibələrinizdən imkanlar yaradılması üçün kifayət qədər məlumat yoxdur.',
  Belarusian: "На жаль, недастаткова дадзеных, каб стварыць магчымасці з васьмі інтэрв'ю.",
  Bengali: 'দুর্ভাগ্যক্রমে, আপনার সাক্ষাৎকার থেকে সুযোগ তৈরি করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za generiranje prilika iz vaših intervjua.',
  Bulgarian:
    'За съжаление, няма достатъчно данни за генериране на възможности от вашите интервюта.',
  Cantonese: '非常抱歉，沒有足夠的數據從您的訪談中生成機會。',
  Catalan:
    'Desafortunadament, no hi ha prou dades per generar oportunitats a partir dels teus entrevistes.',
  Chinese: '很抱歉，没有足够的数据从你的面试中生成机会。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據從您的訪談中生成機會。',
  Croatian: 'Nažalost, nema dovoljno podataka za generiranje prilika iz vaših intervjua.',
  Czech: 'Omlouváme se, ale nemáme dostatek dat na generování příležitostí z vašich rozhovorů.',
  Danish:
    'Desværre er der ikke tilstrækkelige data til at generere muligheder fra dine interviews.',
  Dutch: 'Helaas zijn er niet genoeg gegevens om kansen te genereren uit uw interviews.',
  English: 'Unfortunately there is not enough data to generate opportunities from your interviews.',
  Estonian: 'Kahjuks pole piisavalt andmeid teie intervjuudest võimaluste genereerimiseks.',
  Finnish: 'Valitettavasti haastatteluista ei ole tarpeeksi tietoja mahdollisuuksien luomiseksi.',
  French:
    "Malheureusement, il n'y a pas assez de données pour générer des opportunités à partir de vos entretiens.",
  Galician:
    'Desafortunadamente, non hai suficientes datos para xerar oportunidades das súas entrevistas.',
  Georgian:
    'სამწუხაროდ, თქვენი ინტერვიუებიდან შესაძლებლობების შესაქმნელად საკმარისი მონაცემები არ არის.',
  German:
    'Leider liegen nicht genügend Daten vor, um Möglichkeiten aus Ihren Interviews zu generieren.',
  Greek:
    'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να δημιουργήσουν ευκαιρίες από τις συνεντεύξεις σας.',
  Hebrew: 'לצערנו אין מספיק נתונים ליצירת הזדמנויות מהראיונות שלך.',
  Hindi: 'दुर्भाग्यवश, आपके साक्षात्कारों से अवसर उत्पन्न करने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat a lehetőségek generálásához az interjúidból.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að búa til möguleika úr viðtölum þínum.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menghasilkan peluang dari wawancara Anda.',
  Italian: 'Purtroppo non ci sono abbastanza dati per generare opportunità dai tuoi colloqui.',
  Japanese: '残念ながら、あなたのインタビューから機会を生成するのに十分なデータがありません。',
  Kannada: 'ದುರ್ಭಾಗ್ಯವಶಃ, ನಿಮ್ಮ ಸಾಕ್ಷಾತ್ಕಾರಗಳಿಂದ ಅವಕಾಶಗಳನ್ನು ರಚಿಸಲು ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ.',
  Kazakh: 'Кешірім, сіздің интервьюларыңыздан мүмкіндіктерді жасау үшін дәл мәліметтер жоқ.',
  Korean: '죄송하지만 인터뷰에서 기회를 생성할 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai ģenerētu iespējas no jūsu intervijām.',
  Lithuanian: 'Deja, nepakanka duomenų galimybėms iš jūsų interviu generuoti.',
  Macedonian: 'За жал, нема доволно податоци за генерирање на можностите од вашите интервјуа.',
  Malay:
    'Malangnya, tidak ada data yang mencukupi untuk menghasilkan peluang dari temu ramah anda.',
  Maori: 'Aroha mai, kāore he ōrite mō te tohutoro.',
  Marathi: 'दुर्दैवाने, आपल्या साक्षात्कारांमधून संधी सिद्ध करण्यासाठी पर्याप्त डेटा नाही.',
  Nepali: 'दुर्भाग्यवश, तपाईंको अन्तर्वार्ताबाट अवसरहरू उत्पन्न गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å generere muligheter fra intervjuene dine.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਤੁਹਾਡੇ ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਮੌਕੇ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਤੁਹਾਡੇ ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਮੌਕੇ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای تولید فرصت ها از مصاحبه های شما وجود ندارد.',
  Polish: 'Niestety nie ma wystarczających danych do generowania możliwości z twoich wywiadów.',
  Portuguese:
    'Infelizmente, não há dados suficientes para gerar oportunidades a partir de suas entrevistas.',
  Romanian:
    'Din păcate, nu există suficiente date pentru a genera oportunități din interviurile tale.',
  Russian: 'К сожалению, недостаточно данных для создания возможностей из ваших интервью.',
  Serbian: 'Нажалост, нема довољно података за генерисање прилика из ваших интервјуа.',
  Slovak:
    'Bohužiaľ, nie sú k dispozícii dostatočné údaje na generovanie príležitostí z vašich rozhovorov.',
  Slovenian: 'Na žalost ni dovolj podatkov za generiranje priložnosti iz vaših intervjujev.',
  Spanish:
    'Desafortunadamente, no hay suficientes datos para generar oportunidades a partir de tus entrevistas.',
  Swahili: 'Kwa bahati mbaya hakuna data ya kutosha kuzalisha fursa kutoka kwa mahojiano yako.',
  Swedish:
    'Tyvärr finns det inte tillräckligt med data för att generera möjligheter från dina intervjuer.',
  Tagalog:
    'Sa kasamaang-palad, hindi sapat ang data upang makabuo ng mga pagkakataon mula sa iyong mga panayam.',
  Tamil: 'இந்த சுருக்கம் உருவாக்க போது போதுமான தரவு இல்லை.',
  Telugu: 'దురదృష్టవశాత్తు మీ ఇంటర్వ్యూల నుండి అవకాశాలను రూపొందించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะสร้างโอกาสจากการสัมภาษณ์ของคุณ',
  Turkish: 'Maalesef, görüşmelerinizden fırsatlar üretmek için yeterli veri yok.',
  Ukrainian: "На жаль, недостатньо даних, щоб створити можливості з вашого інтерв'ю.",
  Urdu: 'افسوس، آپ کے مصاحبوں سے مواقع پیدا کرنے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, intervyularingizdan imkoniyatlar yaratish uchun yetarli ma'lumot yo'q.",
  Vietnamese: 'Rất tiếc, không có đủ dữ liệu để tạo ra cơ hội từ cuộc phỏng vấn của bạn.',
  Welsh: "Yn anffodus, nid oes digon o ddata i greu cyfleoedd o'ch cyfweliadau.",
};

export const translateQuestions: Translation = {
  Afrikaans: 'Vrae',
  Amharic: 'ጥያቄዎች',
  Arabic: 'أسئلة',
  Armenian: 'Հարցեր',
  Azerbaijani: 'Sual',
  Belarusian: 'Пытанні',
  Bengali: 'প্রশ্নসমূহ',
  Bosnian: 'Pitanja',
  Bulgarian: 'Въпроси',
  Cantonese: '問題',
  Catalan: 'Preguntes',
  Chinese: '问题',
  'Chinese (Traditional)': '問題',
  Croatian: 'Pitanja',
  Czech: 'Otázky',
  Danish: 'Spørgsmål',
  Dutch: 'Vragen',
  English: 'Questions',
  Estonian: 'Küsimused',
  Finnish: 'Kysymykset',
  French: 'Questions',
  Galician: 'Preguntas',
  Georgian: 'კითხვები',
  German: 'Fragen',
  Greek: 'Ερωτήσεις',
  Hebrew: 'שאלות',
  Hindi: 'प्रश्न',
  Hungarian: 'Kérdések',
  Icelandic: 'Spurningar',
  Indonesian: 'Pertanyaan',
  Italian: 'Domande',
  Japanese: '質問',
  Kannada: 'ಪ್ರಶ್ನೆಗಳು',
  Kazakh: 'Сұрақтар',
  Korean: '질문',
  Latvian: 'Jautājumi',
  Lithuanian: 'Klausimai',
  Macedonian: 'Прашања',
  Malay: 'Soalan',
  Maori: 'Pātai',
  Marathi: 'प्रश्न',
  Nepali: 'प्रश्नहरू',
  Norwegian: 'Spørsmål',
  Panjabi: 'ਸਵਾਲ',
  Punjabi: 'ਸਵਾਲ',
  Persian: 'سوالات',
  Polish: 'Pytania',
  Portuguese: 'Perguntas',
  Romanian: 'Întrebări',
  Russian: 'Вопросы',
  Serbian: 'Питања',
  Slovak: 'Otázky',
  Slovenian: 'Vprašanja',
  Spanish: 'Preguntas',
  Swahili: 'Maswali',
  Swedish: 'Frågor',
  Tagalog: 'Mga Tanong',
  Tamil: 'கேள்விகள்',
  Telugu: 'ప్రశ్నలు',
  Thai: 'คำถาม',
  Turkish: 'Sorular',
  Ukrainian: 'Запитання',
  Urdu: 'سوالات',
  Uzbek: 'Savollar',
  Vietnamese: 'Câu hỏi',
  Welsh: 'Cwestiynau',
};

export const translateNoQuestionsData: Translation = {
  Afrikaans: 'Ongelukkig is daar nie genoeg data om vrae te genereer nie.',
  Amharic: 'አሳዛኝ ሆኖ ጥያቄዎችን ለመፍጠር በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لإنشاء أسئلة.',
  Armenian: 'Ներողություն, բավարար տվյալներ չկան հարցեր ստեղծելու համար:',
  Azerbaijani: 'Təəssüf ki, suallar yaratmaq üçün kifayət qədər məlumat yoxdur.',
  Belarusian: 'На жаль, недастаткова дадзеных для стварэння пытанняў.',
  Bengali: 'দুর্ভাগ্যক্রমে প্রশ্ন তৈরি করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za generisanje pitanja.',
  Bulgarian: 'За съжаление, няма достатъчно данни за генериране на въпроси.',
  Cantonese: '非常抱歉，沒有足夠的數據來生成問題。',
  Catalan: 'Desafortunadament, no hi ha prou dades per generar preguntes.',
  Chinese: '很抱歉，没有足够的数据来生成问题。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來生成問題。',
  Croatian: 'Nažalost, nema dovoljno podataka za generiranje pitanja.',
  Czech: 'Omlouváme se, ale k vytvoření otázek není dostatek dat.',
  Danish: 'Desværre er der ikke tilstrækkelige data til at generere spørgsmål.',
  Dutch: 'Helaas zijn er niet genoeg gegevens om vragen te genereren.',
  English: 'Unfortunately there is not enough data to generate questions.',
  Estonian: 'Kahjuks pole küsimuste koostamiseks piisavalt andmeid.',
  Finnish: 'Valitettavasti kysymysten luomiseen ei ole riittävästi tietoja.',
  French: "Malheureusement, il n'y a pas assez de données pour générer des questions.",
  Galician: 'Desafortunadamente, non hai suficientes datos para xerar preguntas.',
  Georgian: 'სამწუხაროდ, კითხვების შესაქმნელად საკმარისი მონაცემები არ არის.',
  German: 'Leider liegen nicht genügend Daten vor, um Fragen zu generieren.',
  Greek: 'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να δημιουργηθούν ερωτήσεις.',
  Hebrew: 'לצערנו אין מספיק נתונים כדי ליצור שאלות.',
  Hindi: 'दुर्भाग्यवश प्रश्न तैयार करने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat a kérdések generálásához.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að búa til spurningar.',
  Indonesian: 'Sayangnya, tidak ada cukup data untuk menghasilkan pertanyaan.',
  Italian: 'Purtroppo non ci sono abbastanza dati per generare domande.',
  Japanese: '残念ながら、質問を生成するのに十分なデータがありません。',
  Kannada: 'ದುರದೃಷ್ಟವಶಾತ್ ಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಲು ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ.',
  Kazakh: 'Өкінішке орай, сұрақтар жасау үшін жеткілікті деректер жоқ.',
  Korean: '질문을 생성할만한 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai ģenerētu jautājumus.',
  Lithuanian: 'Deja, nepakanka duomenų klausimams generuoti.',
  Macedonian: 'За жал, нема доволно податоци за генерирање прашања.',
  Malay: 'Malangnya, tidak ada data yang mencukupi untuk menghasilkan soalan.',
  Maori: 'Aroha mai, kāore he ōrite mō ngā pātai.',
  Marathi: 'दुर्दैवाने प्रश्न तयार करण्यासाठी पुरेसे डेटा नाही.',
  Nepali: 'दुर्भाग्यवश प्रश्नहरू उत्पन्न गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å generere spørsmål.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਸਵਾਲ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਸਵਾਲ ਤਿਆਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian: 'متاسفانه داده کافی برای ایجاد سوالات موجود نیست.',
  Polish: 'Niestety nie ma wystarczająco danych, aby wygenerować pytania.',
  Portuguese: 'Infelizmente, não há dados suficientes para gerar perguntas.',
  Romanian: 'Din păcate, nu există suficiente date pentru a genera întrebări.',
  Russian: 'К сожалению, недостаточно данных для создания вопросов.',
  Serbian: 'Нажалост, нема довољно података за генерисање питања.',
  Slovak: 'Bohužiaľ, nie sú k dispozícii dostatočné údaje na generovanie otázok.',
  Slovenian: 'Na žalost ni dovolj podatkov za generiranje vprašanj.',
  Spanish: 'Desafortunadamente, no hay suficientes datos para generar preguntas.',
  Swahili: 'Kwa bahati mbaya hakuna data ya kutosha ya kuzalisha maswali.',
  Swedish: 'Tyvärr finns det inte tillräckligt med data för att generera frågor.',
  Tagalog: 'Sa kasamaang-palad, hindi sapat ang data upang makabuo ng mga tanong.',
  Tamil: 'இந்த கேள்விகளை உருவாக்க போதுமான தரவு இல்லை.',
  Telugu: 'దురదృష్టవశాత్తు ప్రశ్నలను రూపొందించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะสร้างคำถาม',
  Turkish: 'Maalesef, bu sorular için yeterli veri yok.',
  Ukrainian: 'На жаль, недостатньо даних для створення питань.',
  Urdu: 'افسوس کہ سوالات تیار کرنے کے لئے کافی ڈیٹا نہیں ہے۔',
  Uzbek: "Afsuski, savollar yaratish uchun yetarli ma'lumot yo'q.",
  Vietnamese: 'Rất tiếc, không có đủ dữ liệu để tạo ra câu hỏi.',
  Welsh: 'Yn anffodus, nid oes digon o ddata i greu cwestiynau.',
};

export const translateVoiceOfTheCustomer: Translation = {
  Afrikaans: 'In Hul Eie Woorde',
  Amharic: 'በራሳቸው ቃላት',
  Arabic: 'بكلماتهم الخاصة',
  Armenian: 'Իրենց իսկ խոսքերով',
  Azerbaijani: 'Öz sözləri ilə',
  Belarusian: 'Іх уласнымі словамі',
  Bengali: 'তাদের নিজের ভাষায়',
  Bosnian: 'Njihovim vlastitim riječima',
  Bulgarian: 'С техните собствени думи',
  Cantonese: '佢哋嘅原話',
  Catalan: 'En les seves pròpies paraules',
  Chinese: '用他们自己的话',
  'Chinese (Traditional)': '用他們自己的話',
  Croatian: 'Njihovim vlastitim riječima',
  Czech: 'Jejich vlastními slovy',
  Danish: 'Med deres egne ord',
  Dutch: 'In Hun Eigen Woorden',
  English: 'In Their Own Words',
  Estonian: 'Nende endi sõnadega',
  Finnish: 'Heidän omin sanoin',
  French: 'Dans leurs propres mots',
  Galician: 'Nas súas propias palabras',
  Georgian: 'მათივე სიტყვებით',
  German: 'In ihren eigenen Worten',
  Greek: 'Με τα δικά τους λόγια',
  Hebrew: 'במילים שלהם',
  Hindi: 'उनके अपने शब्दों में',
  Hungarian: 'Saját szavaikkal',
  Icelandic: 'Með þeirra eigin orðum',
  Indonesian: 'Dalam Kata-Kata Mereka Sendiri',
  Italian: 'Con parole loro',
  Japanese: '彼ら自身の言葉で',
  Kannada: 'ಅವರ ಸ್ವಂತ ಮಾತುಗಳಲ್ಲಿ',
  Kazakh: 'Олардың өз сөздерімен',
  Korean: '그들 자신의 말로',
  Latvian: 'Viņu pašu vārdiem',
  Lithuanian: 'Jų pačių žodžiais',
  Macedonian: 'Со нивни сопствени зборови',
  Malay: 'Dalam Kata-Kata Mereka Sendiri',
  Maori: 'I ā rātou ake kupu',
  Marathi: 'त्यांच्याच शब्दांत',
  Nepali: 'तिनीहरूकै शब्दमा',
  Norwegian: 'Med deres egne ord',
  Panjabi: 'ਉਹਨਾਂ ਦੇ ਆਪਣੇ ਸ਼ਬਦਾਂ ਵਿੱਚ',
  Punjabi: 'ਉਹਨਾਂ ਦੇ ਆਪਣੇ ਸ਼ਬਦਾਂ ਵਿੱਚ',
  Persian: 'به زبان خودشان',
  Polish: 'Ich własnymi słowami',
  Portuguese: 'Nas Suas Próprias Palavras',
  Romanian: 'În propriile lor cuvinte',
  Russian: 'Их собственными словами',
  Serbian: 'Њиховим сопственим речима',
  Slovak: 'Ich vlastnými slovami',
  Slovenian: 'Z njihovimi lastnimi besedami',
  Spanish: 'En Sus Propias Palabras',
  Swahili: 'Kwa Maneno Yao Wenyewe',
  Swedish: 'Med deras egna ord',
  Tagalog: 'Sa Kanilang Sariling Salita',
  Tamil: 'அவர்களின் சொந்த வார்த்தைகளில்',
  Telugu: 'వారి సొంత మాటల్లో',
  Thai: 'ในคำพูดของพวกเขาเอง',
  Turkish: 'Kendi Sözleriyle',
  Ukrainian: 'Їхніми власними словами',
  Urdu: 'ان کے اپنے الفاظ میں',
  Uzbek: "O'z so'zlari bilan",
  Vietnamese: 'Theo lời của chính họ',
  Welsh: 'Yn eu geiriau eu hunain',
};

export const translateKeyFindings: Translation = {
  Afrikaans: 'Belangrikste Bevindinge',
  Amharic: 'ዋና ዋና ግኝቶች',
  Arabic: 'النتائج الرئيسية',
  Armenian: 'Հիմնական Բացահայտումներ',
  Azerbaijani: 'Əsas Tapıntılar',
  Belarusian: 'Ключавыя Высновы',
  Bengali: 'মূল আবিষ্কারসমূহ',
  Bosnian: 'Ključni Nalazi',
  Bulgarian: 'Ключови Открития',
  Cantonese: '主要發現',
  Catalan: 'Conclusions Clau',
  Chinese: '主要发现',
  'Chinese (Traditional)': '主要發現',
  Croatian: 'Ključni Nalazi',
  Czech: 'Klíčová Zjištění',
  Danish: 'Centrale Fund',
  Dutch: 'Belangrijkste Bevindingen',
  English: 'Key Findings',
  Estonian: 'Peamised Leiud',
  Finnish: 'Tärkeimmät Havainnot',
  French: 'Principales Conclusions',
  Galician: 'Conclusións Clave',
  Georgian: 'მთავარი დასკვნები',
  German: 'Wichtigste Erkenntnisse',
  Greek: 'Βασικά Ευρήματα',
  Hebrew: 'ממצאים עיקריים',
  Hindi: 'मुख्य निष्कर्ष',
  Hungarian: 'Főbb Megállapítások',
  Icelandic: 'Helstu Niðurstöður',
  Indonesian: 'Temuan Utama',
  Italian: 'Risultati Principali',
  Japanese: '主な発見',
  Kannada: 'ಪ್ರಮುಖ ಸಂಶೋಧನೆಗಳು',
  Kazakh: 'Негізгі Тұжырымдар',
  Korean: '주요 발견',
  Latvian: 'Galvenie Atklājumi',
  Lithuanian: 'Pagrindiniai Atradimai',
  Macedonian: 'Клучни Наоди',
  Malay: 'Penemuan Utama',
  Maori: 'Ngā Kitenga Matua',
  Marathi: 'मुख्य निष्कर्ष',
  Nepali: 'मुख्य निष्कर्षहरू',
  Norwegian: 'Viktige Funn',
  Panjabi: 'ਮੁੱਖ ਖੋਜਾਂ',
  Punjabi: 'ਮੁੱਖ ਖੋਜਾਂ',
  Persian: 'یافته‌های کلیدی',
  Polish: 'Kluczowe Ustalenia',
  Portuguese: 'Principais Descobertas',
  Romanian: 'Concluzii Cheie',
  Russian: 'Ключевые Выводы',
  Serbian: 'Кључни Налази',
  Slovak: 'Kľúčové Zistenia',
  Slovenian: 'Ključne Ugotovitve',
  Spanish: 'Hallazgos Clave',
  Swahili: 'Matokeo Muhimu',
  Swedish: 'Viktigaste Resultat',
  Tagalog: 'Mga Pangunahing Natuklasan',
  Tamil: 'முக்கிய கண்டுபிடிப்புகள்',
  Telugu: 'ముఖ్య ఫలితాలు',
  Thai: 'ผลการค้นพบหลัก',
  Turkish: 'Temel Bulgular',
  Ukrainian: 'Ключові Висновки',
  Urdu: 'اہم نتائج',
  Uzbek: 'Asosiy Topilmalar',
  Vietnamese: 'Những Phát Hiện Chính',
  Welsh: 'Canfyddiadau Allweddol',
};

export const translateVisualEvidence: Translation = {
  Afrikaans: 'Visuele Bewys',
  Amharic: 'የእይታ ማስረጃ',
  Arabic: 'الدليل البصري',
  Armenian: 'Տեսողական Ապացույց',
  Azerbaijani: 'Vizual Sübut',
  Belarusian: 'Візуальны Доказ',
  Bengali: 'দৃশ্যমান প্রমাণ',
  Bosnian: 'Vizualni Dokaz',
  Bulgarian: 'Визуални Доказателства',
  Cantonese: '視覺證據',
  Catalan: 'Evidència Visual',
  Chinese: '视觉证据',
  'Chinese (Traditional)': '視覺證據',
  Croatian: 'Vizualni Dokaz',
  Czech: 'Vizuální Důkaz',
  Danish: 'Visuelt Bevis',
  Dutch: 'Visueel Bewijs',
  English: 'Visual Evidence',
  Estonian: 'Visuaalne Tõend',
  Finnish: 'Visuaalinen Todiste',
  French: 'Preuves Visuelles',
  Galician: 'Evidencia Visual',
  Georgian: 'ვიზუალური მტკიცებულება',
  German: 'Visueller Beweis',
  Greek: 'Οπτικά Στοιχεία',
  Hebrew: 'עדות חזותית',
  Hindi: 'दृश्य प्रमाण',
  Hungarian: 'Vizuális Bizonyíték',
  Icelandic: 'Sjónrænt Sönnunargagn',
  Indonesian: 'Bukti Visual',
  Italian: 'Prove Visive',
  Japanese: '視覚的証拠',
  Kannada: 'ದೃಶ್ಯ ಸಾಕ್ಷ್ಯ',
  Kazakh: 'Көрнекі Дәлел',
  Korean: '시각적 증거',
  Latvian: 'Vizuālie Pierādījumi',
  Lithuanian: 'Vizualiniai Įrodymai',
  Macedonian: 'Визуелни Докази',
  Malay: 'Bukti Visual',
  Maori: 'Taunakitanga Ataata',
  Marathi: 'दृश्य पुरावा',
  Nepali: 'दृश्य प्रमाण',
  Norwegian: 'Visuelt Bevis',
  Panjabi: 'ਦ੍ਰਿਸ਼ਟੀਗਤ ਸਬੂਤ',
  Punjabi: 'ਦ੍ਰਿਸ਼ਟੀਗਤ ਸਬੂਤ',
  Persian: 'شواهد بصری',
  Polish: 'Dowody Wizualne',
  Portuguese: 'Evidências Visuais',
  Romanian: 'Dovezi Vizuale',
  Russian: 'Визуальные Доказательства',
  Serbian: 'Визуелни Докази',
  Slovak: 'Vizuálny Dôkaz',
  Slovenian: 'Vizualni Dokaz',
  Spanish: 'Evidencia Visual',
  Swahili: 'Ushahidi wa Kuona',
  Swedish: 'Visuella Bevis',
  Tagalog: 'Visual na Katibayan',
  Tamil: 'காட்சி சான்று',
  Telugu: 'దృశ్య ఆధారాలు',
  Thai: 'หลักฐานภาพ',
  Turkish: 'Görsel Kanıt',
  Ukrainian: 'Візуальні Докази',
  Urdu: 'بصری ثبوت',
  Uzbek: 'Vizual Dalillar',
  Vietnamese: 'Bằng Chứng Hình Ảnh',
  Welsh: 'Tystiolaeth Weledol',
};

export const translateThemesAndOpportunities: Translation = {
  Afrikaans: 'Temas & Geleenthede',
  Amharic: 'ጭብጦች እና ዕድሎች',
  Arabic: 'المواضيع والفرص',
  Armenian: 'Թեմաներ և Հنарavorelatumner',
  Azerbaijani: 'Mövzular və İmkanlar',
  Belarusian: 'Тэмы і Магчымасці',
  Bengali: 'বিষয়বস্তু ও সুযোগ',
  Bosnian: 'Teme i Prilike',
  Bulgarian: 'Теми и Възможности',
  Cantonese: '主題與機會',
  Catalan: 'Temes i Oportunitats',
  Chinese: '主题与机会',
  'Chinese (Traditional)': '主題與機會',
  Croatian: 'Teme i Prilike',
  Czech: 'Témata a Příležitosti',
  Danish: 'Temaer og Muligheder',
  Dutch: "Thema's & Kansen",
  English: 'Themes & Opportunities',
  Estonian: 'Teemad ja Võimalused',
  Finnish: 'Teemat ja Mahdollisuudet',
  French: 'Thèmes & Opportunités',
  Galician: 'Temas e Oportunidades',
  Georgian: 'თემები და შესაძლებლობები',
  German: 'Themen & Chancen',
  Greek: 'Θέματα και Ευκαιρίες',
  Hebrew: 'נושאים והזדמנויות',
  Hindi: 'विषय और अवसर',
  Hungarian: 'Témák és Lehetőségek',
  Icelandic: 'Þemu og Tækifæri',
  Indonesian: 'Tema & Peluang',
  Italian: 'Temi e Opportunità',
  Japanese: 'テーマと機会',
  Kannada: 'ವಿಷಯಗಳು ಮತ್ತು ಅವಕಾಶಗಳು',
  Kazakh: 'Тақырыптар мен Мүмкіндіктер',
  Korean: '주제 및 기회',
  Latvian: 'Tēmas un Iespējas',
  Lithuanian: 'Temos ir Galimybės',
  Macedonian: 'Теми и Можности',
  Malay: 'Tema & Peluang',
  Maori: 'Ngā Kaupapa me ngā Tauhokohoko',
  Marathi: 'थीम्स आणि संधी',
  Nepali: 'विषयवस्तु र अवसरहरू',
  Norwegian: 'Temaer og Muligheter',
  Panjabi: 'ਵਿਸ਼ੇ ਅਤੇ ਮੌਕੇ',
  Punjabi: 'ਵਿਸ਼ੇ ਅਤੇ ਮੌਕੇ',
  Persian: 'موضوعات و فرصت‌ها',
  Polish: 'Tematy i Możliwości',
  Portuguese: 'Temas e Oportunidades',
  Romanian: 'Teme și Oportunități',
  Russian: 'Темы и Возможности',
  Serbian: 'Теме и Прилике',
  Slovak: 'Témy a Príležitosti',
  Slovenian: 'Teme in Priložnosti',
  Spanish: 'Temas y Oportunidades',
  Swahili: 'Mada na Fursa',
  Swedish: 'Teman och Möjligheter',
  Tagalog: 'Mga Tema at Pagkakataon',
  Tamil: 'தொகுப்புகள் மற்றும் வாயில்கள்',
  Telugu: 'థీమ్‌లు & అవకాశాలు',
  Thai: 'หัวข้อและโอกาส',
  Turkish: 'Temalar ve Fırsatlar',
  Ukrainian: 'Теми і Можливості',
  Urdu: 'موضوعات اور مواقع',
  Uzbek: 'Mavzular va Imkoniyatlar',
  Vietnamese: 'Chủ Đề và Cơ Hội',
  Welsh: 'Themâu a Chyfleoedd',
};

export const translateNotableVisuals: Translation = {
  Afrikaans: 'Opvallende Beelde',
  Amharic: 'ጉልህ የሆኑ ምስሎች',
  Arabic: 'مرئيات بارزة',
  Armenian: 'Նշանավոր Տեսողական Նյութեր',
  Azerbaijani: 'Diqqətəlayiq Görsəllər',
  Belarusian: 'Прыкметныя Візуалы',
  Bengali: 'উল্লেখযোগ্য দৃশ্যমান উপাদান',
  Bosnian: 'Značajni Vizuali',
  Bulgarian: 'Забележителни Визуали',
  Cantonese: '值得注意的視覺內容',
  Catalan: 'Visuals Destacats',
  Chinese: '值得注意的视觉内容',
  'Chinese (Traditional)': '值得注意的視覺內容',
  Croatian: 'Značajni Vizuali',
  Czech: 'Pozoruhodné Vizuály',
  Danish: 'Bemærkelsesværdige Visuals',
  Dutch: 'Opvallende Beelden',
  English: 'Notable Visuals',
  Estonian: 'Tähelepanuväärsed Visuaalid',
  Finnish: 'Merkittävät Visuaalit',
  French: 'Visuels Remarquables',
  Galician: 'Visuais Destacados',
  Georgian: 'გამორჩეული ვიზუალები',
  German: 'Bemerkenswerte Visuals',
  Greek: 'Αξιόλογα Οπτικά',
  Hebrew: 'חזותיים בולטים',
  Hindi: 'उल्लेखनीय दृश्य',
  Hungarian: 'Figyelemre Méltó Vizuálok',
  Icelandic: 'Áberandi Myndefni',
  Indonesian: 'Visual yang Patut Diperhatikan',
  Italian: 'Elementi Visivi Notevoli',
  Japanese: '注目すべきビジュアル',
  Kannada: 'ಗಮನಾರ್ಹ ದೃಶ್ಯಗಳು',
  Kazakh: 'Айқын Визуалдар',
  Korean: '주목할 만한 시각 자료',
  Latvian: 'Ievērojamie Vizuālie Materiāli',
  Lithuanian: 'Pažymėtini Vaizdiniai',
  Macedonian: 'Значajни Визуели',
  Malay: 'Visual Ketara',
  Maori: 'Ngā Ataata Rongonui',
  Marathi: 'उल्लेखनीय दृश्ये',
  Nepali: 'उल्लेखनीय दृश्यहरू',
  Norwegian: 'Merkeverdige Bilder',
  Panjabi: 'ਧਿਆਨਯੋਗ ਦ੍ਰਿਸ਼',
  Punjabi: 'ਧਿਆਨਯੋਗ ਦ੍ਰਿਸ਼',
  Persian: 'تصاویر بارز',
  Polish: 'Znaczące Wizualizacje',
  Portuguese: 'Visuais Notáveis',
  Romanian: 'Elemente Vizuale Notabile',
  Russian: 'Примечательные Визуалы',
  Serbian: 'Значajни Визуели',
  Slovak: 'Pozoruhodné Vizuály',
  Slovenian: 'Opazni Vizuali',
  Spanish: 'Elementos Visuales Notables',
  Swahili: 'Picha Zinazovutia',
  Swedish: 'Anmärkningsvärda Bilder',
  Tagalog: 'Mga Kapansin-pansing Visual',
  Tamil: 'குறிப்பிடத்தக்க காட்சிகள்',
  Telugu: 'గుర్తించదగిన దృశ్యాలు',
  Thai: 'ภาพที่น่าสังเกต',
  Turkish: 'Dikkat Çekici Görseller',
  Ukrainian: 'Помітні Візуали',
  Urdu: 'قابل ذکر بصری',
  Uzbek: 'Diqqatga Sazovor Vizuallar',
  Vietnamese: 'Hình Ảnh Đáng Chú Ý',
  Welsh: 'Delweddau Nodedig',
};

export const translateRecommendations: Translation = {
  Afrikaans: 'Aanbevelings',
  Amharic: 'ምክሮች',
  Arabic: 'التوصيات',
  Armenian: 'Հանձնարարականներ',
  Azerbaijani: 'Tövsiyələr',
  Belarusian: 'Рэкамендацыі',
  Bengali: 'সুপারিশসমূহ',
  Bosnian: 'Preporuke',
  Bulgarian: 'Препоръки',
  Cantonese: '建議',
  Catalan: 'Recomanacions',
  Chinese: '建议',
  'Chinese (Traditional)': '建議',
  Croatian: 'Preporuke',
  Czech: 'Doporučení',
  Danish: 'Anbefalinger',
  Dutch: 'Aanbevelingen',
  English: 'Recommendations',
  Estonian: 'Soovitused',
  Finnish: 'Suositukset',
  French: 'Recommandations',
  Galician: 'Recomendacións',
  Georgian: 'რეკომენდაციები',
  German: 'Empfehlungen',
  Greek: 'Συστάσεις',
  Hebrew: 'המלצות',
  Hindi: 'सिफारिशें',
  Hungarian: 'Ajánlások',
  Icelandic: 'Tillögur',
  Indonesian: 'Rekomendasi',
  Italian: 'Raccomandazioni',
  Japanese: '推奨事項',
  Kannada: 'ಶಿಫಾರಸುಗಳು',
  Kazakh: 'Ұсыныстар',
  Korean: '권장 사항',
  Latvian: 'Ieteikumi',
  Lithuanian: 'Rekomendacijos',
  Macedonian: 'Препораки',
  Malay: 'Cadangan',
  Maori: 'Ngā Tūtohu',
  Marathi: 'शिफारशी',
  Nepali: 'सिफारिसहरू',
  Norwegian: 'Anbefalinger',
  Panjabi: 'ਸਿਫ਼ਾਰਸ਼ਾਂ',
  Punjabi: 'ਸਿਫ਼ਾਰਸ਼ਾਂ',
  Persian: 'توصیه‌ها',
  Polish: 'Rekomendacje',
  Portuguese: 'Recomendações',
  Romanian: 'Recomandări',
  Russian: 'Рекомендации',
  Serbian: 'Препоруке',
  Slovak: 'Odporúčania',
  Slovenian: 'Priporočila',
  Spanish: 'Recomendaciones',
  Swahili: 'Mapendekezo',
  Swedish: 'Rekommendationer',
  Tagalog: 'Mga Rekomendasyon',
  Tamil: 'பரிந்துரைகள்',
  Telugu: 'సిఫార్సులు',
  Thai: 'คำแนะนำ',
  Turkish: 'Öneriler',
  Ukrainian: 'Рекомендації',
  Urdu: 'سفارشات',
  Uzbek: 'Tavsiyalar',
  Vietnamese: 'Khuyến Nghị',
  Welsh: 'Argymhellion',
};

export const translateResponses: Translation = {
  Afrikaans: 'Antwoorde',
  Amharic: 'ምላሾች',
  Arabic: 'الردود',
  Armenian: 'Պատասխաններ',
  Azerbaijani: 'Cavablar',
  Belarusian: 'Адказы',
  Bengali: 'প্রতিক্রিয়াসমূহ',
  Bosnian: 'Odgovori',
  Bulgarian: 'Отговори',
  Cantonese: '回應',
  Catalan: 'Respostes',
  Chinese: '回答',
  'Chinese (Traditional)': '回應',
  Croatian: 'Odgovori',
  Czech: 'Odpovědi',
  Danish: 'Svar',
  Dutch: 'Antwoorden',
  English: 'Responses',
  Estonian: 'Vastused',
  Finnish: 'Vastaukset',
  French: 'Réponses',
  Galician: 'Respostas',
  Georgian: 'პასუხები',
  German: 'Antworten',
  Greek: 'Απαντήσεις',
  Hebrew: 'תגובות',
  Hindi: 'प्रतिक्रियाएं',
  Hungarian: 'Válaszok',
  Icelandic: 'Svör',
  Indonesian: 'Respons',
  Italian: 'Risposte',
  Japanese: '回答',
  Kannada: 'ಪ್ರತಿಕ್ರಿಯೆಗಳು',
  Kazakh: 'Жауаптар',
  Korean: '응답',
  Latvian: 'Atbildes',
  Lithuanian: 'Atsakymai',
  Macedonian: 'Одговори',
  Malay: 'Respons',
  Maori: 'Ngā Whakautu',
  Marathi: 'प्रतिसाद',
  Nepali: 'प्रतिक्रियाहरू',
  Norwegian: 'Svar',
  Panjabi: 'ਜਵਾਬ',
  Punjabi: 'ਜਵਾਬ',
  Persian: 'پاسخ‌ها',
  Polish: 'Odpowiedzi',
  Portuguese: 'Respostas',
  Romanian: 'Răspunsuri',
  Russian: 'Ответы',
  Serbian: 'Одговори',
  Slovak: 'Odpovede',
  Slovenian: 'Odgovori',
  Spanish: 'Respuestas',
  Swahili: 'Majibu',
  Swedish: 'Svar',
  Tagalog: 'Mga Tugon',
  Tamil: 'பதில்கள்',
  Telugu: 'సమాధానాలు',
  Thai: 'คำตอบ',
  Turkish: 'Yanıtlar',
  Ukrainian: 'Відповіді',
  Urdu: 'جوابات',
  Uzbek: 'Javoblar',
  Vietnamese: 'Phản Hồi',
  Welsh: 'Ymatebion',
};

export const translateRespondentMedia: Translation = {
  Afrikaans: 'Respondentmedia',
  Amharic: 'የምላሽ ሰጪ ሚዲያ',
  Arabic: 'وسائط المستجيب',
  Armenian: 'Հartsvoghji Media',
  Azerbaijani: 'Respondent Medyası',
  Belarusian: 'Медыя Рэспандэнта',
  Bengali: 'উত্তরদাতার মিডিয়া',
  Bosnian: 'Mediji Ispitanika',
  Bulgarian: 'Медия на Респондента',
  Cantonese: '受訪者媒體',
  Catalan: 'Mitjans del Respondent',
  Chinese: '受访者媒体',
  'Chinese (Traditional)': '受訪者媒體',
  Croatian: 'Mediji Ispitanika',
  Czech: 'Média Respondenta',
  Danish: 'Respondentmedier',
  Dutch: 'Respondentmedia',
  English: 'Respondent Media',
  Estonian: 'Vastaja Meedia',
  Finnish: 'Vastaajan Media',
  French: 'Médias du Répondant',
  Galician: 'Medios do Respondente',
  Georgian: 'გამომხდომის მედია',
  German: 'Medien des Befragten',
  Greek: 'Μέσα Ερωτηθέντος',
  Hebrew: 'מדיה של המשיב',
  Hindi: 'उत्तरदाता मीडिया',
  Hungarian: 'Válaszadó Médiája',
  Icelandic: 'Miðlar Þátttakanda',
  Indonesian: 'Media Responden',
  Italian: 'Media del Rispondente',
  Japanese: '回答者のメディア',
  Kannada: 'ಉತ್ತರದಾತರ ಮಾಧ್ಯಮ',
  Kazakh: 'Респондент Медиасы',
  Korean: '응답자 미디어',
  Latvian: 'Respondenta Mediji',
  Lithuanian: 'Respondento Medija',
  Macedonian: 'Медиуми на Испитаникот',
  Malay: 'Media Responden',
  Maori: 'Pāpāho a te Kaiurupare',
  Marathi: 'उत्तरदात्याचे मीडिया',
  Nepali: 'उत्तरदाताको मिडिया',
  Norwegian: 'Respondentens Medier',
  Panjabi: 'ਉੱਤਰਦਾਤਾ ਮੀਡੀਆ',
  Punjabi: 'ਉੱਤਰਦਾਤਾ ਮੀਡੀਆ',
  Persian: 'رسانه‌های پاسخ‌دهنده',
  Polish: 'Media Respondenta',
  Portuguese: 'Mídia do Respondente',
  Romanian: 'Media Respondentului',
  Russian: 'Медиа Респондента',
  Serbian: 'Медији Испитаника',
  Slovak: 'Médiá Respondenta',
  Slovenian: 'Mediji Anketiranca',
  Spanish: 'Medios del Respondente',
  Swahili: 'Vyombo vya Mhojiwa',
  Swedish: 'Respondentens Medier',
  Tagalog: 'Media ng Respondent',
  Tamil: 'பதிலளிப்பவர் ஊடகம்',
  Telugu: 'పాల్గొనేవారి మీడియా',
  Thai: 'สื่อของผู้ตอบ',
  Turkish: 'Katılımcı Medyası',
  Ukrainian: 'Медіа Респондента',
  Urdu: 'جواب دہندہ کا میڈیا',
  Uzbek: 'Respondent Mediyasi',
  Vietnamese: 'Phương Tiện của Người Trả Lời',
  Welsh: "Cyfryngau'r Ymatebydd",
};

export const translateNoDivergentViewsData: Translation = {
  Afrikaans:
    'Ongelukkig is daar nie genoeg data om afwykende menings uit die onderhoude te wys nie.',
  Amharic: 'አሳዛኝ ሆኖ ከቃለ-ምልልሶቹ ተቃራኒ አስተያየቶችን ለማሳየት በቂ ውሂብ የለም።',
  Arabic: 'للأسف ليس هناك ما يكفي من البيانات لعرض وجهات النظر المتباينة من المقابلات.',
  Armenian:
    'Yfavok, chart bavarar tvyalner chkan ts ucats anel tarbervogh tesaktetter harts azruycts.',
  Azerbaijani:
    'Təəssüf ki, müsahibələrdən fərqli baxışları göstərmək üçün kifayət qədər məlumat yoxdur.',
  Belarusian: "Na zhal, nedastaткова dadzenykh, kab pakazats' roznyya dumki z intervyuw.",
  Bengali: 'দুর্ভাগ্যক্রমে, সাক্ষাৎকার থেকে ভিন্নমতামত প্রদর্শন করতে পর্যাপ্ত ডেটা নেই।',
  Bosnian: 'Nažalost, nema dovoljno podataka za prikaz divergentnih mišljenja iz intervjua.',
  Bulgarian:
    'Za sazhalenie, nyama dostatachno danni, za da pokazhim razlichavashtite se mneniya ot intervyuta.',
  Cantonese: '非常抱歉，沒有足夠的數據來顯示訪談中的分歧觀點。',
  Catalan:
    'Desafortunadament, no hi ha prou dades per mostrar punts de vista divergents de les entrevistes.',
  Chinese: '很抱歉，没有足够的数据来显示访谈中的分歧观点。',
  'Chinese (Traditional)': '非常抱歉，沒有足夠的數據來顯示訪談中的分歧觀點。',
  Croatian: 'Nažalost, nema dovoljno podataka za prikaz divergentnih mišljenja iz intervjua.',
  Czech: 'Omlouváme se, ale k zobrazení odlišných názorů z rozhovorů není dostatek dat.',
  Danish:
    'Desværre er der ikke tilstrækkelige data til at vise divergerende synspunkter fra interviews.',
  Dutch: 'Helaas zijn er niet genoeg gegevens om afwijkende meningen uit de interviews te tonen.',
  English:
    'Unfortunately, there is not enough data to display divergent views from the interviews.',
  Estonian: 'Kahjuks pole piisavalt andmeid, et näidata erinevaid arvamusi intervjuudest.',
  Finnish:
    'Valitettavasti haastatteluista ei ole tarpeeksi tietoja eriävien mielipiteiden näyttämiseksi.',
  French:
    "Malheureusement, il n'y a pas assez de données pour afficher des points de vue divergents des entretiens.",
  Galician:
    'Desafortunadamente, non hai suficientes datos para mostrar puntos de vista diverxentes das entrevistas.',
  Georgian:
    'სამწუხაროდ, ინტერვიუებიდან განსხვავებული შეხედულებების საჩვენებლად საკმარისი მონაცემები არ არის.',
  German:
    'Leider liegen nicht genügend Daten vor, um abweichende Ansichten aus den Interviews anzuzeigen.',
  Greek:
    'Δυστυχώς δεν υπάρχουν αρκετά δεδομένα για να εμφανιστούν αντικρουόμενες απόψεις από τις συνεντεύξεις.',
  Hebrew: 'לצערנו אין מספיק נתונים להצגת דעות שונות מהראיונות.',
  Hindi: 'दुर्भाग्यवश, साक्षात्कारों से भिन्न दृष्टिकोण दिखाने के लिए पर्याप्त डेटा नहीं है।',
  Hungarian: 'Sajnos nincs elég adat az interjúkból származó eltérő vélemények megjelenítéséhez.',
  Icelandic: 'Því miður eru ekki nægjanleg gögn til að sýna ólík viðhorf frá viðtölum.',
  Indonesian:
    'Sayangnya, tidak ada cukup data untuk menampilkan pandangan yang berbeda dari wawancara.',
  Italian:
    'Purtroppo non ci sono abbastanza dati per mostrare punti di vista divergenti dalle interviste.',
  Japanese: '残念ながら、インタビューから異なる見解を表示するのに十分なデータがありません。',
  Kannada:
    'Durbhagyavasha, sandarshanagalinda vibhinna drishtikonagalannu torisalu sakastu data illa.',
  Kazakh:
    'Okinishke oray, intervyulardan qarama-qarsy kozqarastardi korsetw ushin zheterlikti derekter zhok.',
  Korean: '죄송하지만 인터뷰에서 다양한 관점을 표시할 데이터가 충분하지 않습니다.',
  Latvian: 'Diemžēl nav pietiekami daudz datu, lai parādītu atšķirīgus viedokļus no intervijām.',
  Lithuanian: 'Deja, nepakanka duomenų skirtingiems požiūriams iš interviu rodyti.',
  Macedonian:
    'Za zhal, nema dovolno podatoci za prikažuvanje na razlichni mislenja od intervjuata.',
  Malay:
    'Malangnya, tidak ada data yang mencukupi untuk memaparkan pandangan berbeza daripada temu ramah.',
  Maori: 'Aroha mai, kaore he orite mo te whakaatu i nga tirohanga rereke mai i nga uiuinga.',
  Marathi: 'Durdaivane, mulaakhatimsdhun bhinn mate darshavisaathi purse data nahi.',
  Nepali: 'दुर्भाग्यवश, अन्तर्वार्ताबाट भिन्न दृष्टिकोणहरू प्रदर्शन गर्न पर्याप्त डेटा छैन।',
  Norwegian: 'Dessverre er det ikke nok data til å vise divergerende synspunkter fra intervjuene.',
  Panjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਵੱਖਰੇ ਵਿਚਾਰ ਦਿਖਾਉਣ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Punjabi: 'ਬਦਕਿਸਮਤੀ ਨਾਲ, ਇੰਟਰਵਿਊਆਂ ਤੋਂ ਵੱਖਰੇ ਵਿਚਾਰ ਦਿਖਾਉਣ ਲਈ ਕਾਫ਼ੀ ਡੇਟਾ ਨਹੀਂ ਹੈ।',
  Persian:
    'Matasefane dade kafi baraye namayesh didgah hay motafavot az mosahebe ha vojod nadarad.',
  Polish: 'Niestety nie ma wystarczająco danych, aby pokazać rozbieżne poglądy z wywiadów.',
  Portuguese:
    'Infelizmente, não há dados suficientes para exibir pontos de vista divergentes das entrevistas.',
  Romanian:
    'Din păcate, nu există suficiente date pentru a afișa puncte de vedere divergente din interviuri.',
  Russian:
    'K sozhaleniyu, nedostatochno dannykh dlya otobrazheniya raskhodiashchikhsya mnenii iz intervyu.',
  Serbian: 'Nazhalost, nema dovoljno podataka za prikazivanje razlichitikh misljenja iz intervjua.',
  Slovak:
    'Bohužiaľ, nie sú k dispozícii dostatočné údaje na zobrazenie rozdielnych názorov z rozhovorov.',
  Slovenian: 'Na žalost ni dovolj podatkov za prikaz različnih mnenj iz intervjujev.',
  Spanish:
    'Desafortunadamente, no hay suficientes datos para mostrar puntos de vista divergentes de las entrevistas.',
  Swahili:
    'Kwa bahati mbaya hakuna data ya kutosha kuonyesha mitazamo tofauti kutoka kwa mahojiano.',
  Swedish:
    'Tyvärr finns det inte tillräckligt med data för att visa avvikande åsikter från intervjuerna.',
  Tagalog:
    'Sa kasamaang-palad, hindi sapat ang data upang ipakita ang magkakaibang pananaw mula sa mga panayam.',
  Tamil:
    'Duradirushtavasama, nerkaanalgalilirundu verapatta karuttukkalai kaata pothumana taravu illai.',
  Telugu: 'దురదృష్టవశాత్తు, ఇంటర్వ్యూల నుండి భిన్నాభిప్రాయాలను చూపించడానికి సరిపడా డేటా లేదు.',
  Thai: 'ขอโทษเราไม่มีข้อมูลเพียงพอที่จะแสดงมุมมองที่แตกต่างจากการสัมภาษณ์',
  Turkish: 'Maalesef, röportajlardan farklı görüşleri göstermek için yeterli veri yok.',
  Ukrainian: 'Na zhal, nedostatno danikh, shchob vidobraziti rizni dumki z intervyu.',
  Urdu: 'Afsos, muqabalon se mukhtalif khayalaat zahir karne ke liye kafi data nahin hai.',
  Uzbek: "Afsuski, intervyulardan turli xil qarashlarni ko'rsatish uchun yetarli ma'lumot yo'q.",
  Vietnamese:
    'Rất tiếc, không có đủ dữ liệu để hiển thị các quan điểm khác nhau từ các cuộc phỏng vấn.',
  Welsh: "Yn anffodus, nid oes digon o ddata i arddangos safbwyntiau gwahanol o'r cyfweliadau.",
};

export const translateFiltered: Translation = {
  Afrikaans: 'Gefilterde',
  Amharic: 'ተጣርቷል',
  Arabic: 'مصفى',
  Armenian: 'Filtrvats',
  Azerbaijani: 'Filtrlənmiş',
  Belarusian: 'Аdfiltraвany',
  Bengali: 'ফিল্টার করা হয়েছে',
  Bosnian: 'Filtrirano',
  Bulgarian: 'Филтрирано',
  Cantonese: '已篩選',
  Catalan: 'Filtrat',
  Chinese: '已筛选',
  'Chinese (Traditional)': '已篩選',
  Croatian: 'Filtrirano',
  Czech: 'Filtrováno',
  Danish: 'Filtreret',
  Dutch: 'Gefilterd',
  English: 'Filtered',
  Estonian: 'Filtreeritud',
  Finnish: 'Suodatettu',
  French: 'Filtré',
  Galician: 'Filtrado',
  Georgian: 'გაფილტრული',
  German: 'Gefiltert',
  Greek: 'Φιλτραρισμένο',
  Hebrew: 'מסונן',
  Hindi: 'फ़िल्टर किया गया',
  Hungarian: 'Szűrt',
  Icelandic: 'Síað',
  Indonesian: 'Difilter',
  Italian: 'Filtrato',
  Japanese: 'フィルター済み',
  Kannada: 'Filtar madalaagide',
  Kazakh: 'Suzilgen',
  Korean: '필터됨',
  Latvian: 'Filtrēts',
  Lithuanian: 'Filtruotas',
  Macedonian: 'Филтрирано',
  Malay: 'Ditapis',
  Maori: 'Tātaritia',
  Marathi: 'Filter kelele',
  Nepali: 'फिल्टर गरिएको',
  Norwegian: 'Filtrert',
  Panjabi: 'ਫਿਲਟਰ ਕੀਤਾ',
  Punjabi: 'ਫਿਲਟਰ ਕੀਤਾ',
  Persian: 'فیلتر شده',
  Polish: 'Przefiltrowane',
  Portuguese: 'Filtrado',
  Romanian: 'Filtrat',
  Russian: 'Отфильтровано',
  Serbian: 'Филтрирано',
  Slovak: 'Filtrované',
  Slovenian: 'Filtrirano',
  Spanish: 'Filtrado',
  Swahili: 'Imechujwa',
  Swedish: 'Filtrerat',
  Tagalog: 'Na-filter',
  Tamil: 'Vadikatpattatu',
  Telugu: 'ఫిల్టర్ చేయబడింది',
  Thai: 'กรองแล้ว',
  Turkish: 'Filtrelenmiş',
  Ukrainian: 'Vidfiltrovanо',
  Urdu: 'فلٹر شدہ',
  Uzbek: 'Filtrlangan',
  Vietnamese: 'Đã Lọc',
  Welsh: "Wedi'i Hidlo",
};

export const translateStatisticalComparison: Translation = {
  Afrikaans: 'Statistiese Vergelyking',
  Amharic: 'ስታቲስቲካዊ ንፅፅር',
  Arabic: 'المقارنة الإحصائية',
  Armenian: 'Վիճակագրական Համեմատություն',
  Azerbaijani: 'Statistik Müqayisə',
  Belarusian: 'Статыстычнае Параўнанне',
  Bengali: 'পরিসংখ্যানগত তুলনা',
  Bosnian: 'Statistička Usporedba',
  Bulgarian: 'Статистическо Сравнение',
  Cantonese: '統計比較',
  Catalan: 'Comparació Estadística',
  Chinese: '统计比较',
  'Chinese (Traditional)': '統計比較',
  Croatian: 'Statistička Usporedba',
  Czech: 'Statistické Srovnání',
  Danish: 'Statistisk Sammenligning',
  Dutch: 'Statistische Vergelijking',
  English: 'Statistical Comparison',
  Estonian: 'Statistiline Võrdlus',
  Finnish: 'Tilastollinen Vertailu',
  French: 'Comparaison Statistique',
  Galician: 'Comparación Estatística',
  Georgian: 'სტატისტიკური შედარება',
  German: 'Statistischer Vergleich',
  Greek: 'Στατιστική Σύγκριση',
  Hebrew: 'השוואה סטטיסטית',
  Hindi: 'सांख्यिकीय तुलना',
  Hungarian: 'Statisztikai Összehasonlítás',
  Icelandic: 'Tölfræðileg Samanburður',
  Indonesian: 'Perbandingan Statistik',
  Italian: 'Confronto Statistico',
  Japanese: '統計的比較',
  Kannada: 'ಅಂಕಿಅಂಶ ಹೋಲಿಕೆ',
  Kazakh: 'Статистикалық Салыстыру',
  Korean: '통계적 비교',
  Latvian: 'Statistiskais Salīdzinājums',
  Lithuanian: 'Statistinis Palyginimas',
  Macedonian: 'Статистичка Споредба',
  Malay: 'Perbandingan Statistik',
  Maori: 'Whakataurite Tauanga',
  Marathi: 'सांख्यिकीय तुलना',
  Nepali: 'सांख्यिक तुलना',
  Norwegian: 'Statistisk Sammenligning',
  Panjabi: 'ਅੰਕੜਾ ਤੁਲਨਾ',
  Punjabi: 'ਅੰਕੜਾ ਤੁਲਨਾ',
  Persian: 'مقایسه آماری',
  Polish: 'Porównanie Statystyczne',
  Portuguese: 'Comparação Estatística',
  Romanian: 'Comparație Statistică',
  Russian: 'Статистическое Сравнение',
  Serbian: 'Статистичко Поређење',
  Slovak: 'Štatistické Porovnanie',
  Slovenian: 'Statistična Primerjava',
  Spanish: 'Comparación Estadística',
  Swahili: 'Ulinganisho wa Takwimu',
  Swedish: 'Statistisk Jämförelse',
  Tagalog: 'Estadistikal na Paghahambing',
  Tamil: 'புள்ளிவிவர ஒப்பீடு',
  Telugu: 'గణాంక పోలిక',
  Thai: 'การเปรียบเทียบทางสถิติ',
  Turkish: 'İstatistiksel Karşılaştırma',
  Ukrainian: 'Статистичне Порівняння',
  Urdu: 'اعداد و شمار کا موازنہ',
  Uzbek: 'Statistik Taqqoslash',
  Vietnamese: 'So sánh Thống kê',
  Welsh: 'Cymhariaeth Ystadegol',
};

export const translateSampleProfiles: Translation = {
  Afrikaans: 'Steekproefprofiele',
  Amharic: 'የናሙና መገለጫዎች',
  Arabic: 'ملفات تعريف العينة',
  Armenian: 'Նմուշի Պրոֆիլներ',
  Azerbaijani: 'Nümunə Profilləri',
  Belarusian: 'Профілі Выбаркі',
  Bengali: 'নমুনা প্রোফাইল',
  Bosnian: 'Profili Uzorka',
  Bulgarian: 'Профили на Извадката',
  Cantonese: '樣本簡介',
  Catalan: 'Perfils de la Mostra',
  Chinese: '样本概况',
  'Chinese (Traditional)': '樣本概況',
  Croatian: 'Profili Uzorka',
  Czech: 'Profily Vzorku',
  Danish: 'Stikprøveprofiler',
  Dutch: 'Steekproefprofielen',
  English: 'Sample Profiles',
  Estonian: 'Valimi Profiilid',
  Finnish: 'Otoksen Profiilit',
  French: 'Profils des Échantillons',
  Galician: 'Perfís da Mostra',
  Georgian: 'ნიმუშის პროფილები',
  German: 'Stichprobenprofile',
  Greek: 'Προφίλ Δείγματος',
  Hebrew: 'פרופילי המדגם',
  Hindi: 'नमूना प्रोफाइल',
  Hungarian: 'Mintaprofilok',
  Icelandic: 'Sýnishornaprófílar',
  Indonesian: 'Profil Sampel',
  Italian: 'Profili del Campione',
  Japanese: 'サンプルプロフィール',
  Kannada: 'ಮಾದರಿ ಪ್ರೊಫೈಲ್‌ಗಳು',
  Kazakh: 'Үлгі Профильдері',
  Korean: '샘플 프로필',
  Latvian: 'Izlases Profili',
  Lithuanian: 'Imties Profiliai',
  Macedonian: 'Профили на Примерок',
  Malay: 'Profil Sampel',
  Maori: 'Ngā Kōtaha Tauira',
  Marathi: 'नमुना प्रोफाइल',
  Nepali: 'नमूना प्रोफाइलहरू',
  Norwegian: 'Utvalgsprofilier',
  Panjabi: 'ਨਮੂਨਾ ਪ੍ਰੋਫਾਈਲ',
  Punjabi: 'ਨਮੂਨਾ ਪ੍ਰੋਫਾਈਲ',
  Persian: 'پروفایل‌های نمونه',
  Polish: 'Profile Próby',
  Portuguese: 'Perfis da Amostra',
  Romanian: 'Profiluri de Eșantion',
  Russian: 'Профили Выборки',
  Serbian: 'Профили Узорка',
  Slovak: 'Profily Vzorky',
  Slovenian: 'Profili Vzorca',
  Spanish: 'Perfiles de Muestra',
  Swahili: 'Maelezo ya Sampuli',
  Swedish: 'Urvalsprofiler',
  Tagalog: 'Mga Profil ng Sample',
  Tamil: 'மாதிரி சுயவிவரங்கள்',
  Telugu: 'నమూనా ప్రొఫైల్‌లు',
  Thai: 'โปรไฟล์ตัวอย่าง',
  Turkish: 'Örnek Profilleri',
  Ukrainian: 'Профілі Вибірки',
  Urdu: 'نمونہ پروفائلز',
  Uzbek: 'Namuna Profillari',
  Vietnamese: 'Hồ sơ Mẫu',
  Welsh: 'Proffiliau Sampl',
};

export const translateSharedThemes: Translation = {
  Afrikaans: 'Gedeelde Temas',
  Amharic: 'የጋራ ጭብጦች',
  Arabic: 'المواضيع المشتركة',
  Armenian: 'Ընդհանուր Թեմաներ',
  Azerbaijani: 'Ortaq Mövzular',
  Belarusian: 'Агульныя Тэмы',
  Bengali: 'ভাগ করা থিম',
  Bosnian: 'Zajedničke Teme',
  Bulgarian: 'Споделени Теми',
  Cantonese: '共同主題',
  Catalan: 'Temes Compartits',
  Chinese: '共同主题',
  'Chinese (Traditional)': '共同主題',
  Croatian: 'Zajedničke Teme',
  Czech: 'Sdílená Témata',
  Danish: 'Delte Temaer',
  Dutch: "Gedeelde Thema's",
  English: 'Shared Themes',
  Estonian: 'Ühised Teemad',
  Finnish: 'Yhteiset Teemat',
  French: 'Thèmes Partagés',
  Galician: 'Temas Compartidos',
  Georgian: 'საერთო თემები',
  German: 'Geteilte Themen',
  Greek: 'Κοινά Θέματα',
  Hebrew: 'נושאים משותפים',
  Hindi: 'साझा विषय',
  Hungarian: 'Közös Témák',
  Icelandic: 'Sameiginleg Þemu',
  Indonesian: 'Tema Bersama',
  Italian: 'Temi Condivisi',
  Japanese: '共有テーマ',
  Kannada: 'ಹಂಚಿದ ವಿಷಯಗಳು',
  Kazakh: 'Ортақ Тақырыптар',
  Korean: '공유 테마',
  Latvian: 'Kopīgās Tēmas',
  Lithuanian: 'Bendros Temos',
  Macedonian: 'Заеднички Теми',
  Malay: 'Tema Bersama',
  Maori: 'Ngā Kaupeka Tūhono',
  Marathi: 'सामायिक विषय',
  Nepali: 'साझा विषयहरू',
  Norwegian: 'Delte Temaer',
  Panjabi: 'ਸਾਂਝੇ ਵਿਸ਼ੇ',
  Punjabi: 'ਸਾਂਝੇ ਵਿਸ਼ੇ',
  Persian: 'موضوعات مشترک',
  Polish: 'Wspólne Tematy',
  Portuguese: 'Temas Compartilhados',
  Romanian: 'Teme Comune',
  Russian: 'Общие Темы',
  Serbian: 'Заједничке Теме',
  Slovak: 'Zdieľané Témy',
  Slovenian: 'Skupne Teme',
  Spanish: 'Temas Compartidos',
  Swahili: 'Mada Zinazoshirikiwa',
  Swedish: 'Delade Teman',
  Tagalog: 'Mga Shared na Tema',
  Tamil: 'பகிரப்பட்ட கருப்பொருள்கள்',
  Telugu: 'భాగస్వామ్య థీమ్‌లు',
  Thai: 'ธีมที่แชร์ร่วมกัน',
  Turkish: 'Paylaşılan Temalar',
  Ukrainian: 'Спільні Теми',
  Urdu: 'مشترکہ موضوعات',
  Uzbek: 'Umumiy Mavzular',
  Vietnamese: 'Chủ đề Chung',
  Welsh: 'Themâu a Rennir',
};

export const translatePerQuestionComparison: Translation = {
  Afrikaans: 'Per-Vraag Vergelyking',
  Amharic: 'በጥያቄ ንፅፅር',
  Arabic: 'المقارنة لكل سؤال',
  Armenian: 'Հարցի Կտրվածքով Համեմատություն',
  Azerbaijani: 'Sual üzrə Müqayisə',
  Belarusian: 'Параўнанне па Пытаннях',
  Bengali: 'প্রতি প্রশ্নে তুলনা',
  Bosnian: 'Usporedba po Pitanjima',
  Bulgarian: 'Сравнение по Въпроси',
  Cantonese: '逐題比較',
  Catalan: 'Comparació per Pregunta',
  Chinese: '逐题比较',
  'Chinese (Traditional)': '逐題比較',
  Croatian: 'Usporedba po Pitanjima',
  Czech: 'Srovnání po Otázkách',
  Danish: 'Sammenligning pr. Spørgsmål',
  Dutch: 'Vergelijking per Vraag',
  English: 'Per-Question Comparison',
  Estonian: 'Küsimuste Kaupa Võrdlus',
  Finnish: 'Kysymyskohtainen Vertailu',
  French: 'Comparaison par Question',
  Galician: 'Comparación por Pregunta',
  Georgian: 'კითხვების მიხედვით შედარება',
  German: 'Vergleich pro Frage',
  Greek: 'Σύγκριση ανά Ερώτηση',
  Hebrew: 'השוואה לפי שאלה',
  Hindi: 'प्रश्न-वार तुलना',
  Hungarian: 'Kérdésenkénti Összehasonlítás',
  Icelandic: 'Samanburður eftir Spurningu',
  Indonesian: 'Perbandingan per Pertanyaan',
  Italian: 'Confronto per Domanda',
  Japanese: '質問ごとの比較',
  Kannada: 'ಪ್ರಶ್ನೆ ಮೂಲಕ ಹೋಲಿಕೆ',
  Kazakh: 'Сұрақ Бойынша Салыстыру',
  Korean: '질문별 비교',
  Latvian: 'Salīdzinājums pa Jautājumiem',
  Lithuanian: 'Palyginimas pagal Klausimus',
  Macedonian: 'Споредба по Прашања',
  Malay: 'Perbandingan per Soalan',
  Maori: 'Whakataurite ia Pātai',
  Marathi: 'प्रश्नानुसार तुलना',
  Nepali: 'प्रश्न-अनुसार तुलना',
  Norwegian: 'Sammenligning per Spørsmål',
  Panjabi: 'ਹਰ ਸਵਾਲ ਦੀ ਤੁਲਨਾ',
  Punjabi: 'ਹਰ ਸਵਾਲ ਦੀ ਤੁਲਨਾ',
  Persian: 'مقایسه در هر سوال',
  Polish: 'Porównanie na Pytanie',
  Portuguese: 'Comparação por Pergunta',
  Romanian: 'Comparație pe Întrebare',
  Russian: 'Сравнение по Вопросам',
  Serbian: 'Поређење по Питањима',
  Slovak: 'Porovnanie po Otázkach',
  Slovenian: 'Primerjava po Vprašanjih',
  Spanish: 'Comparación por Pregunta',
  Swahili: 'Ulinganisho kwa Swali',
  Swedish: 'Jämförelse per Fråga',
  Tagalog: 'Paghahambing bawat Tanong',
  Tamil: 'கேள்வி வாரியான ஒப்பீடு',
  Telugu: 'ప్రశ్న వారీగా పోలిక',
  Thai: 'การเปรียบเทียบต่อคำถาม',
  Turkish: 'Soru Bazlı Karşılaştırma',
  Ukrainian: 'Порівняння за Питаннями',
  Urdu: 'سوال کے حساب سے موازنہ',
  Uzbek: "Savol Bo'yicha Taqqoslash",
  Vietnamese: 'So sánh theo Câu hỏi',
  Welsh: 'Cymhariaeth fesul Cwestiwn',
};

export const translateComparisonSummary: Translation = {
  Afrikaans: 'Vergelykingsopsomming',
  Amharic: 'የንፅፅር ማጠቃለያ',
  Arabic: 'ملخص المقارنة',
  Armenian: 'Համեմատության Ամփոփ',
  Azerbaijani: 'Müqayisə Xülasəsi',
  Belarusian: 'Рэзюмэ Параўнання',
  Bengali: 'তুলনার সারসংক্ষেপ',
  Bosnian: 'Sažetak Usporedbe',
  Bulgarian: 'Резюме на Сравнението',
  Cantonese: '比較摘要',
  Catalan: 'Resum de la Comparació',
  Chinese: '比较摘要',
  'Chinese (Traditional)': '比較摘要',
  Croatian: 'Sažetak Usporedbe',
  Czech: 'Shrnutí Srovnání',
  Danish: 'Sammenligningsresumé',
  Dutch: 'Vergelijkingssamenvatting',
  English: 'Comparison Summary',
  Estonian: 'Võrdluse Kokkuvõte',
  Finnish: 'Vertailun Yhteenveto',
  French: 'Résumé de la Comparaison',
  Galician: 'Resumo da Comparación',
  Georgian: 'შედარების შეჯამება',
  German: 'Vergleichszusammenfassung',
  Greek: 'Σύνοψη Σύγκρισης',
  Hebrew: 'סיכום ההשוואה',
  Hindi: 'तुलना सारांश',
  Hungarian: 'Összehasonlítás Összefoglalása',
  Icelandic: 'Samantekt Samanburðar',
  Indonesian: 'Ringkasan Perbandingan',
  Italian: 'Riepilogo del Confronto',
  Japanese: '比較サマリー',
  Kannada: 'ಹೋಲಿಕೆ ಸಾರಾಂಶ',
  Kazakh: 'Салыстыру Қорытындысы',
  Korean: '비교 요약',
  Latvian: 'Salīdzinājuma Kopsavilkums',
  Lithuanian: 'Palyginimo Santrauka',
  Macedonian: 'Резиме на Споредбата',
  Malay: 'Ringkasan Perbandingan',
  Maori: 'Whakarāpopototanga Whakataurite',
  Marathi: 'तुलनेचा सारांश',
  Nepali: 'तुलनाको सारांश',
  Norwegian: 'Sammenligningssammendrag',
  Panjabi: 'ਤੁਲਨਾ ਸੰਖੇਪ',
  Punjabi: 'ਤੁਲਨਾ ਸੰਖੇਪ',
  Persian: 'خلاصه مقایسه',
  Polish: 'Podsumowanie Porównania',
  Portuguese: 'Resumo da Comparação',
  Romanian: 'Rezumatul Comparației',
  Russian: 'Резюме Сравнения',
  Serbian: 'Резиме Поређења',
  Slovak: 'Zhrnutie Porovnania',
  Slovenian: 'Povzetek Primerjave',
  Spanish: 'Resumen de la Comparación',
  Swahili: 'Muhtasari wa Ulinganisho',
  Swedish: 'Jämförelsesammanfattning',
  Tagalog: 'Buod ng Paghahambing',
  Tamil: 'ஒப்பீட்டு சுருக்கம்',
  Telugu: 'పోలిక సారాంశం',
  Thai: 'สรุปการเปรียบเทียบ',
  Turkish: 'Karşılaştırma Özeti',
  Ukrainian: 'Резюме Порівняння',
  Urdu: 'موازنے کا خلاصہ',
  Uzbek: 'Taqqoslash Xulosasi',
  Vietnamese: 'Tóm tắt So sánh',
  Welsh: 'Crynodeb Cymhariaeth',
};

export const translateKeyDifferences: Translation = {
  Afrikaans: 'Sleutelverskille',
  Amharic: 'ዋና ልዩነቶች',
  Arabic: 'الاختلافات الرئيسية',
  Armenian: 'Հիմնական Տարբերություններ',
  Azerbaijani: 'Əsas Fərqlər',
  Belarusian: 'Ключавыя Адрозненні',
  Bengali: 'মূল পার্থক্য',
  Bosnian: 'Ključne Razlike',
  Bulgarian: 'Ключови Различия',
  Cantonese: '主要差異',
  Catalan: 'Diferències Clau',
  Chinese: '关键差异',
  'Chinese (Traditional)': '關鍵差異',
  Croatian: 'Ključne Razlike',
  Czech: 'Klíčové Rozdíly',
  Danish: 'Centrale Forskelle',
  Dutch: 'Belangrijkste Verschillen',
  English: 'Key Differences',
  Estonian: 'Peamised Erinevused',
  Finnish: 'Tärkeimmät Erot',
  French: 'Différences Clés',
  Galician: 'Diferenzas Clave',
  Georgian: 'ძირითადი განსხვავებები',
  German: 'Wesentliche Unterschiede',
  Greek: 'Βασικές Διαφορές',
  Hebrew: 'הבדלים מרכזיים',
  Hindi: 'मुख्य अंतर',
  Hungarian: 'Fő Különbségek',
  Icelandic: 'Lykilmunur',
  Indonesian: 'Perbedaan Utama',
  Italian: 'Differenze Chiave',
  Japanese: '主な違い',
  Kannada: 'ಮುಖ್ಯ ವ್ಯತ್ಯಾಸಗಳು',
  Kazakh: 'Негізгі Айырмашылықтар',
  Korean: '주요 차이점',
  Latvian: 'Galvenās Atšķirības',
  Lithuanian: 'Pagrindiniai Skirtumai',
  Macedonian: 'Клучни Разлики',
  Malay: 'Perbezaan Utama',
  Maori: 'Ngā Rereketanga Matua',
  Marathi: 'मुख्य फरक',
  Nepali: 'मुख्य भिन्नताहरू',
  Norwegian: 'Viktige Forskjeller',
  Panjabi: 'ਮੁੱਖ ਅੰਤਰ',
  Punjabi: 'ਮੁੱਖ ਅੰਤਰ',
  Persian: 'تفاوت‌های کلیدی',
  Polish: 'Kluczowe Różnice',
  Portuguese: 'Diferenças Chave',
  Romanian: 'Diferențe Cheie',
  Russian: 'Ключевые Различия',
  Serbian: 'Кључне Разлике',
  Slovak: 'Kľúčové Rozdiely',
  Slovenian: 'Ključne Razlike',
  Spanish: 'Diferencias Clave',
  Swahili: 'Tofauti Muhimu',
  Swedish: 'Viktiga Skillnader',
  Tagalog: 'Mga Pangunahing Pagkakaiba',
  Tamil: 'முக்கிய வேறுபாடுகள்',
  Telugu: 'ముఖ్య తేడాలు',
  Thai: 'ความแตกต่างหลัก',
  Turkish: 'Temel Farklılıklar',
  Ukrainian: 'Ключові Відмінності',
  Urdu: 'اہم فرق',
  Uzbek: 'Asosiy Farqlar',
  Vietnamese: 'Sự khác biệt Chính',
  Welsh: 'Prif Wahaniaethau',
};

export const translateSharedPatterns: Translation = {
  Afrikaans: 'Gedeelde Patrone',
  Amharic: 'የጋራ ቅጦች',
  Arabic: 'الأنماط المشتركة',
  Armenian: 'Ընդհանուր Օրինաչափություններ',
  Azerbaijani: 'Ortaq Nümunələr',
  Belarusian: 'Агульныя Узоры',
  Bengali: 'ভাগ করা নিদর্শন',
  Bosnian: 'Zajednički Obrasci',
  Bulgarian: 'Споделени Модели',
  Cantonese: '共同模式',
  Catalan: 'Patrons Compartits',
  Chinese: '共同模式',
  'Chinese (Traditional)': '共同模式',
  Croatian: 'Zajednički Obrasci',
  Czech: 'Sdílené Vzory',
  Danish: 'Delte Mønstre',
  Dutch: 'Gedeelde Patronen',
  English: 'Shared Patterns',
  Estonian: 'Ühised Mustrid',
  Finnish: 'Yhteiset Mallit',
  French: 'Modèles Partagés',
  Galician: 'Patróns Compartidos',
  Georgian: 'საერთო ნიმუშები',
  German: 'Gemeinsame Muster',
  Greek: 'Κοινά Μοτίβα',
  Hebrew: 'דפוסים משותפים',
  Hindi: 'साझा पैटर्न',
  Hungarian: 'Közös Minták',
  Icelandic: 'Sameiginleg Mynstur',
  Indonesian: 'Pola Bersama',
  Italian: 'Pattern Condivisi',
  Japanese: '共通パターン',
  Kannada: 'ಹಂಚಿದ ಮಾದರಿಗಳು',
  Kazakh: 'Ортақ Үлгілер',
  Korean: '공유 패턴',
  Latvian: 'Kopīgie Modeļi',
  Lithuanian: 'Bendri Modeliai',
  Macedonian: 'Заеднички Шаблони',
  Malay: 'Corak Bersama',
  Maori: 'Ngā Tauira Tūhono',
  Marathi: 'सामायिक नमुने',
  Nepali: 'साझा ढाँचाहरू',
  Norwegian: 'Delte Mønstre',
  Panjabi: 'ਸਾਂਝੇ ਨਮੂਨੇ',
  Punjabi: 'ਸਾਂਝੇ ਨਮੂਨੇ',
  Persian: 'الگوهای مشترک',
  Polish: 'Wspólne Wzorce',
  Portuguese: 'Padrões Compartilhados',
  Romanian: 'Modele Comune',
  Russian: 'Общие Паттерны',
  Serbian: 'Заједнички Обрасци',
  Slovak: 'Zdieľané Vzory',
  Slovenian: 'Skupni Vzorci',
  Spanish: 'Patrones Compartidos',
  Swahili: 'Mifumo Inayoshirikiwa',
  Swedish: 'Delade Mönster',
  Tagalog: 'Mga Shared na Pattern',
  Tamil: 'பகிரப்பட்ட வடிவங்கள்',
  Telugu: 'భాగస్వామ్య నమూనాలు',
  Thai: 'รูปแบบที่แชร์ร่วมกัน',
  Turkish: 'Paylaşılan Desenler',
  Ukrainian: 'Спільні Патерни',
  Urdu: 'مشترکہ نمونے',
  Uzbek: 'Umumiy Namunalar',
  Vietnamese: 'Các Mẫu Chung',
  Welsh: 'Patrymau a Rennir',
};

export const translateBackToResults: Translation = {
  Afrikaans: 'Terug na resultate',
  Amharic: 'ወደ ውጤቶች ተመለስ',
  Arabic: 'العودة إلى النتائج',
  Armenian: 'Վերադառնալ արդյունքներին',
  Azerbaijani: 'Nəticələrə qayıt',
  Belarusian: 'Назад да вынікаў',
  Bengali: 'ফলাফলে ফিরে যান',
  Bosnian: 'Povratak na rezultate',
  Bulgarian: 'Обратно към резултатите',
  Cantonese: '返回結果',
  Catalan: 'Tornar als resultats',
  Chinese: '返回结果',
  'Chinese (Traditional)': '返回結果',
  Croatian: 'Povratak na rezultate',
  Czech: 'Zpět na výsledky',
  Danish: 'Tilbage til resultater',
  Dutch: 'Terug naar resultaten',
  English: 'Back to results',
  Estonian: 'Tagasi tulemustele',
  Finnish: 'Takaisin tuloksiin',
  French: 'Retour aux résultats',
  Galician: 'Volver aos resultados',
  Georgian: 'შედეგებზე დაბრუნება',
  German: 'Zurück zu den Ergebnissen',
  Greek: 'Επιστροφή στα αποτελέσματα',
  Hebrew: 'חזרה לתוצאות',
  Hindi: 'परिणामों पर वापस जाएं',
  Hungarian: 'Vissza az eredményekhez',
  Icelandic: 'Aftur í niðurstöður',
  Indonesian: 'Kembali ke hasil',
  Italian: 'Torna ai risultati',
  Japanese: '結果に戻る',
  Kannada: 'ಫಲಿತಾಂಶಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
  Kazakh: 'Нәтижелерге оралу',
  Korean: '결과로 돌아가기',
  Latvian: 'Atpakaļ uz rezultātiem',
  Lithuanian: 'Grįžti prie rezultatų',
  Macedonian: 'Назад кон резултатите',
  Malay: 'Kembali ke keputusan',
  Maori: 'Hoki ki ngā hua',
  Marathi: 'निकालांवर परत जा',
  Nepali: 'नतिजाहरूमा फिर्ता जानुहोस्',
  Norwegian: 'Tilbake til resultater',
  Panjabi: "ਨਤੀਜਿਆਂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  Punjabi: "ਨਤੀਜਿਆਂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  Persian: 'بازگشت به نتایج',
  Polish: 'Powrót do wyników',
  Portuguese: 'Voltar aos resultados',
  Romanian: 'Înapoi la rezultate',
  Russian: 'Вернуться к результатам',
  Serbian: 'Назад на резултате',
  Slovak: 'Späť na výsledky',
  Slovenian: 'Nazaj na rezultate',
  Spanish: 'Volver a los resultados',
  Swahili: 'Rudi kwa matokeo',
  Swedish: 'Tillbaka till resultat',
  Tagalog: 'Bumalik sa mga resulta',
  Tamil: 'முடிவுகளுக்கு திரும்பு',
  Telugu: 'ఫలితాలకు తిరిగి వెళ్లండి',
  Thai: 'กลับสู่ผลลัพธ์',
  Turkish: 'Sonuçlara geri dön',
  Ukrainian: 'Повернутися до результатів',
  Urdu: 'نتائج پر واپس جائیں',
  Uzbek: 'Natijalarga qaytish',
  Vietnamese: 'Quay lại kết quả',
  Welsh: 'Yn ol i ganlyniadau',
};

export const translateGeneratingComparison: Translation = {
  Afrikaans: 'Genereer vergelykingsverslag...',
  Amharic: 'የንፅፅር ሪፖርት እየፈጠረ ነው...',
  Arabic: 'جارٍ إنشاء تقرير المقارنة...',
  Armenian: 'Ստեղծվում է համեմատական հաշվետվություն...',
  Azerbaijani: 'Müqayisə hesabatı yaradılır...',
  Belarusian: 'Фарміраванне справаздачы параўнання...',
  Bengali: 'তুলনা রিপোর্ট তৈরি হচ্ছে...',
  Bosnian: 'Generiranje izvještaja o usporedbi...',
  Bulgarian: 'Генериране на отчет за сравнение...',
  Cantonese: '正在生成比較報告...',
  Catalan: 'Generant informe de comparació...',
  Chinese: '正在生成比较报告...',
  'Chinese (Traditional)': '正在生成比較報告...',
  Croatian: 'Generiranje izvješća o usporedbi...',
  Czech: 'Generování zprávy o srovnání...',
  Danish: 'Genererer sammenligningsrapport...',
  Dutch: 'Vergelijkingsrapport genereren...',
  English: 'Generating comparison report...',
  Estonian: 'Võrdlusaruande genereerimine...',
  Finnish: 'Vertailuraportin luominen...',
  French: 'Génération du rapport de comparaison...',
  Galician: 'Xerando informe de comparación...',
  Georgian: 'შედარების ანგარიშის გენერირება...',
  German: 'Vergleichsbericht wird generiert...',
  Greek: 'Δημιουργία αναφοράς σύγκρισης...',
  Hebrew: 'יוצר דוח השוואה...',
  Hindi: 'तुलना रिपोर्ट तैयार हो रही है...',
  Hungarian: 'Összehasonlítási jelentés generálása...',
  Icelandic: 'Myndun samanburðarskýrslu...',
  Indonesian: 'Membuat laporan perbandingan...',
  Italian: 'Generazione del rapporto di confronto...',
  Japanese: '比較レポートを生成中...',
  Kannada: 'ಹೋಲಿಕೆ ವರದಿ ರಚಿಸಲಾಗುತ್ತಿದೆ...',
  Kazakh: 'Салыстыру есебі жасалуда...',
  Korean: '비교 보고서 생성 중...',
  Latvian: 'Salīdzinājuma atskaites ģenerēšana...',
  Lithuanian: 'Kuriama palyginimo ataskaita...',
  Macedonian: 'Се генерира извештај за споредба...',
  Malay: 'Menjana laporan perbandingan...',
  Maori: 'E hanga ana i te purongo whakataurite...',
  Marathi: 'तुलना अहवाल तयार केला जात आहे...',
  Nepali: 'तुलना रिपोर्ट उत्पन्न गर्दै...',
  Norwegian: 'Genererer sammenligningsrapport...',
  Panjabi: 'ਤੁਲਨਾ ਰਿਪੋਰਟ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ...',
  Punjabi: 'ਤੁਲਨਾ ਰਿਪੋਰਟ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ...',
  Persian: 'در حال تولید گزارش مقایسه...',
  Polish: 'Generowanie raportu porównawczego...',
  Portuguese: 'Gerando relatório de comparação...',
  Romanian: 'Se generează raportul de comparație...',
  Russian: 'Формирование отчета о сравнении...',
  Serbian: 'Генерисање извештаја о поређењу...',
  Slovak: 'Generovanie správy o porovnaní...',
  Slovenian: 'Ustvarjanje poročila o primerjavi...',
  Spanish: 'Generando informe de comparación...',
  Swahili: 'Inazalisha ripoti ya ulinganisho...',
  Swedish: 'Genererar jämförelserapport...',
  Tagalog: 'Bumubuo ng ulat ng paghahambing...',
  Tamil: 'ஒப்பீட்டு அறிக்கை உருவாக்கப்படுகிறது...',
  Telugu: 'పోలిక నివేదిక తయారవుతోంది...',
  Thai: 'กำลังสร้างรายงานการเปรียบเทียบ...',
  Turkish: 'Karşılaştırma raporu oluşturuluyor...',
  Ukrainian: 'Формується звіт про порівняння...',
  Urdu: 'موازنے کی رپورٹ تیار کی جا رہی ہے...',
  Uzbek: 'Taqqoslash hisoboti yaratilmoqda...',
  Vietnamese: 'Đang tạo báo cáo so sánh...',
  Welsh: 'Cynhyrchu adroddiad cymhariaeth...',
};

export const translateUniqueToSegment: Translation = {
  Afrikaans: 'Uniek aan',
  Amharic: 'ለዚህ ብቻ',
  Arabic: 'فريد من نوعه لـ',
  Armenian: 'Բացառիկ',
  Azerbaijani: 'Yalnız',
  Belarusian: 'Унікальна для',
  Bengali: 'শুধুমাত্র',
  Bosnian: 'Jedinstveno za',
  Bulgarian: 'Уникално за',
  Cantonese: '獨有於',
  Catalan: 'Únic per a',
  Chinese: '独有于',
  'Chinese (Traditional)': '獨有於',
  Croatian: 'Jedinstveno za',
  Czech: 'Jedinečné pro',
  Danish: 'Unikt for',
  Dutch: 'Uniek voor',
  English: 'Unique to',
  Estonian: 'Ainulaadne',
  Finnish: 'Ainutlaatuinen',
  French: 'Unique pour',
  Galician: 'Único para',
  Georgian: 'უნიკალური',
  German: 'Einzigartig für',
  Greek: 'Μοναδικό για',
  Hebrew: 'ייחודי ל-',
  Hindi: 'के लिए अद्वितीय',
  Hungarian: 'Egyedi',
  Icelandic: 'Einstakt fyrir',
  Indonesian: 'Unik untuk',
  Italian: 'Unico per',
  Japanese: '固有',
  Kannada: 'ವಿಶಿಷ್ಟ',
  Kazakh: 'Бірегей',
  Korean: '고유한',
  Latvian: 'Unikāls',
  Lithuanian: 'Unikalu',
  Macedonian: 'Единствено за',
  Malay: 'Unik untuk',
  Maori: 'Motuhake mo',
  Marathi: 'साठी अद्वितीय',
  Nepali: 'को लागि अद्वितीय',
  Norwegian: 'Unikt for',
  Panjabi: 'ਲਈ ਵਿਲੱਖਣ',
  Punjabi: 'ਲਈ ਵਿਲੱਖਣ',
  Persian: 'منحصر به فرد برای',
  Polish: 'Unikalne dla',
  Portuguese: 'Único para',
  Romanian: 'Unic pentru',
  Russian: 'Уникально для',
  Serbian: 'Јединствено за',
  Slovak: 'Jedinečné pre',
  Slovenian: 'Edinstveno za',
  Spanish: 'Único para',
  Swahili: 'Ya kipekee kwa',
  Swedish: 'Unikt för',
  Tagalog: 'Natatangi sa',
  Tamil: 'இதற்கு மட்டுமே',
  Telugu: 'దీనికి మాత్రమే',
  Thai: 'เฉพาะสำหรับ',
  Turkish: 'Yalnızca',
  Ukrainian: 'Унікально для',
  Urdu: 'کے لیے منفرد',
  Uzbek: 'Uchun noyob',
  Vietnamese: 'Duy nhất cho',
  Welsh: 'Unigryw i',
};

/**
 * "Started Interviews" — used in comparison statistical tables.
 * Refers to interviews that began but may not have completed.
 */
export const translateStartedInterviews: Translation = {
  Afrikaans: 'Begonne onderhoude',
  Amharic: 'የተጀመሩ ቃለ-መጠይቆች',
  Arabic: 'المقابلات التي بدأت',
  Armenian: 'Սկսված հարցումներ',
  Azerbaijani: 'Başlanmış mülakatlar',
  Belarusian: "Распачатыя інтэрв'ю",
  Bengali: 'শুরু হওয়া সাক্ষাৎকার',
  Bosnian: 'Započeti intervjui',
  Bulgarian: 'Започнати интервюта',
  Cantonese: '已開始的訪談',
  Catalan: 'Entrevistes iniciades',
  Chinese: '已开始的面试',
  'Chinese (Traditional)': '已開始的訪談',
  Croatian: 'Započeti razgovori',
  Czech: 'Zahájené rozhovory',
  Danish: 'Påbegyndte interviews',
  Dutch: 'Gestarte interviews',
  English: 'Started interviews',
  Estonian: 'Alustatud intervjuud',
  Finnish: 'Aloitetut haastattelut',
  French: 'Entretiens commencés',
  Galician: 'Entrevistas iniciadas',
  Georgian: 'დაწყებული ინტერვიუები',
  German: 'Begonnene Interviews',
  Greek: 'Συνεντεύξεις που ξεκίνησαν',
  Hebrew: 'ראיונות שהתחילו',
  Hindi: 'शुरू किए गए साक्षात्कार',
  Hungarian: 'Elkezdett interjúk',
  Icelandic: 'Hafin viðtöl',
  Indonesian: 'Wawancara dimulai',
  Italian: 'Interviste iniziate',
  Japanese: '開始された面接',
  Kannada: 'ಪ್ರಾರಂಭಿಸಿದ ಸಂವಾದಗಳು',
  Kazakh: 'Басталған интервьюлар',
  Korean: '시작된 인터뷰',
  Latvian: 'Sāktās intervijas',
  Lithuanian: 'Pradėti interviu',
  Macedonian: 'Започнати интервјуа',
  Malay: 'Wawancara dimulakan',
  Maori: 'Ngā uiui kua tīmata',
  Marathi: 'सुरू केलेल्या मुलाखती',
  Nepali: 'सुरु भएका अन्तर्वार्ताहरू',
  Norwegian: 'Påbegynte intervjuer',
  Panjabi: 'ਸ਼ੁਰੂ ਕੀਤੇ ਇੰਟਰਵਿਊ',
  Punjabi: 'ਸ਼ੁਰੂ ਕੀਤੇ ਇੰਟਰਵਿਊ',
  Persian: 'مصاحبه های آغاز شده',
  Polish: 'Rozpoczęte wywiady',
  Portuguese: 'Entrevistas iniciadas',
  Romanian: 'Interviuri începute',
  Russian: 'Начатые интервью',
  Serbian: 'Започети интервјуи',
  Slovak: 'Začaté pohovory',
  Slovenian: 'Začeti pogovori',
  Spanish: 'Entrevistas iniciadas',
  Swahili: 'Mahojiano yaliyoanzishwa',
  Swedish: 'Påbörjade intervjuer',
  Tagalog: 'Mga panayam na sinimulan',
  Tamil: 'தொடங்கப்பட்ட பேட்டிகள்',
  Telugu: 'ప్రారంభమైన ఇంటర్వ్యూలు',
  Thai: 'สัมภาษณ์ที่เริ่มแล้ว',
  Turkish: 'Başlatılan mülakatlar',
  Ukrainian: "Розпочаті інтерв'ю",
  Urdu: 'شروع شدہ انٹرویوز',
  Uzbek: 'Boshlangan suhbatlar',
  Vietnamese: 'Các cuộc phỏng vấn đã bắt đầu',
  Welsh: 'Cyfweliadau wedi dechrau',
};

/**
 * "Screening Pass Rate" — used in comparison statistical tables.
 * Percentage of started interviews that passed screening (completed).
 */
export const translateScreeningPassRate: Translation = {
  Afrikaans: 'Sifting deurloopkoers',
  Amharic: 'የማጣራት ማለፍ መጠን',
  Arabic: 'معدل اجتياز الفرز',
  Armenian: 'Զննման անցման տոկոս',
  Azerbaijani: 'Skrininq keçmə nisbəti',
  Belarusian: 'Працэнт праходжання адбору',
  Bengali: 'স্ক্রিনিং পাস রেট',
  Bosnian: 'Stopa prolaska screeninga',
  Bulgarian: 'Процент на преминаване на скрининга',
  Cantonese: '篩選通過率',
  Catalan: 'Taxa de superació del cribratge',
  Chinese: '筛选通过率',
  'Chinese (Traditional)': '篩選通過率',
  Croatian: 'Stopa prolaska screeninga',
  Czech: 'Míra úspěšnosti screeningu',
  Danish: 'Screeningens beståelsesprocent',
  Dutch: 'Slagingspercentage screening',
  English: 'Screening pass rate',
  Estonian: 'Sõelumise läbimise määr',
  Finnish: 'Seulonnan läpäisyaste',
  French: 'Taux de réussite du filtrage',
  Galician: 'Taxa de superación do cribado',
  Georgian: 'სკრინინგის გავლის მაჩვენებელი',
  German: 'Screening-Bestehensquote',
  Greek: 'Ποσοστό επιτυχίας ελέγχου',
  Hebrew: 'שיעור מעבר סינון',
  Hindi: 'स्क्रीनिंग पास दर',
  Hungarian: 'Szűrési átmeneti arány',
  Icelandic: 'Skimunaratíni',
  Indonesian: 'Tingkat lulus penyaringan',
  Italian: 'Tasso di superamento dello screening',
  Japanese: 'スクリーニング通過率',
  Kannada: 'ಸ್ಕ್ರೀನಿಂಗ್ ಪಾಸ್ ದರ',
  Kazakh: 'Скрининг өту жылдамдығы',
  Korean: '스크리닝 통과율',
  Latvian: 'Skrīninga izturēšanas rādītājs',
  Lithuanian: 'Atrankos išlaikymo rodiklis',
  Macedonian: 'Стапка на поминување на скрининг',
  Malay: 'Kadar lulus penyaringan',
  Maori: 'Pāpātanga tukunga tātaritanga',
  Marathi: 'स्क्रीनिंग उत्तीर्ण दर',
  Nepali: 'स्क्रिनिङ पास दर',
  Norwegian: 'Screening-bestått andel',
  Panjabi: 'ਸਕ੍ਰੀਨਿੰਗ ਪਾਸ ਦਰ',
  Punjabi: 'ਸਕ੍ਰੀਨਿੰਗ ਪਾਸ ਦਰ',
  Persian: 'نرخ قبولی غربالگری',
  Polish: 'Wskaźnik zaliczenia screeningu',
  Portuguese: 'Taxa de aprovação na triagem',
  Romanian: 'Rata de promovare a screening-ului',
  Russian: 'Процент прохождения скрининга',
  Serbian: 'Стопа проласка скрининга',
  Slovak: 'Miera úspešnosti screeningu',
  Slovenian: 'Stopnja uspešnosti presejanja',
  Spanish: 'Tasa de aprobación del cribado',
  Swahili: 'Kiwango cha kufaulu uchunguzi',
  Swedish: 'Godkännandegrad screening',
  Tagalog: 'Rate ng pagpasa sa screening',
  Tamil: 'திரையிடல் தேர்ச்சி விகிதம்',
  Telugu: 'స్క్రీనింగ్ ఉత్తీర్ణత రేటు',
  Thai: 'อัตราผ่านการคัดกรอง',
  Turkish: 'Eleme geçme oranı',
  Ukrainian: 'Коефіцієнт проходження скринінгу',
  Urdu: 'اسکریننگ پاس کی شرح',
  Uzbek: 'Skrining oʻtish darajasi',
  Vietnamese: 'Tỷ lệ vượt qua sàng lọc',
  Welsh: 'Cyfradd llwyddo sgrinio',
};

// ─────────────────────────────────────────────────────────────────────
// TELV1-342 — project-locale labels for the Overview "Screening & Quota
// Insights" block. The block previously used the user-locale `lang.get()`
// for these strings, which left English text on Dutch projects whenever
// the researcher's UI preference wasn't Dutch. The other Overview chrome
// (Statistics, Completed Interviews, Median, Average) already uses
// `resolveTranslation(translateX, analysisLanguage)` — so a Dutch project
// rendered "Statistieken" but "Screening & Quota Insights" / "Pass Rate"
// side-by-side. These maps make the screening labels follow the project
// language too.
//
// TELV1-365 — expanded from 8 to full 65-language coverage matching
// `translateStatistics` and the other canonical maps in this file.
// The original ship matched the (now-abandoned) "ship EN + 6 EU and
// extend gradually" pattern; Tellet supports 65 analysis languages and
// every chrome label should follow the project locale, not silently
// fall back to English for the other 56.
// ─────────────────────────────────────────────────────────────────────
export const translateScreeningQuotaInsights: Translation = {
  Afrikaans: 'Sifting- en kwota-insigte',
  Amharic: 'የማጣራት እና ኮታ ግንዛቤዎች',
  Arabic: 'رؤى التصفية والحصص',
  Armenian: 'Զտման և քվոտաների վերլուծություն',
  Azerbaijani: 'Filtrasiya və kvota məlumatları',
  Belarusian: 'Аналітыка адсейвання і квот',
  Bengali: 'যাচাইকরণ ও কোটা অন্তর্দৃষ্টি',
  Bosnian: 'Uvidi u probiranje i kvote',
  Bulgarian: 'Информация за пресяване и квоти',
  Cantonese: '篩查與配額洞察',
  Catalan: 'Informació de cribratge i quotes',
  Chinese: '筛查与配额洞察',
  'Chinese (Traditional)': '篩查與配額洞察',
  Croatian: 'Uvidi u probir i kvote',
  Czech: 'Přehled screeningu a kvót',
  Danish: 'Screening- og kvoteindsigt',
  Dutch: 'Screening- en quota-inzichten',
  English: 'Screening & quota insights',
  Estonian: 'Sõelumise ja kvootide ülevaade',
  Finnish: 'Seulonta- ja kiintiötiedot',
  French: 'Aperçus filtrage et quotas',
  Galician: 'Información de cribado e cotas',
  Georgian: 'სკრინინგისა და კვოტების მონაცემები',
  German: 'Screening- und Quoten-Einblicke',
  Greek: 'Πληροφορίες ελέγχου και ποσοστώσεων',
  Hebrew: 'תובנות סינון ומכסות',
  Hindi: 'स्क्रीनिंग और कोटा अंतर्दृष्टि',
  Hungarian: 'Szűrési és kvóta áttekintés',
  Icelandic: 'Skimun og kvótayfirlit',
  Indonesian: 'Wawasan penyaringan & kuota',
  Italian: 'Approfondimenti su screening e quote',
  Japanese: 'スクリーニングとクォータの洞察',
  Kannada: 'ಪರಿಶೀಲನೆ ಮತ್ತು ಕೋಟಾ ಒಳನೋಟಗಳು',
  Kazakh: 'Скрининг және квота түсінігі',
  Korean: '스크리닝 및 할당량 인사이트',
  Latvian: 'Pārbaudes un kvotu pārskats',
  Lithuanian: 'Atrankos ir kvotų įžvalgos',
  Macedonian: 'Преглед на скрининг и квоти',
  Malay: 'Wawasan saringan & kuota',
  Maori: 'Whakaaroaro tirotiro me ngā tuewhā',
  Marathi: 'स्क्रिनिंग आणि कोटा अंतर्दृष्टी',
  Nepali: 'स्क्रिनिङ र कोटा अन्तर्दृष्टि',
  Norwegian: 'Screening- og kvotemålinger',
  Panjabi: 'ਸਕ੍ਰੀਨਿੰਗ ਅਤੇ ਕੋਟਾ ਜਾਣਕਾਰੀ',
  Punjabi: 'ਸਕ੍ਰੀਨਿੰਗ ਅਤੇ ਕੋਟਾ ਜਾਣਕਾਰੀ',
  Persian: 'بینش غربالگری و سهمیه',
  Polish: 'Statystyki kwalifikacji i kwot',
  Portuguese: 'Informações de triagem e cotas',
  Romanian: 'Perspective de filtrare și cote',
  Russian: 'Аналитика отбора и квот',
  Serbian: 'Преглед скрининга и квота',
  Slovak: 'Prehľad skríningu a kvót',
  Slovenian: 'Pregled presejanja in kvot',
  Spanish: 'Información de cribado y cuotas',
  Swahili: 'Maarifa ya uchunguzi na vipaumbele',
  Swedish: 'Screening- och kvotinsikter',
  Tagalog: 'Mga insight sa pag-screen at quota',
  Tamil: 'திரையிடல் மற்றும் ஒதுக்கீடு நுண்ணறிவுகள்',
  Telugu: 'స్క్రీనింగ్ & కోటా అంతర్దృష్టులు',
  Thai: 'ข้อมูลเชิงลึกการคัดกรองและโควต้า',
  Turkish: 'Eleme ve kota görüşleri',
  Ukrainian: 'Аналітика відбору та квот',
  Urdu: 'اسکریننگ اور کوٹہ بصیرت',
  Uzbek: 'Saralash va kvota tahlili',
  Vietnamese: 'Thông tin sàng lọc & hạn ngạch',
  Welsh: 'Mewnwelediadau sgrinio a chwota',
};

export const translateScreeningTotalScreened: Translation = {
  Afrikaans: 'Totaal gesif',
  Amharic: 'ጠቅላላ የተጣራ',
  Arabic: 'إجمالي المفحوصين',
  Armenian: 'Ընդհանուր զննված',
  Azerbaijani: 'Cəmi yoxlanmış',
  Belarusian: 'Усяго адсеяна',
  Bengali: 'মোট পরীক্ষিত',
  Bosnian: 'Ukupno probrano',
  Bulgarian: 'Общо пресети',
  Cantonese: '篩查總數',
  Catalan: 'Total cribrat',
  Chinese: '筛查总数',
  'Chinese (Traditional)': '篩查總數',
  Croatian: 'Ukupno pregledano',
  Czech: 'Celkem prověřeno',
  Danish: 'Samlet screenet',
  Dutch: 'Totaal gescreend',
  English: 'Total screened',
  Estonian: 'Sõelutud kokku',
  Finnish: 'Yhteensä seulottu',
  French: 'Total filtré',
  Galician: 'Total cribado',
  Georgian: 'სულ შემოწმებული',
  German: 'Insgesamt gescreent',
  Greek: 'Σύνολο ελεγχθέντων',
  Hebrew: 'סך הכל סוננו',
  Hindi: 'कुल जांचे गए',
  Hungarian: 'Összes szűrt',
  Icelandic: 'Heildarskimun',
  Indonesian: 'Total disaring',
  Italian: 'Totale selezionati',
  Japanese: 'スクリーニング合計',
  Kannada: 'ಒಟ್ಟು ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
  Kazakh: 'Жалпы тексерілген',
  Korean: '총 스크리닝',
  Latvian: 'Kopā pārbaudīti',
  Lithuanian: 'Iš viso patikrinta',
  Macedonian: 'Вкупно прегледани',
  Malay: 'Jumlah disaring',
  Maori: 'Tapeke i tirohia',
  Marathi: 'एकूण स्क्रीन केले',
  Nepali: 'कुल स्क्रिन गरिएको',
  Norwegian: 'Totalt screenet',
  Panjabi: 'ਕੁੱਲ ਸਕ੍ਰੀਨ ਕੀਤੇ',
  Punjabi: 'ਕੁੱਲ ਸਕ੍ਰੀਨ ਕੀਤੇ',
  Persian: 'کل غربالگری',
  Polish: 'Łącznie zakwalifikowanych',
  Portuguese: 'Total triado',
  Romanian: 'Total filtrate',
  Russian: 'Всего отобрано',
  Serbian: 'Укупно прегледано',
  Slovak: 'Celkovo skrínovaných',
  Slovenian: 'Skupaj presejanih',
  Spanish: 'Total cribado',
  Swahili: 'Jumla iliyochunguzwa',
  Swedish: 'Totalt screenade',
  Tagalog: 'Kabuuang na-screen',
  Tamil: 'மொத்த திரையிடப்பட்டவர்கள்',
  Telugu: 'మొత్తం స్క్రీన్ చేయబడినవారు',
  Thai: 'คัดกรองทั้งหมด',
  Turkish: 'Toplam taranan',
  Ukrainian: 'Всього відібрано',
  Urdu: 'کل اسکریننگ',
  Uzbek: 'Jami tekshirilgan',
  Vietnamese: 'Tổng số sàng lọc',
  Welsh: "Cyfanswm wedi'i sgrinio",
};

export const translateScreeningPassed: Translation = {
  Afrikaans: 'Geslaag',
  Amharic: 'አለፉ',
  Arabic: 'نجح',
  Armenian: 'Անցել է',
  Azerbaijani: 'Keçdi',
  Belarusian: 'Прайшоў',
  Bengali: 'উত্তীর্ণ',
  Bosnian: 'Prošlo',
  Bulgarian: 'Преминаха',
  Cantonese: '已通過',
  Catalan: 'Aprovat',
  Chinese: '已通过',
  'Chinese (Traditional)': '已通過',
  Croatian: 'Prošli',
  Czech: 'Prošlo',
  Danish: 'Bestået',
  Dutch: 'Geslaagd',
  English: 'Passed',
  Estonian: 'Läbisid',
  Finnish: 'Hyväksytty',
  French: 'Réussi',
  Galician: 'Aprobado',
  Georgian: 'გავიდა',
  German: 'Bestanden',
  Greek: 'Πέρασαν',
  Hebrew: 'עברו',
  Hindi: 'पास हुए',
  Hungarian: 'Sikeres',
  Icelandic: 'Stóðust',
  Indonesian: 'Lulus',
  Italian: 'Superati',
  Japanese: '通過',
  Kannada: 'ಉತ್ತೀರ್ಣ',
  Kazakh: 'Өтті',
  Korean: '통과',
  Latvian: 'Izturēja',
  Lithuanian: 'Praėjo',
  Macedonian: 'Поминаа',
  Malay: 'Lulus',
  Maori: 'I paahi',
  Marathi: 'उत्तीर्ण',
  Nepali: 'उत्तीर्ण',
  Norwegian: 'Bestått',
  Panjabi: 'ਪਾਸ',
  Punjabi: 'ਪਾਸ',
  Persian: 'قبول‌شدگان',
  Polish: 'Zaliczeni',
  Portuguese: 'Aprovados',
  Romanian: 'Acceptate',
  Russian: 'Прошли',
  Serbian: 'Прошли',
  Slovak: 'Úspešní',
  Slovenian: 'Uspešni',
  Spanish: 'Aprobados',
  Swahili: 'Walipita',
  Swedish: 'Godkända',
  Tagalog: 'Pumasa',
  Tamil: 'தேர்ச்சி',
  Telugu: 'ఉత్తీర్ణత',
  Thai: 'ผ่าน',
  Turkish: 'Geçti',
  Ukrainian: 'Пройшли',
  Urdu: 'کامیاب',
  Uzbek: "O'tdi",
  Vietnamese: 'Đạt',
  Welsh: 'Wedi pasio',
};

// TELV1-388 — the screening "failed" count is labelled "Screened out": the
// respondent was screened out by the screener, not "failed". The map name keeps
// the `screening.failed` data-field alignment. English + Dutch reviewed; the
// remaining languages are AI translations pending native review.
export const translateScreeningFailed: Translation = {
  Afrikaans: 'Uitgesluit',
  Amharic: 'የተገለሉ',
  Arabic: 'مستبعدون',
  Armenian: 'Բացառված',
  Azerbaijani: 'Kənarlaşdırılıb',
  Belarusian: 'Адсеяныя',
  Bengali: 'বাদ পড়েছে',
  Bosnian: 'Isključeni',
  Bulgarian: 'Изключени',
  Cantonese: '已篩走',
  Catalan: 'Exclosos',
  Chinese: '已筛除',
  'Chinese (Traditional)': '已篩除',
  Croatian: 'Isključeni',
  Czech: 'Vyřazeni',
  Danish: 'Frasorteret',
  Dutch: 'Uitgesloten',
  English: 'Screened out',
  Estonian: 'Välistatud',
  Finnish: 'Karsittu',
  French: 'Exclus',
  Galician: 'Excluídos',
  Georgian: 'გამოირიცხა',
  German: 'Aussortiert',
  Greek: 'Αποκλείστηκαν',
  Hebrew: 'סוננו',
  Hindi: 'बाहर किए गए',
  Hungarian: 'Kiszűrve',
  Icelandic: 'Útilokuð',
  Indonesian: 'Tersaring keluar',
  Italian: 'Esclusi',
  Japanese: '除外',
  Kannada: 'ಹೊರಗಿಡಲಾಗಿದೆ',
  Kazakh: 'Шеттетілді',
  Korean: '제외됨',
  Latvian: 'Izslēgti',
  Lithuanian: 'Pašalinti',
  Macedonian: 'Исклучени',
  Malay: 'Dikecualikan',
  Maori: 'I tangohia',
  Marathi: 'वगळले',
  Nepali: 'हटाइएका',
  Norwegian: 'Frasortert',
  Panjabi: 'ਬਾਹਰ ਕੱਢੇ ਗਏ',
  Punjabi: 'ਬਾਹਰ ਕੱਢੇ ਗਏ',
  Persian: 'حذف‌شدگان',
  Polish: 'Wykluczeni',
  Portuguese: 'Excluídos',
  Romanian: 'Excluși',
  Russian: 'Отсеяны',
  Serbian: 'Искључени',
  Slovak: 'Vyradení',
  Slovenian: 'Izločeni',
  Spanish: 'Descartados',
  Swahili: 'Wameondolewa',
  Swedish: 'Bortgallrade',
  Tagalog: 'Inalis',
  Tamil: 'விலக்கப்பட்டது',
  Telugu: 'తిరస్కరించబడింది',
  Thai: 'ถูกคัดออก',
  Turkish: 'Elendi',
  Ukrainian: 'Відсіяні',
  Urdu: 'خارج کیے گئے',
  Uzbek: 'Chetlatildi',
  Vietnamese: 'Bị loại',
  Welsh: "Wedi'u hidlo allan",
};

export const translateScreeningAbandoned: Translation = {
  Afrikaans: 'Verlate',
  Amharic: 'ተተዉ',
  Arabic: 'متروك',
  Armenian: 'Թողարկված',
  Azerbaijani: 'Tərk edildi',
  Belarusian: 'Пакінутыя',
  Bengali: 'পরিত্যক্ত',
  Bosnian: 'Napušteno',
  Bulgarian: 'Изоставени',
  Cantonese: '已放棄',
  Catalan: 'Abandonat',
  Chinese: '已放弃',
  'Chinese (Traditional)': '已放棄',
  Croatian: 'Napušteno',
  Czech: 'Opuštěno',
  Danish: 'Forladt',
  Dutch: 'Verlaten',
  English: 'Abandoned',
  Estonian: 'Jäeti pooleli',
  Finnish: 'Hylätty kesken',
  French: 'Abandonné',
  Galician: 'Abandonado',
  Georgian: 'მიტოვებული',
  German: 'Abgebrochen',
  Greek: 'Εγκαταλελειμμένα',
  Hebrew: 'נטוש',
  Hindi: 'छोड़ दिया',
  Hungarian: 'Megszakítva',
  Icelandic: 'Hætt við',
  Indonesian: 'Ditinggalkan',
  Italian: 'Abbandonati',
  Japanese: '中止',
  Kannada: 'ಕೈಬಿಡಲಾಗಿದೆ',
  Kazakh: 'Бас тартылды',
  Korean: '중단됨',
  Latvian: 'Pamests',
  Lithuanian: 'Apleista',
  Macedonian: 'Напуштени',
  Malay: 'Ditinggalkan',
  Maori: 'I whakarerea',
  Marathi: 'सोडले',
  Nepali: 'छाडिएको',
  Norwegian: 'Forlatt',
  Panjabi: 'ਛੱਡ ਦਿੱਤੇ ਗਏ',
  Punjabi: 'ਛੱਡ ਦਿੱਤੇ ਗਏ',
  Persian: 'رهاشده',
  Polish: 'Porzuceni',
  Portuguese: 'Abandonados',
  Romanian: 'Abandonate',
  Russian: 'Прерваны',
  Serbian: 'Напуштени',
  Slovak: 'Opustení',
  Slovenian: 'Opuščeni',
  Spanish: 'Abandonados',
  Swahili: 'Walikataa',
  Swedish: 'Avbrutna',
  Tagalog: 'Inabandona',
  Tamil: 'கைவிடப்பட்டது',
  Telugu: 'వదిలివేయబడింది',
  Thai: 'ละทิ้ง',
  Turkish: 'Terk edildi',
  Ukrainian: 'Покинуті',
  Urdu: 'ترک شدہ',
  Uzbek: 'Tashlandi',
  Vietnamese: 'Đã bỏ',
  Welsh: "Wedi'u gadael",
};

export const translateRespondentsLabel: Translation = {
  Afrikaans: 'Respondente',
  Amharic: 'ምላሽ ሰጪዎች',
  Arabic: 'المستجيبون',
  Armenian: 'Հարցվածներ',
  Azerbaijani: 'Cavabdehlər',
  Belarusian: 'Рэспандэнты',
  Bengali: 'উত্তরদাতারা',
  Bosnian: 'Ispitanici',
  Bulgarian: 'Респонденти',
  Cantonese: '受訪者',
  Catalan: 'Enquestats',
  Chinese: '受访者',
  'Chinese (Traditional)': '受訪者',
  Croatian: 'Ispitanici',
  Czech: 'Respondenti',
  Danish: 'Respondenter',
  Dutch: 'Respondenten',
  English: 'Respondents',
  Estonian: 'Vastajad',
  Finnish: 'Vastaajat',
  French: 'Répondants',
  Galician: 'Enquisados',
  Georgian: 'რესპონდენტები',
  German: 'Befragte',
  Greek: 'Συμμετέχοντες',
  Hebrew: 'משיבים',
  Hindi: 'उत्तरदाता',
  Hungarian: 'Válaszadók',
  Icelandic: 'Svarendur',
  Indonesian: 'Responden',
  Italian: 'Intervistati',
  Japanese: '回答者',
  Kannada: 'ಪ್ರತಿಕ್ರಿಯಿಸಿದವರು',
  Kazakh: 'Респонденттер',
  Korean: '응답자',
  Latvian: 'Respondenti',
  Lithuanian: 'Respondentai',
  Macedonian: 'Испитаници',
  Malay: 'Responden',
  Maori: 'Ngā kaiwhakautu',
  Marathi: 'प्रतिसादकर्ते',
  Nepali: 'उत्तरदाताहरू',
  Norwegian: 'Respondenter',
  Panjabi: 'ਜਵਾਬਦੇਹ',
  Punjabi: 'ਜਵਾਬਦੇਹ',
  Persian: 'پاسخ‌دهندگان',
  Polish: 'Respondenci',
  Portuguese: 'Respondentes',
  Romanian: 'Respondenți',
  Russian: 'Респонденты',
  Serbian: 'Испитаници',
  Slovak: 'Respondenti',
  Slovenian: 'Anketiranci',
  Spanish: 'Encuestados',
  Swahili: 'Waliojibu',
  Swedish: 'Respondenter',
  Tagalog: 'Mga tumugon',
  Tamil: 'பதிலளித்தவர்கள்',
  Telugu: 'పాల్గొనేవారు',
  Thai: 'ผู้ตอบ',
  Turkish: 'Katılımcılar',
  Ukrainian: 'Респонденти',
  Urdu: 'جواب دہندگان',
  Uzbek: 'Respondentlar',
  Vietnamese: 'Người trả lời',
  Welsh: 'Ymatebwyr',
};

// ─────────────────────────────────────────────────────────────────────
// TELV1-360 — three more project-locale labels for the Overview /
// Questions sidebar chrome. TELV1-342 fixed the Screening Insights
// block. These cover the remaining sticky-sidebar pieces:
//   - the SECTIONS heading above the in-page nav
//   - the Sample Profile card's "Show all demographics" / "Show less"
//     collapse toggle (the heading itself reuses the existing
//     `translateSampleProfiles` map — DO NOT add a duplicate)
// Full 65-language coverage matching `translateStatistics` and the
// other canonical maps in this file — Tellet supports 65 analysis
// languages and every chrome label should follow the project locale,
// not silently fall back to English.
// ─────────────────────────────────────────────────────────────────────
export const translateSectionsLabel: Translation = {
  Afrikaans: 'Afdelings',
  Amharic: 'ክፍሎች',
  Arabic: 'الأقسام',
  Armenian: 'Բաժիններ',
  Azerbaijani: 'Bölmələr',
  Belarusian: 'Раздзелы',
  Bengali: 'বিভাগসমূহ',
  Bosnian: 'Sekcije',
  Bulgarian: 'Раздели',
  Cantonese: '章節',
  Catalan: 'Seccions',
  Chinese: '章节',
  'Chinese (Traditional)': '章節',
  Croatian: 'Odjeljci',
  Czech: 'Sekce',
  Danish: 'Sektioner',
  Dutch: 'Secties',
  English: 'Sections',
  Estonian: 'Jaotised',
  Finnish: 'Osiot',
  French: 'Sections',
  Galician: 'Seccións',
  Georgian: 'სექციები',
  German: 'Abschnitte',
  Greek: 'Ενότητες',
  Hebrew: 'סעיפים',
  Hindi: 'अनुभाग',
  Hungarian: 'Szakaszok',
  Icelandic: 'Kaflar',
  Indonesian: 'Bagian',
  Italian: 'Sezioni',
  Japanese: 'セクション',
  Kannada: 'ವಿಭಾಗಗಳು',
  Kazakh: 'Бөлімдер',
  Korean: '섹션',
  Latvian: 'Sadaļas',
  Lithuanian: 'Skiltys',
  Macedonian: 'Секции',
  Malay: 'Bahagian',
  Maori: 'Wāhanga',
  Marathi: 'विभाग',
  Nepali: 'खण्डहरू',
  Norwegian: 'Seksjoner',
  Panjabi: 'ਭਾਗ',
  Punjabi: 'ਭਾਗ',
  Persian: 'بخش‌ها',
  Polish: 'Sekcje',
  Portuguese: 'Seções',
  Romanian: 'Secțiuni',
  Russian: 'Разделы',
  Serbian: 'Секције',
  Slovak: 'Sekcie',
  Slovenian: 'Razdelki',
  Spanish: 'Secciones',
  Swahili: 'Sehemu',
  Swedish: 'Avsnitt',
  Tagalog: 'Mga Seksyon',
  Tamil: 'பிரிவுகள்',
  Telugu: 'విభాగాలు',
  Thai: 'ส่วน',
  Turkish: 'Bölümler',
  Ukrainian: 'Розділи',
  Urdu: 'حصے',
  Uzbek: "Bo'limlar",
  Vietnamese: 'Mục',
  Welsh: 'Adrannau',
};

export const translateShowAllDemographics: Translation = {
  Afrikaans: 'Wys alle demografie',
  Amharic: 'ሁሉንም የሕዝብ ስታቲስቲክስ አሳይ',
  Arabic: 'عرض جميع البيانات الديموغرافية',
  Armenian: 'Ցույց տալ բոլոր ժողովրդագրությունները',
  Azerbaijani: 'Bütün demoqrafiyaları göstər',
  Belarusian: 'Паказаць усе дэмаграфічныя даныя',
  Bengali: 'সমস্ত জনসংখ্যাগত তথ্য দেখান',
  Bosnian: 'Prikaži sve demografije',
  Bulgarian: 'Покажи всички демографски данни',
  Cantonese: '顯示所有人口統計',
  Catalan: 'Mostra totes les dades demogràfiques',
  Chinese: '显示所有人口统计',
  'Chinese (Traditional)': '顯示所有人口統計',
  Croatian: 'Prikaži sve demografije',
  Czech: 'Zobrazit všechny demografie',
  Danish: 'Vis alle demografier',
  Dutch: 'Toon alle demografieën',
  English: 'Show all demographics',
  Estonian: 'Näita kõiki demograafilisi andmeid',
  Finnish: 'Näytä kaikki demografiat',
  French: 'Afficher toutes les démographies',
  Galician: 'Mostrar todas as demografías',
  Georgian: 'ყველა დემოგრაფიის ჩვენება',
  German: 'Alle Demografien anzeigen',
  Greek: 'Εμφάνιση όλων των δημογραφικών',
  Hebrew: 'הצג את כל הדמוגרפיה',
  Hindi: 'सभी जनसांख्यिकी दिखाएं',
  Hungarian: 'Összes demográfia mutatása',
  Icelandic: 'Sýna alla lýðfræði',
  Indonesian: 'Tampilkan semua demografi',
  Italian: 'Mostra tutti i dati demografici',
  Japanese: 'すべての人口統計を表示',
  Kannada: 'ಎಲ್ಲಾ ಜನಸಂಖ್ಯಾಶಾಸ್ತ್ರವನ್ನು ತೋರಿಸಿ',
  Kazakh: 'Барлық демографияны көрсету',
  Korean: '모든 인구 통계 표시',
  Latvian: 'Rādīt visu demogrāfiju',
  Lithuanian: 'Rodyti visą demografiją',
  Macedonian: 'Прикажи ги сите демографии',
  Malay: 'Tunjukkan semua demografi',
  Maori: 'Whakaatu i ngā taupori katoa',
  Marathi: 'सर्व लोकसंख्या दर्शवा',
  Nepali: 'सबै जनसांख्यिकी देखाउनुहोस्',
  Norwegian: 'Vis all demografi',
  Panjabi: 'ਸਾਰੀ ਜਨਸੰਖਿਆ ਦਿਖਾਓ',
  Punjabi: 'ਸਾਰੀ ਜਨਸੰਖਿਆ ਦਿਖਾਓ',
  Persian: 'نمایش همه جمعیت‌شناسی‌ها',
  Polish: 'Pokaż wszystkie dane demograficzne',
  Portuguese: 'Mostrar todos os dados demográficos',
  Romanian: 'Afișează toate datele demografice',
  Russian: 'Показать всю демографию',
  Serbian: 'Прикажи све демографије',
  Slovak: 'Zobraziť všetky demografie',
  Slovenian: 'Prikaži vse demografije',
  Spanish: 'Mostrar todos los datos demográficos',
  Swahili: 'Onyesha demografia zote',
  Swedish: 'Visa all demografi',
  Tagalog: 'Ipakita lahat ng demograpiko',
  Tamil: 'அனைத்து மக்கள்தொகை விவரங்களையும் காட்டு',
  Telugu: 'అన్ని జనాభా వివరాలను చూపించు',
  Thai: 'แสดงข้อมูลประชากรทั้งหมด',
  Turkish: 'Tüm demografiyi göster',
  Ukrainian: 'Показати всю демографію',
  Urdu: 'تمام آبادیات دکھائیں',
  Uzbek: "Barcha demografiyani ko'rsatish",
  Vietnamese: 'Hiển thị tất cả nhân khẩu học',
  Welsh: 'Dangos pob demograffeg',
};

export const translateShowLess: Translation = {
  Afrikaans: 'Wys minder',
  Amharic: 'ጥቂት አሳይ',
  Arabic: 'عرض أقل',
  Armenian: 'Ցույց տալ ավելի քիչ',
  Azerbaijani: 'Daha az göstər',
  Belarusian: 'Паказаць менш',
  Bengali: 'কম দেখান',
  Bosnian: 'Prikaži manje',
  Bulgarian: 'Покажи по-малко',
  Cantonese: '顯示較少',
  Catalan: "Mostra'n menys",
  Chinese: '显示更少',
  'Chinese (Traditional)': '顯示較少',
  Croatian: 'Prikaži manje',
  Czech: 'Zobrazit méně',
  Danish: 'Vis mindre',
  Dutch: 'Toon minder',
  English: 'Show less',
  Estonian: 'Näita vähem',
  Finnish: 'Näytä vähemmän',
  French: 'Afficher moins',
  Galician: 'Mostrar menos',
  Georgian: 'ნაკლების ჩვენება',
  German: 'Weniger anzeigen',
  Greek: 'Εμφάνιση λιγότερων',
  Hebrew: 'הצג פחות',
  Hindi: 'कम दिखाएं',
  Hungarian: 'Kevesebb mutatása',
  Icelandic: 'Sýna minna',
  Indonesian: 'Tampilkan lebih sedikit',
  Italian: 'Mostra meno',
  Japanese: '少なく表示',
  Kannada: 'ಕಡಿಮೆ ತೋರಿಸಿ',
  Kazakh: 'Азырақ көрсету',
  Korean: '적게 표시',
  Latvian: 'Rādīt mazāk',
  Lithuanian: 'Rodyti mažiau',
  Macedonian: 'Прикажи помалку',
  Malay: 'Tunjukkan kurang',
  Maori: 'Whakaatu iti iho',
  Marathi: 'कमी दर्शवा',
  Nepali: 'कम देखाउनुहोस्',
  Norwegian: 'Vis mindre',
  Panjabi: 'ਘੱਟ ਦਿਖਾਓ',
  Punjabi: 'ਘੱਟ ਦਿਖਾਓ',
  Persian: 'کمتر نشان بده',
  Polish: 'Pokaż mniej',
  Portuguese: 'Mostrar menos',
  Romanian: 'Afișează mai puțin',
  Russian: 'Показать меньше',
  Serbian: 'Прикажи мање',
  Slovak: 'Zobraziť menej',
  Slovenian: 'Prikaži manj',
  Spanish: 'Mostrar menos',
  Swahili: 'Onyesha kidogo',
  Swedish: 'Visa mindre',
  Tagalog: 'Magpakita ng mas kaunti',
  Tamil: 'குறைவாகக் காட்டு',
  Telugu: 'తక్కువ చూపించు',
  Thai: 'แสดงน้อยลง',
  Turkish: 'Daha az göster',
  Ukrainian: 'Показати менше',
  Urdu: 'کم دکھائیں',
  Uzbek: "Kamroq ko'rsatish",
  Vietnamese: 'Hiển thị ít hơn',
  Welsh: 'Dangos llai',
};

/**
 * Resolves a comparison metric_key to its localized label. Falls back to
 * the metric_key itself when an unknown key is supplied — callers should
 * also pass the legacy `metric` field as a final fallback so older
 * comparison documents persisted before metric_key existed still render.
 */
export function translateComparisonMetricKey(metricKey: string, language: string): string | null {
  const lookup: Record<string, Translation> = {
    completed_interviews: translateCompletedInterviews,
    completion_rate_pct: translateCompletionRate,
    average_time_min: translateAverageTime,
    median_time_min: translateMedianTime,
    started_interviews: translateStartedInterviews,
    screening_pass_rate_pct: translateScreeningPassRate,
  };
  const table = lookup[metricKey];
  if (!table) return null;
  return table[language] ?? table.English ?? null;
}

// ─────────────────────────────────────────────────────────────────────
// TELV1-433 — Overview "Data quality" widget labels. Category words are
// DELIBERATE duplicates of the viewer-locale msg.qualityExcellent/Good/Low
// keys used by QualityBadge elsewhere: Overview chrome follows the
// project's analysis language (resolveTranslation), not the viewer's
// account locale — reusing lang.get here would reproduce the
// mixed-language-in-one-card bug TELV1-342 fixed for screening.
// ─────────────────────────────────────────────────────────────────────
export const translateDataQuality: Translation = {
  Afrikaans: 'Datakwaliteit',
  Amharic: 'የመረጃ ጥራት',
  Arabic: 'جودة البيانات',
  Armenian: 'Տվյալների որակ',
  Azerbaijani: 'Məlumat keyfiyyəti',
  Belarusian: 'Якасць даных',
  Bengali: 'ডেটার মান',
  Bosnian: 'Kvalitet podataka',
  Bulgarian: 'Качество на данните',
  Cantonese: '數據質素',
  Catalan: 'Qualitat de les dades',
  Chinese: '数据质量',
  'Chinese (Traditional)': '數據品質',
  Croatian: 'Kvaliteta podataka',
  Czech: 'Kvalita dat',
  Danish: 'Datakvalitet',
  Dutch: 'Datakwaliteit',
  English: 'Data quality',
  Estonian: 'Andmete kvaliteet',
  Finnish: 'Datan laatu',
  French: 'Qualité des données',
  Galician: 'Calidade dos datos',
  Georgian: 'მონაცემების ხარისხი',
  German: 'Datenqualität',
  Greek: 'Ποιότητα δεδομένων',
  Hebrew: 'איכות הנתונים',
  Hindi: 'डेटा गुणवत्ता',
  Hungarian: 'Adatminőség',
  Icelandic: 'Gagnagæði',
  Indonesian: 'Kualitas data',
  Italian: 'Qualità dei dati',
  Japanese: 'データ品質',
  Kannada: 'ಡೇಟಾ ಗುಣಮಟ್ಟ',
  Kazakh: 'Деректер сапасы',
  Korean: '데이터 품질',
  Latvian: 'Datu kvalitāte',
  Lithuanian: 'Duomenų kokybė',
  Macedonian: 'Квалитет на податоците',
  Malay: 'Kualiti data',
  Maori: 'Kounga raraunga',
  Marathi: 'डेटा गुणवत्ता',
  Nepali: 'डेटा गुणस्तर',
  Norwegian: 'Datakvalitet',
  Panjabi: 'ਡਾਟਾ ਗੁਣਵੱਤਾ',
  Punjabi: 'ਡਾਟਾ ਗੁਣਵੱਤਾ',
  Persian: 'کیفیت داده‌ها',
  Polish: 'Jakość danych',
  Portuguese: 'Qualidade dos dados',
  Romanian: 'Calitatea datelor',
  Russian: 'Качество данных',
  Serbian: 'Квалитет података',
  Slovak: 'Kvalita dát',
  Slovenian: 'Kakovost podatkov',
  Spanish: 'Calidad de los datos',
  Swahili: 'Ubora wa data',
  Swedish: 'Datakvalitet',
  Tagalog: 'Kalidad ng datos',
  Tamil: 'தரவுத் தரம்',
  Telugu: 'డేటా నాణ్యత',
  Thai: 'คุณภาพข้อมูล',
  Turkish: 'Veri kalitesi',
  Ukrainian: 'Якість даних',
  Urdu: 'ڈیٹا کا معیار',
  Uzbek: "Ma'lumotlar sifati",
  Vietnamese: 'Chất lượng dữ liệu',
  Welsh: 'Ansawdd data',
};

export const translateQualityExcellent: Translation = {
  Afrikaans: 'Uitstekend',
  Amharic: 'እጅግ በጣም ጥሩ',
  Arabic: 'ممتاز',
  Armenian: 'Գերազանց',
  Azerbaijani: 'Əla',
  Belarusian: 'Выдатна',
  Bengali: 'চমৎকার',
  Bosnian: 'Odlično',
  Bulgarian: 'Отлично',
  Cantonese: '優秀',
  Catalan: 'Excel·lent',
  Chinese: '优秀',
  'Chinese (Traditional)': '優秀',
  Croatian: 'Izvrsno',
  Czech: 'Vynikající',
  Danish: 'Fremragende',
  Dutch: 'Uitstekend',
  English: 'Excellent',
  Estonian: 'Suurepärane',
  Finnish: 'Erinomainen',
  French: 'Excellent',
  Galician: 'Excelente',
  Georgian: 'შესანიშნავი',
  German: 'Hervorragend',
  Greek: 'Εξαιρετική',
  Hebrew: 'מצוין',
  Hindi: 'उत्कृष्ट',
  Hungarian: 'Kiváló',
  Icelandic: 'Framúrskarandi',
  Indonesian: 'Sangat baik',
  Italian: 'Eccellente',
  Japanese: '優秀',
  Kannada: 'ಅತ್ಯುತ್ತಮ',
  Kazakh: 'Өте жақсы',
  Korean: '우수',
  Latvian: 'Izcili',
  Lithuanian: 'Puiku',
  Macedonian: 'Одлично',
  Malay: 'Cemerlang',
  Maori: 'Rawe',
  Marathi: 'उत्कृष्ट',
  Nepali: 'उत्कृष्ट',
  Norwegian: 'Utmerket',
  Panjabi: 'ਸ਼ਾਨਦਾਰ',
  Punjabi: 'ਸ਼ਾਨਦਾਰ',
  Persian: 'عالی',
  Polish: 'Doskonała',
  Portuguese: 'Excelente',
  Romanian: 'Excelentă',
  Russian: 'Отлично',
  Serbian: 'Одлично',
  Slovak: 'Vynikajúca',
  Slovenian: 'Odlično',
  Spanish: 'Excelente',
  Swahili: 'Bora sana',
  Swedish: 'Utmärkt',
  Tagalog: 'Napakahusay',
  Tamil: 'மிகச்சிறந்தது',
  Telugu: 'అత్యుత్తమం',
  Thai: 'ยอดเยี่ยม',
  Turkish: 'Mükemmel',
  Ukrainian: 'Відмінно',
  Urdu: 'بہترین',
  Uzbek: "A'lo",
  Vietnamese: 'Xuất sắc',
  Welsh: 'Rhagorol',
};

export const translateQualityGood: Translation = {
  Afrikaans: 'Goed',
  Amharic: 'ጥሩ',
  Arabic: 'جيد',
  Armenian: 'Լավ',
  Azerbaijani: 'Yaxşı',
  Belarusian: 'Добра',
  Bengali: 'ভালো',
  Bosnian: 'Dobro',
  Bulgarian: 'Добро',
  Cantonese: '良好',
  Catalan: 'Bona',
  Chinese: '良好',
  'Chinese (Traditional)': '良好',
  Croatian: 'Dobro',
  Czech: 'Dobrá',
  Danish: 'God',
  Dutch: 'Goed',
  English: 'Good',
  Estonian: 'Hea',
  Finnish: 'Hyvä',
  French: 'Bon',
  Galician: 'Boa',
  Georgian: 'კარგი',
  German: 'Gut',
  Greek: 'Καλή',
  Hebrew: 'טוב',
  Hindi: 'अच्छा',
  Hungarian: 'Jó',
  Icelandic: 'Gott',
  Indonesian: 'Baik',
  Italian: 'Buona',
  Japanese: '良好',
  Kannada: 'ಉತ್ತಮ',
  Kazakh: 'Жақсы',
  Korean: '양호',
  Latvian: 'Labi',
  Lithuanian: 'Gerai',
  Macedonian: 'Добро',
  Malay: 'Baik',
  Maori: 'Pai',
  Marathi: 'चांगले',
  Nepali: 'राम्रो',
  Norwegian: 'God',
  Panjabi: 'ਚੰਗਾ',
  Punjabi: 'ਚੰਗਾ',
  Persian: 'خوب',
  Polish: 'Dobra',
  Portuguese: 'Boa',
  Romanian: 'Bună',
  Russian: 'Хорошо',
  Serbian: 'Добро',
  Slovak: 'Dobrá',
  Slovenian: 'Dobro',
  Spanish: 'Buena',
  Swahili: 'Nzuri',
  Swedish: 'God',
  Tagalog: 'Mabuti',
  Tamil: 'நல்லது',
  Telugu: 'మంచిది',
  Thai: 'ดี',
  Turkish: 'İyi',
  Ukrainian: 'Добре',
  Urdu: 'اچھا',
  Uzbek: 'Yaxshi',
  Vietnamese: 'Tốt',
  Welsh: 'Da',
};

export const translateQualityLow: Translation = {
  Afrikaans: 'Laag',
  Amharic: 'ዝቅተኛ',
  Arabic: 'منخفض',
  Armenian: 'Ցածր',
  Azerbaijani: 'Aşağı',
  Belarusian: 'Нізкая',
  Bengali: 'নিম্ন',
  Bosnian: 'Nisko',
  Bulgarian: 'Ниско',
  Cantonese: '低',
  Catalan: 'Baixa',
  Chinese: '低',
  'Chinese (Traditional)': '低',
  Croatian: 'Nisko',
  Czech: 'Nízká',
  Danish: 'Lav',
  Dutch: 'Laag',
  English: 'Low',
  Estonian: 'Madal',
  Finnish: 'Matala',
  French: 'Faible',
  Galician: 'Baixa',
  Georgian: 'დაბალი',
  German: 'Niedrig',
  Greek: 'Χαμηλή',
  Hebrew: 'נמוך',
  Hindi: 'निम्न',
  Hungarian: 'Alacsony',
  Icelandic: 'Lágt',
  Indonesian: 'Rendah',
  Italian: 'Bassa',
  Japanese: '低い',
  Kannada: 'ಕಡಿಮೆ',
  Kazakh: 'Төмен',
  Korean: '낮음',
  Latvian: 'Zema',
  Lithuanian: 'Žema',
  Macedonian: 'Ниско',
  Malay: 'Rendah',
  Maori: 'Iti',
  Marathi: 'कमी',
  Nepali: 'न्यून',
  Norwegian: 'Lav',
  Panjabi: 'ਘੱਟ',
  Punjabi: 'ਘੱਟ',
  Persian: 'پایین',
  Polish: 'Niska',
  Portuguese: 'Baixa',
  Romanian: 'Scăzută',
  Russian: 'Низкое',
  Serbian: 'Ниско',
  Slovak: 'Nízka',
  Slovenian: 'Nizko',
  Spanish: 'Baja',
  Swahili: 'Chini',
  Swedish: 'Låg',
  Tagalog: 'Mababa',
  Tamil: 'குறைவு',
  Telugu: 'తక్కువ',
  Thai: 'ต่ำ',
  Turkish: 'Düşük',
  Ukrainian: 'Низька',
  Urdu: 'کم',
  Uzbek: 'Past',
  Vietnamese: 'Thấp',
  Welsh: 'Isel',
};
